"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function () {
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef;
  // The pk helpers are the engine's own (window.__pkInternals), never a reimplementation,
  // so the Active Drugs panel always agrees with the physiology.
  var PKI = window.__pkInternals || {};
  var PREDEFINED_FINDINGS = {
    'CT': ['Normal Head CT', 'Large Subdural Haematoma with midline shift', 'Epidural Haematoma', 'Subarachnoid Haemorrhage (Fisher Grade 3)', 'Large MCA Territory Infarct', 'Dense MCA Sign', 'Intraparenchymal Haemorrhage', 'Basal Skull Fracture', 'C-Spine: No acute fracture', 'CTPA: Large saddle embolus', 'CTPA: Segmental PE', 'CT Abdo: Free gas (perforation)', 'CT Abdo: Ruptured AAA', 'CT Abdo: Acute appendicitis'],
    'X-ray': ['Normal CXR', 'Large right-sided pneumothorax', 'Tension pneumothorax (tracheal deviation)', 'Left lower lobe consolidation', 'Right upper lobe consolidation', 'Bilateral diffuse infiltrates (Pulmonary Oedema)', 'Widened mediastinum', 'Right neck of femur fracture', 'Pelvic ring fracture (open book)', 'Distal radius fracture'],
    'ECG': ['Normal Sinus Rhythm', 'Anterior STEMI (V1-V4 ST elevation)', 'Inferior STEMI (II, III, aVF ST elevation)', 'Lateral STEMI (I, aVL, V5-V6)', 'Atrial Fibrillation (Rapid Ventricular Response)', 'SVT (Narrow complex tachycardia)', 'Complete Heart Block (3rd Degree)', '1st Degree AV Block', 'LBBB (New onset)', 'RBBB', 'Prolonged QT interval', 'Peaked T waves (Hyperkalaemia)', 'VT (Broad complex tachycardia)'],
    'VBG': ['Normal (pH 7.4, pCO2 5.0, Lactate 1.0)', 'Severe Metabolic Acidosis (pH 7.1, Lac 8.0, HCO3 12)', 'Respiratory Acidosis (pH 7.2, pCO2 9.0)', 'Hyperkalaemia (K+ 7.2)', 'Severe DKA (pH 7.0, Glu >30, Ketones 6.0)', 'Sepsis pattern (Lac 5.5, BE -8)'],
    'Urine': ['Normal', 'Leucocytes +++, Nitrites +, Blood + (UTI)', 'Blood +++ (Haematuria)', 'Ketones +++, Glucose +++ (DKA)', 'Protein +++ (Pre-eclampsia/Renal)', 'B-hCG Positive (Pregnancy)'],
    'POCUS': ['Normal / No free fluid', 'FAST: Free fluid in Morison\'s pouch', 'FAST: Free fluid in Splenorenal recess', 'FAST: Pelvic free fluid', 'ECHO: Large Pericardial Effusion / Tamponade', 'ECHO: Poor LV function', 'ECHO: Dilated Right Ventricle', 'LUNG: Absent lung sliding (Pneumothorax)', 'LUNG: B-lines bilaterally (Pulmonary Oedema)', 'AORTA: AAA > 5.5cm']
  };
  var DRUG_CALC_LIST = [
  // RCUK doses IM adrenaline by AGE, not weight: < 6 months 100-150 mcg, 6 months-6 years 150 mcg,
  // 6-12 years 300 mcg, > 12 years and adults 500 mcg.
  {
    name: 'Adrenaline IM (Anaphylaxis)',
    byAge: function byAge(age) {
      return age === null || age > 12 ? 0.5 : age > 6 ? 0.3 : 0.15;
    },
    display: function display(age) {
      return age !== null && age < 0.5 ? '0.1-0.15' : null;
    },
    unit: 'mg',
    max: 0.5,
    info: '1 mg/ml IM. RCUK dose by age, not weight'
  }, {
    name: 'Adrenaline IV (Arrest)',
    perKg: 0.01,
    unit: 'mg',
    max: 1,
    info: '1:10 000 (0.1 mg/ml) IV/IO, 10 mcg/kg'
  }, {
    name: 'Lorazepam (Seizure)',
    perKg: 0.1,
    unit: 'mg',
    max: 4,
    info: '4 mg/ml IV/IO'
  }, {
    name: 'Midazolam Buccal (Seizure)',
    perKg: 0.3,
    unit: 'mg',
    max: 10,
    info: 'Buccal 0.3 mg/kg (RCUK; BNFc gives age-banded doses)'
  }, {
    name: 'Morphine IV',
    perKg: 0.1,
    unit: 'mg',
    max: 10,
    info: '10 mg/ml IV slow'
  }, {
    name: 'Ketamine (RSI/Anaesthesia)',
    perKg: 1.5,
    unit: 'mg',
    max: 200,
    info: '50 mg/ml IV'
  }, {
    name: 'Rocuronium (RSI)',
    perKg: 1.2,
    unit: 'mg',
    max: 200,
    info: '10 mg/ml IV'
  }, {
    name: 'Suxamethonium (RSI)',
    perKg: 2,
    unit: 'mg',
    max: 200,
    info: '50 mg/ml IV'
  }, {
    name: 'Amiodarone (Arrest)',
    perKg: 5,
    unit: 'mg',
    max: 300,
    info: 'After 3rd shock (max 300 mg); child: repeat once after 5th shock, max 150 mg'
  }, {
    name: 'Atropine (Bradycardia)',
    perKg: 0.02,
    unit: 'mg',
    maxByAge: function maxByAge(age) {
      return age !== null && age >= 12 && age < 18 ? 0.6 : 0.5;
    },
    info: 'IV/IO 20 mcg/kg. Max 0.5 mg up to 11 y; 0.3-0.6 mg at 12-17 y; adult 0.5 mg (3 mg total)'
  }, {
    name: 'Paracetamol IV',
    perKg: 15,
    unit: 'mg',
    max: 1000,
    info: '10 mg/ml IV'
  }, {
    name: 'Glucose 10% (child)',
    perKg: 2,
    unit: 'ml',
    max: 50,
    info: 'IV/IO 2 ml/kg for known hypoglycaemia (RCUK chart max 50 ml)'
  }, {
    name: 'Sodium Bicarb 8.4%',
    perKg: 1,
    unit: 'mmol',
    max: 50,
    info: '1 mmol/ml IV slow'
  }, {
    name: 'TXA (Trauma Haemorrhage)',
    perKg: 15,
    unit: 'mg',
    max: 1000,
    info: '100 mg/ml IV slow over 10 min'
  }, {
    name: 'Ceftriaxone (Sepsis)',
    perKg: 50,
    unit: 'mg',
    max: 2000,
    info: '250 mg/ml IV'
  }, {
    name: 'IV Fluid Bolus',
    perKg: 10,
    unit: 'ml',
    max: 500,
    info: "NS or Hartmann's IV"
  }, {
    name: 'MgSO4 (Asthma)',
    perKg: 40,
    unit: 'mg',
    max: 2000,
    info: 'IV over 20 min. Torsades: 25-50 mg/kg (max 2 g) over 10-15 min'
  }, {
    name: 'Calcium Gluconate 10%',
    perKg: 0.5,
    unit: 'ml',
    max: 30,
    info: 'Hyperkalaemic arrhythmia: IV over 5-10 min (RCUK)'
  }];

  // "Not started" is a state of its own (every launch mode waits for START), so it is said in
  // words next to START rather than left to a 00:00 clock.
  var NotStartedBadge = function NotStartedBadge(_ref) {
    var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$long = _ref["long"],
      _long = _ref$long === void 0 ? false : _ref$long;
    return /*#__PURE__*/React.createElement("span", {
      "data-testid": "not-started",
      role: "status",
      title: "Setting up: the patient is not live yet. The patient screens stay blank and there are no trends, deterioration or drug effects until you press START. Anything you set or give now is recorded and starts acting at START.",
      className: "h-8 px-2 inline-flex items-center justify-center gap-1 rounded border border-amber-400 bg-amber-950/70 text-amber-200 text-[11px] font-bold uppercase tracking-wider whitespace-nowrap ".concat(className)
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-2 h-2 rounded-full bg-amber-400 animate-pulse",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("span", null, "Set-up: not running", /*#__PURE__*/React.createElement("span", {
      className: _long ? '' : 'hidden xl:inline'
    }, " \xB7 press START")));
  };

  // =============================================================================================
  // USER-RESIZABLE MONITOR / OBS PANEL ON THE CONTROLLER
  //
  // Requested verbatim: "I want to be able to expand or shrink the size of the monitor / obs
  // section on the controller screen please. Ideally by clicking and dragging with my mouse."
  //
  // Two drags, both persisted to localStorage and both bounded so the panel can never be made
  // unusable or squash the rhythm selector / event log out of reach:
  //   * a VERTICAL grip on the panel's right edge  -> panel WIDTH   (md+ only; below md the layout
  //     is a single stacked column and a width drag is meaningless, so the handle is not rendered)
  //   * a HORIZONTAL grip under the waveform card  -> STRIP HEIGHT (all widths)
  // Pointer events cover mouse, pen and touch with one code path. Both handles are focusable
  // `separator`s with arrow-key / Home / End support, so the feature is keyboard-accessible.
  // =============================================================================================
  var PANEL_STORE_KEY = 'wmebem.controllerPanel.v1';
  // The strip defaults SHORT (120 px): on a 1366x768 laptop the old 256 px preview pushed the obs
  // tiles, ARREST, Defib and CPR below the fold. The team's real monitor is the room screen; this
  // is a preview, and the grip makes it as tall as anyone wants.
  var PANEL_DEFAULTS = {
    width: null,
    stripHeight: 120
  }; // width null = the classic ~34% column
  var PANEL_BOUNDS = {
    minWidth: 280,
    minRight: 380,
    maxFraction: 0.72,
    minStrip: 96,
    maxStrip: 560
  };
  var readPanelPrefs = function readPanelPrefs() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(PANEL_STORE_KEY);
      if (!raw) return _objectSpread({}, PANEL_DEFAULTS);
      var p = JSON.parse(raw);
      return {
        width: Number.isFinite(Number(p.width)) && Number(p.width) > 0 ? Number(p.width) : null,
        stripHeight: Number.isFinite(Number(p.stripHeight)) ? Number(p.stripHeight) : PANEL_DEFAULTS.stripHeight
      };
    } catch (e) {
      return _objectSpread({}, PANEL_DEFAULTS);
    }
  };
  var writePanelPrefs = function writePanelPrefs(p) {
    try {
      if (window.localStorage) window.localStorage.setItem(PANEL_STORE_KEY, JSON.stringify(p));
    } catch (e) {/* private mode: size simply does not persist */}
  };
  var clampPanelWidth = function clampPanelWidth(px, containerWidth) {
    var cw = containerWidth > 0 ? containerWidth : window.innerWidth || 1280;
    var max = Math.max(PANEL_BOUNDS.minWidth, Math.min(cw * PANEL_BOUNDS.maxFraction, cw - PANEL_BOUNDS.minRight));
    return Math.round(Math.max(PANEL_BOUNDS.minWidth, Math.min(max, px)));
  };
  var clampStripHeight = function clampStripHeight(px) {
    return Math.round(Math.max(PANEL_BOUNDS.minStrip, Math.min(PANEL_BOUNDS.maxStrip, px)));
  };
  // Exported as a test handle, so a test can exercise the SHIPPING bounds arithmetic.
  window.__controllerPanel = {
    PANEL_STORE_KEY: PANEL_STORE_KEY,
    PANEL_DEFAULTS: PANEL_DEFAULTS,
    PANEL_BOUNDS: PANEL_BOUNDS,
    readPanelPrefs: readPanelPrefs,
    writePanelPrefs: writePanelPrefs,
    clampPanelWidth: clampPanelWidth,
    clampStripHeight: clampStripHeight
  };
  var useResizablePanel = function useResizablePanel() {
    var _useState = useState(readPanelPrefs),
      _useState2 = _slicedToArray(_useState, 2),
      prefs = _useState2[0],
      setPrefs = _useState2[1];
    var rowRef = useRef(null);
    var _useState3 = useState(function () {
        try {
          return !!(window.matchMedia && window.matchMedia('(min-width: 768px)').matches);
        } catch (e) {
          return true;
        }
      }),
      _useState4 = _slicedToArray(_useState3, 2),
      isWide = _useState4[0],
      setIsWide = _useState4[1];
    useEffect(function () {
      var onResize = function onResize() {
        var wide = true;
        try {
          wide = !!(window.matchMedia && window.matchMedia('(min-width: 768px)').matches);
        } catch (e) {
          wide = true;
        }
        setIsWide(wide);
        // Re-clamp against the new container so a saved width can never overflow a smaller
        // window (which is what would reintroduce horizontal scrolling).
        setPrefs(function (p) {
          return p.width === null ? p : _objectSpread(_objectSpread({}, p), {}, {
            width: clampPanelWidth(p.width, rowRef.current ? rowRef.current.clientWidth : 0)
          });
        });
      };
      window.addEventListener('resize', onResize);
      return function () {
        return window.removeEventListener('resize', onResize);
      };
    }, []);
    var commit = function commit(next) {
      setPrefs(next);
      writePanelPrefs(next);
    };

    // One pointer-driven drag for both axes.
    var beginDrag = function beginDrag(axis) {
      return function (e) {
        if (axis === 'x' && !isWide) return;
        var row = rowRef.current;
        var containerWidth = row ? row.clientWidth : 0;
        var startX = e.clientX,
          startY = e.clientY;
        var startWidth = prefs.width !== null ? prefs.width : row ? Math.round(row.clientWidth * 0.34) : 420;
        var startStrip = prefs.stripHeight;
        var target = e.currentTarget;
        try {
          if (target && target.setPointerCapture && e.pointerId !== undefined) target.setPointerCapture(e.pointerId);
        } catch (err) {/* no capture: move events still arrive on window */}
        if (e.preventDefault) e.preventDefault();
        var latest = _objectSpread({}, prefs);
        var onMove = function onMove(ev) {
          if (axis === 'x') latest = _objectSpread(_objectSpread({}, latest), {}, {
            width: clampPanelWidth(startWidth + (ev.clientX - startX), containerWidth)
          });else latest = _objectSpread(_objectSpread({}, latest), {}, {
            stripHeight: clampStripHeight(startStrip + (ev.clientY - startY))
          });
          setPrefs(latest);
        };
        var _onUp = function onUp() {
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', _onUp);
          window.removeEventListener('pointercancel', _onUp);
          commit(latest);
        };
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', _onUp);
        window.addEventListener('pointercancel', _onUp);
      };
    };
    var nudge = function nudge(axis, delta) {
      var row = rowRef.current;
      if (axis === 'x') {
        var base = prefs.width !== null ? prefs.width : row ? Math.round(row.clientWidth * 0.34) : 420;
        commit(_objectSpread(_objectSpread({}, prefs), {}, {
          width: clampPanelWidth(base + delta, row ? row.clientWidth : 0)
        }));
      } else {
        commit(_objectSpread(_objectSpread({}, prefs), {}, {
          stripHeight: clampStripHeight(prefs.stripHeight + delta)
        }));
      }
    };
    var reset = function reset() {
      return commit(_objectSpread({}, PANEL_DEFAULTS));
    };
    var panelStyle = isWide && prefs.width !== null ? {
      width: clampPanelWidth(prefs.width, rowRef.current ? rowRef.current.clientWidth : 0) + 'px',
      flex: '0 0 auto'
    } : undefined;
    return {
      prefs: prefs,
      isWide: isWide,
      rowRef: rowRef,
      beginDrag: beginDrag,
      nudge: nudge,
      reset: reset,
      panelStyle: panelStyle,
      isCustom: prefs.width !== null || prefs.stripHeight !== PANEL_DEFAULTS.stripHeight
    };
  };

  // The grip itself: a wide, obvious, grabbable bar with the right cursor, a tooltip, and
  // keyboard support. Deliberately 10 px of hit area with a visible 3-dot grip so it is
  // discoverable without being told it exists.
  var ResizeGrip = function ResizeGrip(_ref2) {
    var axis = _ref2.axis,
      onPointerDown = _ref2.onPointerDown,
      onNudge = _ref2.onNudge,
      onReset = _ref2.onReset,
      value = _ref2.value,
      min = _ref2.min,
      max = _ref2.max;
    return /*#__PURE__*/React.createElement("div", {
      role: "separator",
      "aria-orientation": axis === 'x' ? 'vertical' : 'horizontal',
      "aria-label": axis === 'x' ? 'Resize the monitor and obs panel width (drag, or use the arrow keys)' : 'Resize the waveform strip height (drag, or use the arrow keys)',
      "aria-valuenow": Math.round(value),
      "aria-valuemin": min,
      "aria-valuemax": max,
      tabIndex: 0,
      title: axis === 'x' ? 'Drag to resize the monitor / obs panel — double-click to reset' : 'Drag to resize the waveform strip — double-click to reset',
      onPointerDown: onPointerDown,
      onDoubleClick: onReset,
      onKeyDown: function onKeyDown(e) {
        var step = e.shiftKey ? 64 : 16;
        if (axis === 'x' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
          e.preventDefault();
          onNudge(e.key === 'ArrowLeft' ? -step : step);
        }
        if (axis === 'y' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
          e.preventDefault();
          onNudge(e.key === 'ArrowUp' ? -step : step);
        }
        if (e.key === 'Home' || e.key === 'Escape') {
          e.preventDefault();
          onReset();
        }
      },
      style: {
        touchAction: 'none'
      },
      className: axis === 'x' ? 'hidden md:flex flex-none w-2.5 self-stretch items-center justify-center cursor-col-resize group bg-slate-800 hover:bg-sky-700 focus:bg-sky-600 focus:outline-none focus:ring-1 focus:ring-sky-400 rounded' : 'flex h-2.5 w-full items-center justify-center cursor-row-resize group bg-slate-800 hover:bg-sky-700 focus:bg-sky-600 focus:outline-none focus:ring-1 focus:ring-sky-400 rounded'
    }, /*#__PURE__*/React.createElement("span", {
      className: axis === 'x' ? 'flex flex-col gap-0.5' : 'flex gap-0.5',
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("span", {
      className: "block w-1 h-1 rounded-full bg-slate-500 group-hover:bg-white"
    }), /*#__PURE__*/React.createElement("span", {
      className: "block w-1 h-1 rounded-full bg-slate-500 group-hover:bg-white"
    }), /*#__PURE__*/React.createElement("span", {
      className: "block w-1 h-1 rounded-full bg-slate-500 group-hover:bg-white"
    })));
  };
  var LiveSimScreen = function LiveSimScreen(_ref3) {
    var _scenario$wetflag, _scenario$patientAge, _scenario$wetflag2, _scenario$wetflag3, _scenario$wetflag4, _state$monitorTimer, _state$monitorTimer2, _state$monitorTimer3, _state$monitorTimer5, _defib$lastEnergy, _scenario$wetflag5;
    var sim = _ref3.sim,
      onFinish = _ref3.onFinish,
      onBack = _ref3.onBack,
      sessionID = _ref3.sessionID;
    var _window = window,
      INTERVENTIONS = _window.INTERVENTIONS,
      Button = _window.Button,
      Lucide = _window.Lucide,
      Card = _window.Card,
      VitalDisplay = _window.VitalDisplay,
      ECGMonitor = _window.ECGMonitor,
      HumanFactorBadge = _window.HumanFactorBadge,
      formatProfileTemplate = _window.formatProfileTemplate,
      Modal = _window.Modal,
      Section = _window.Section,
      MenuButton = _window.MenuButton,
      ViewModeToggle = _window.ViewModeToggle;
    var state = sim.state,
      start = sim.start,
      pause = sim.pause,
      applyIntervention = sim.applyIntervention,
      addLogEntry = sim.addLogEntry,
      manualUpdateVital = sim.manualUpdateVital,
      triggerArrest = sim.triggerArrest,
      triggerROSC = sim.triggerROSC,
      startTrend = sim.startTrend,
      speak = sim.speak,
      revealInvestigation = sim.revealInvestigation,
      clearInvestigation = sim.clearInvestigation,
      triggerNIBP = sim.triggerNIBP,
      toggleNIBPMode = sim.toggleNIBPMode,
      initCharge = sim.initCharge,
      deliverShock = sim.deliverShock;
    // WAVE 8 / FINDINGS 3 + 4. Two-way sensor toggles and the two honest fast paths. Fall back to
    // the plain intervention path if an older engine is loaded, so the panel is never dead.
    var toggleSensor = sim.toggleSensor || function (id) {
      var def = (window.SENSOR_DEFS || []).filter(function (d) {
        return d.id === id;
      })[0];
      if (def) applyIntervention(def.key);
    };
    // The fallbacks are ATOMIC too. The old invasive fallback made three sequential
    // applyIntervention calls inside one click handler, which is precisely the pattern that lost
    // IV access to React's batching; it now prefers the engine's single-action batch primitive
    // and only ever falls back to one dispatch.
    var attachStandard = sim.attachStandardMonitoring || (sim.attachSensors ? function () {
      return sim.attachSensors(['Obs']);
    } : function () {
      return applyIntervention('Obs');
    });
    var attachInvasive = sim.attachInvasiveMonitoring || (sim.attachSensors ? function () {
      return sim.attachSensors(window.INVASIVE_SENSOR_KEYS || ['IV Access', 'ArtLine', 'ToggleETCO2']);
    } : function () {
      return sim.dispatch({
        type: 'ATTACH_SENSORS',
        payload: {
          keys: ['IV Access', 'ArtLine'],
          etco2: true
        }
      });
    });
    // WAVE 3 defibrillator + rhythm surface.
    var RG = window.RHYTHMS;
    var changeRhythm = sim.changeRhythm;
    var nextCycle = sim.nextCycle;
    var rawScenario = state.scenario,
      time = state.time,
      isRunning = state.isRunning,
      vitals = state.vitals,
      activeInterventions = state.activeInterventions,
      interventionCounts = state.interventionCounts,
      activeDurations = state.activeDurations,
      arrestPanelOpen = state.arrestPanelOpen,
      cprInProgress = state.cprInProgress,
      flash = state.flash,
      notification = state.notification,
      trends = state.trends,
      audioOutput = state.audioOutput,
      isMuted = state.isMuted,
      etco2Enabled = state.etco2Enabled,
      etco2Pathology = state.etco2Pathology,
      showWetflag = state.showWetflag;
    // DefibPanelOpen (the monitor-hosted defib), the defib device/metrics block and the
    // ASSESSOR-LOCAL conversion announcements. rhythmEvent/lastConversion never reach Firebase.
    var defibPanelOpen = !!state.defibPanelOpen;
    var defib = state.defib || {};
    var rhythmEvent = state.rhythmEvent;
    var lastConversion = state.lastConversion;
    var remoteClients = state.remotePresence && state.remotePresence.clients || [];
    // Deterioration mode + live drug timing.
    var deteriorationMode = state.deteriorationMode || 'manual';
    var detInfo = sim.describeDeterioration ? sim.describeDeterioration() : {
      declared: false,
      type: null,
      rate: 0
    };
    // Recomputed on every render; `time` changes at 1 Hz so the panel counts down live.
    var activeDrugRows = sim.getActiveDrugStatus ? sim.getActiveDrugStatus() : [];
    var fmtRemaining = function fmtRemaining(s) {
      if (s === null || s === undefined) return "\u2014";
      if (s >= 60) return "".concat(Math.floor(s / 60), "m ").concat(String(Math.round(s % 60)).padStart(2, '0'), "s");
      return "".concat(Math.max(0, Math.round(s)), "s");
    };
    var PHASE_STYLE = {
      onset: {
        cls: 'text-sky-300 border-sky-500/50 bg-sky-950/40',
        label: 'ONSET'
      },
      rising: {
        cls: 'text-amber-300 border-amber-500/50 bg-amber-950/40',
        label: 'RISING'
      },
      peak: {
        cls: 'text-emerald-300 border-emerald-500/50 bg-emerald-950/40',
        label: 'PEAK'
      },
      running: {
        cls: 'text-emerald-300 border-emerald-500/50 bg-emerald-950/40',
        label: 'RUNNING'
      },
      'wearing off': {
        cls: 'text-orange-300 border-orange-500/50 bg-orange-950/40',
        label: 'WEARING OFF'
      }
    };
    var syncStatus = state.syncStatus || {
      state: 'connecting',
      message: 'Connecting to live session…'
    };
    var syncProblem = ['unavailable', 'disconnected', 'error', 'degraded'].includes(syncStatus.state);
    // A restored or partially-synced session can arrive without a scenario; every field read below
    // must degrade to blank rather than take down the whole render tree.
    var scenario = rawScenario || {};
    // ======================= WAVE 4b / PART A: QUICK SIM =======================================
    // `quickSim` is a single boolean read off the SAME scenario object every other screen reads.
    // This is NOT a parallel controller (requirement A4): it is this controller with the
    // scenario-dependent panels omitted. Everything that stays — the vitals tiles, the
    // vitals-control modal and its validation, the trend-over-time control, the rhythm selector,
    // ARREST/ROSC, Launch Monitor, the Defib and Arrest View toggles, the timer, start/pause/
    // finish and the event log — is the existing code path, unchanged and unduplicated.
    //
    // What is omitted, and why:
    //   * intervention library / tabs / search  — nothing to give; there is no scenario.
    //   * drug panel + Active Drugs/pk panels   — no drugs can be given, so they'd be dead UI.
    //   * scenario brief / patient details card — there is no brief.
    //   * learning objectives                   — none exist.
    //   * safety-flag chip + expectation hints  — expectations are properties of interventions;
    //                                             with no interventions there is nothing to flag.
    //   * investigations / voice / assessment   — all scenario-content driven.
    // The AUTO/MANUAL deterioration toggle is HIDDEN in Quick Sim (it always runs MANUAL: the
    // synthetic patient declares no rate, so AUTO could never do anything).
    // What is explicitly KEPT in Quick Sim despite being "extra": Trend Better/Worse (they fall back to
    // relative adjustments when no scenario evolution exists), the custom log entry with its Flag
    // button, NIBP, the drug-dose calculator and the timer alerts — all facilitator tools that
    // are useful without a scenario.
    var quickSim = !!scenario.quickSim;
    // Quick Sim's clock is the session timeline (sessionTime). Like every launch mode it stays
    // at 00:00 until START: the patient is not live before then.
    var clockSeconds = quickSim ? Number(state.sessionTime) || 0 : time;
    // Not started yet (as opposed to paused by the facilitator, or finished): the controller
    // says so plainly until START is pressed.
    var notStarted = !isRunning && !state.isFinished && (state.pausedAt === null || state.pausedAt === undefined);
    var etco2Shape = etco2Pathology || 'normal';
    var setEtco2Shape = function setEtco2Shape(shape) {
      return sim.dispatch({
        type: 'SET_ETCO2_PATHOLOGY',
        payload: shape
      });
    };

    // "Set up the patient" (data/screens/patientstatus.js PatientSetup): injuries and the kit already
    // on when the team arrives, offered beside START until the scenario starts.
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showSetup = _useState6[0],
      setShowSetup = _useState6[1];
    var PS = window.PatientStatus;
    var setUpButton = function setUpButton(cls) {
      return notStarted && PS && PS.PatientSetup && state.scenario ? /*#__PURE__*/React.createElement(Button, {
        variant: "warning",
        onClick: function onClick() {
          return setShowSetup(true);
        },
        className: "h-8 px-2 whitespace-nowrap font-bold ".concat(cls || ''),
        ariaLabel: "Set up the patient"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "bed"
      }), " Set up patient") : null;
    };
    var _useState7 = useState("Common"),
      _useState8 = _slicedToArray(_useState7, 2),
      activeTab = _useState8[0],
      setActiveTab = _useState8[1];
    // Simple / Full view (shared with every screen on this device; Simple is the default).
    var _window$useViewMode = window.useViewMode(),
      _window$useViewMode2 = _slicedToArray(_window$useViewMode, 2),
      viewMode = _window$useViewMode2[0],
      setViewMode = _window$useViewMode2[1];
    var simple = viewMode !== 'full';
    var _useState9 = useState(""),
      _useState0 = _slicedToArray(_useState9, 2),
      customLog = _useState0[0],
      setCustomLog = _useState0[1];
    var _useState1 = useState(""),
      _useState10 = _slicedToArray(_useState1, 2),
      searchTerm = _useState10[0],
      setSearchTerm = _useState10[1];
    var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      speechText = _useState12[0],
      setSpeechText = _useState12[1];
    var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showVolume = _useState14[0],
      setShowVolume = _useState14[1];
    var volumePct = (Number.isFinite(state.volume) ? state.volume : 1) * 100;
    var lastVolumeRef = useRef(1);
    var setVolume = function setVolume(v) {
      if (v > 0) lastVolumeRef.current = v;
      sim.dispatch({
        type: 'SET_VOLUME',
        payload: v
      });
    };
    // Patient voice library (data/voices.js): which recorded voice the stock phrases use. 'auto' picks
    // one from the patient's age and sex. Remembered on this device.
    var _useState15 = useState(function () {
        try {
          return window.localStorage && window.localStorage.getItem('wmebem_voice') || 'auto';
        } catch (e) {
          return 'auto';
        }
      }),
      _useState16 = _slicedToArray(_useState15, 2),
      voicePick = _useState16[0],
      setVoicePickRaw = _useState16[1];
    var setVoicePick = function setVoicePick(v) {
      setVoicePickRaw(v);
      try {
        window.localStorage && window.localStorage.setItem('wmebem_voice', v);
      } catch (e) {}
    };
    var VOICE_LIB = window.VOICE_LIBRARY || {
      voices: [],
      groups: []
    };
    var VOICE_CLIPS = window.VOICE_CLIPS || [];
    var autoVoice = function () {
      var age = Number(scenario.patientAge),
        female = /^f/i.test(scenario.sex || '');
      if (age < 12) return 'child';
      if (age < 18) return 'teen';
      if (age >= 70) return female ? 'older-woman' : 'older-man';
      return female ? 'woman' : 'man';
    }();
    var voiceId = voicePick === 'auto' ? autoVoice : voicePick;
    var hasClip = function hasClip(phraseId) {
      return VOICE_CLIPS.includes("".concat(voiceId, "/").concat(phraseId));
    };
    var sayPhrase = function sayPhrase(p) {
      return speak(p.text, hasClip(p.id) ? "".concat(voiceId, "/").concat(p.id) : null);
    };
    // The Voice tab, and a section of its own in Quick Sim (which has no tabs).
    var renderVoicePanel = function renderVoicePanel() {
      return /*#__PURE__*/React.createElement("div", {
        className: "space-y-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 p-3 rounded border border-slate-700"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "text-xs font-bold text-slate-400 uppercase mb-2 flex items-center gap-2"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "mic",
        className: "w-3 h-3"
      }), " Text to Speech"), /*#__PURE__*/React.createElement("div", {
        className: "flex gap-2"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        value: speechText,
        onChange: function onChange(e) {
          return setSpeechText(e.target.value);
        },
        onKeyDown: function onKeyDown(e) {
          return e.key === 'Enter' && speechText.trim() && (speak(speechText.trim()) || setSpeechText(""));
        },
        className: "flex-1 bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white text-sm",
        placeholder: "Type what the patient says..."
      }), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          if (!speechText.trim()) return;
          speak(speechText.trim());
          setSpeechText("");
        },
        disabled: !speechText.trim(),
        variant: "primary",
        className: "h-10"
      }, "Speak"))), /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 p-3 rounded border border-slate-700"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "voicePick",
        className: "text-xs font-bold text-slate-400 uppercase mb-2 flex items-center gap-2"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "user",
        className: "w-3 h-3"
      }), " Patient's voice"), /*#__PURE__*/React.createElement("select", {
        id: "voicePick",
        "data-testid": "voice-pick",
        value: voicePick,
        onChange: function onChange(e) {
          return setVoicePick(e.target.value);
        },
        className: "w-full bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white text-sm"
      }, /*#__PURE__*/React.createElement("option", {
        value: "auto"
      }, "Match the patient (", (VOICE_LIB.voices.find(function (v) {
        return v.id === autoVoice;
      }) || {}).label || autoVoice, ")"), VOICE_LIB.voices.map(function (v) {
        return /*#__PURE__*/React.createElement("option", {
          key: v.id,
          value: v.id
        }, v.label);
      })), !VOICE_LIB.voices.some(function (v) {
        return VOICE_CLIPS.some(function (c) {
          return c.startsWith(v.id + '/');
        });
      }) && /*#__PURE__*/React.createElement("p", {
        className: "text-[10px] text-slate-400 mt-2"
      }, "Recorded voices are not installed yet, so phrases use this device's built-in voice.")), VOICE_LIB.groups.filter(function (g) {
        return !g.sounds || g.phrases.some(function (p) {
          return hasClip(p.id);
        });
      }).map(function (g) {
        return /*#__PURE__*/React.createElement("div", {
          key: g.label
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1"
        }, g.label), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-2 md:grid-cols-3 gap-2"
        }, g.phrases.filter(function (p) {
          return !g.sounds || hasClip(p.id);
        }).map(function (p) {
          return /*#__PURE__*/React.createElement(Button, {
            key: p.id,
            onClick: function onClick() {
              return sayPhrase(p);
            },
            variant: "secondary",
            className: "min-h-[3rem] h-auto py-2 text-sm normal-case justify-start px-3 text-left border border-slate-600 bg-slate-800"
          }, /*#__PURE__*/React.createElement(Lucide, {
            icon: g.sounds ? 'volume-2' : 'message-square',
            className: "w-4 h-4 mr-2 opacity-50 shrink-0"
          }), " ", g.sounds ? p.text : "\"".concat(p.text, "\""));
        })));
      }));
    };
    var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      modalVital = _useState18[0],
      setModalVital = _useState18[1];
    var _useState19 = useState(""),
      _useState20 = _slicedToArray(_useState19, 2),
      modalTarget = _useState20[0],
      setModalTarget = _useState20[1];
    var _useState21 = useState(""),
      _useState22 = _slicedToArray(_useState21, 2),
      modalTarget2 = _useState22[0],
      setModalTarget2 = _useState22[1];
    // GCS picked as E, V and M (Jake's request); the total is what the engine keeps. The last
    // breakdown set here is remembered so the GCS tile can show it while the total still matches.
    var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      gcsParts = _useState24[0],
      setGcsParts = _useState24[1];
    var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      lastGcsParts = _useState26[0],
      setLastGcsParts = _useState26[1];
    var _useState27 = useState(30),
      _useState28 = _slicedToArray(_useState27, 2),
      trendDuration = _useState28[0],
      setTrendDuration = _useState28[1];
    var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      showLogModal = _useState30[0],
      setShowLogModal = _useState30[1];
    var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      showRhythmModal = _useState32[0],
      setShowRhythmModal = _useState32[1];
    // PHONE ONLY: the trace strip and the Quick Sim rhythm list start folded away (the obs and the
    // rhythm are already at the top of the page, and Change Rhythm opens the same list). Desktop and
    // tablet layouts ignore these.
    var _useState33 = useState(false),
      _useState34 = _slicedToArray(_useState33, 2),
      phoneTrace = _useState34[0],
      setPhoneTrace = _useState34[1];
    var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      phoneRhythms = _useState36[0],
      setPhoneRhythms = _useState36[1];
    // The one-line Quick Sim patient strip truncates the name on a phone; tapping it opens the
    // full details (Jake's request, 28 Oct 2026).
    var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      quickInfoOpen = _useState38[0],
      setQuickInfoOpen = _useState38[1];
    var _useState39 = useState(false),
      _useState40 = _slicedToArray(_useState39, 2),
      showArrestMenu = _useState40[0],
      setShowArrestMenu = _useState40[1];
    var _useState41 = useState(false),
      _useState42 = _slicedToArray(_useState41, 2),
      showROSCMenu = _useState42[0],
      setShowROSCMenu = _useState42[1];
    var _useState43 = useState([]),
      _useState44 = _slicedToArray(_useState43, 2),
      searchResults = _useState44[0],
      setSearchResults = _useState44[1];
    // The ARREST / ROSC pop-up menus close on an outside click or Escape, like any menu.
    var arrestMenuRef = useRef(null);
    var roscMenuRef = useRef(null);
    useEffect(function () {
      if (!showArrestMenu && !showROSCMenu) return;
      var onDown = function onDown(e) {
        if (arrestMenuRef.current && arrestMenuRef.current.contains(e.target)) return;
        if (roscMenuRef.current && roscMenuRef.current.contains(e.target)) return;
        setShowArrestMenu(false);
        setShowROSCMenu(false);
      };
      var onKey = function onKey(e) {
        if (e.key === 'Escape') {
          setShowArrestMenu(false);
          setShowROSCMenu(false);
        }
      };
      document.addEventListener('pointerdown', onDown);
      document.addEventListener('keydown', onKey);
      return function () {
        document.removeEventListener('pointerdown', onDown);
        document.removeEventListener('keydown', onKey);
      };
    }, [showArrestMenu, showROSCMenu]);
    var _useState45 = useState(null),
      _useState46 = _slicedToArray(_useState45, 2),
      invModal = _useState46[0],
      setInvModal = _useState46[1];
    var _useState47 = useState(""),
      _useState48 = _slicedToArray(_useState47, 2),
      invCustomText = _useState48[0],
      setInvCustomText = _useState48[1];
    // Show the written report with an image (on), or the image alone for the team to interpret.
    var _useState49 = useState(true),
      _useState50 = _slicedToArray(_useState49, 2),
      invWithReport = _useState50[0],
      setInvWithReport = _useState50[1];
    var _useState51 = useState(false),
      _useState52 = _slicedToArray(_useState51, 2),
      showNIBPModal = _useState52[0],
      setShowNIBPModal = _useState52[1];
    var _useState53 = useState(vitals.bpSys),
      _useState54 = _slicedToArray(_useState53, 2),
      nibpSys = _useState54[0],
      setNibpSys = _useState54[1];
    var _useState55 = useState(vitals.bpDia),
      _useState56 = _slicedToArray(_useState55, 2),
      nibpDia = _useState56[0],
      setNibpDia = _useState56[1];
    var _useState57 = useState(false),
      _useState58 = _slicedToArray(_useState57, 2),
      showDrugCalc = _useState58[0],
      setShowDrugCalc = _useState58[1];
    var _useState59 = useState(String(((_scenario$wetflag = scenario.wetflag) === null || _scenario$wetflag === void 0 ? void 0 : _scenario$wetflag.weight) || scenario.weight || 70)),
      _useState60 = _slicedToArray(_useState59, 2),
      drugCalcWeightStr = _useState60[0],
      setDrugCalcWeightStr = _useState60[1];
    // A weight of 0 or a typo silently produced 0 mg doses and 0 J energies — every derived number in
    // the calculator is a multiple of it, so an invalid weight must block the whole table, not coerce.
    var drugCalcWeightError = window.validateBuilderField ? window.validateBuilderField('weight', drugCalcWeightStr) : null;
    var drugCalcWeight = drugCalcWeightError ? 0 : parseFloat(drugCalcWeightStr);
    var _useState61 = useState(false),
      _useState62 = _slicedToArray(_useState61, 2),
      showTimerModal = _useState62[0],
      setShowTimerModal = _useState62[1];
    // Timer alerts and a running preset belong to the run, not to this screen: Back to the menu
    // unmounts it, so they are kept per run id and picked up again on "Return to scenario".
    var keepStore = window.__liveSimKeep || (window.__liveSimKeep = {});
    var kept = state.runId && keepStore[state.runId] || null;
    // The right-hand column (interventions, or Quick Sim's rhythms) can be folded away so the obs
    // column fills the screen. Every run starts folded, Quick Sim and scenarios alike (Jake, 18 Oct
    // 2026); the fold bar opens it. Within a run the choice is kept across Back / "Return to
    // scenario" (the run's keep store below). md+ only: on a phone the columns stack and nothing folds.
    var _useState63 = useState(function () {
        return kept && typeof kept.rightFolded === 'boolean' ? kept.rightFolded : true;
      }),
      _useState64 = _slicedToArray(_useState63, 2),
      rightFolded = _useState64[0],
      setRightFolded = _useState64[1];
    var rightFoldedRef = useRef(rightFolded);
    rightFoldedRef.current = rightFolded;
    // A new run starts folded even if this screen stays mounted between runs.
    var foldRunRef = useRef(state.runId);
    useEffect(function () {
      if (foldRunRef.current === state.runId) return;
      foldRunRef.current = state.runId;
      setRightFolded(true);
    }, [state.runId]);
    var toggleRightFolded = function toggleRightFolded() {
      return setRightFolded(function (f) {
        return !f;
      });
    };
    var _useState65 = useState(function () {
        return kept && kept.timerAlerts || [];
      }),
      _useState66 = _slicedToArray(_useState65, 2),
      timerAlerts = _useState66[0],
      setTimerAlerts = _useState66[1];
    var timerAlertsRef = useRef(timerAlerts);
    timerAlertsRef.current = timerAlerts;
    var _useState67 = useState('5'),
      _useState68 = _slicedToArray(_useState67, 2),
      newAlertMins = _useState68[0],
      setNewAlertMins = _useState68[1];
    var _useState69 = useState(''),
      _useState70 = _slicedToArray(_useState69, 2),
      newAlertMsg = _useState70[0],
      setNewAlertMsg = _useState70[1];
    var _useState71 = useState(''),
      _useState72 = _slicedToArray(_useState71, 2),
      timerAlertError = _useState72[0],
      setTimerAlertError = _useState72[1];
    var _useState73 = useState(function () {
        return new Set(kept && kept.fired || []);
      }),
      _useState74 = _slicedToArray(_useState73, 2),
      firedAlerts = _useState74[0],
      setFiredAlerts = _useState74[1];
    var firedAlertsRef = useRef(new Set(kept && kept.fired || []));
    var _useState75 = useState(false),
      _useState76 = _slicedToArray(_useState75, 2),
      showKeyHelp = _useState76[0],
      setShowKeyHelp = _useState76[1];
    // Course scenarios (e.g. ETC) carry a mark sheet: the pathway, results and criteria.
    var _useState77 = useState(false),
      _useState78 = _slicedToArray(_useState77, 2),
      showMarkSheet = _useState78[0],
      setShowMarkSheet = _useState78[1];
    var hasMarkSheet = !!(window.MarkScheme && window.MarkScheme.get(scenario));
    var _useState79 = useState(false),
      _useState80 = _slicedToArray(_useState79, 2),
      showJoin = _useState80[0],
      setShowJoin = _useState80[1];
    var _useState81 = useState(false),
      _useState82 = _slicedToArray(_useState81, 2),
      showFlagsModal = _useState82[0],
      setShowFlagsModal = _useState82[1];
    // Alarm tones now live in the shared engine (so the STUDENT monitor alarms too) and are routed
    // by `audioOutput`. This screen no longer owns an AudioContext, which also removes the risk of
    // the controller double-playing every alarm.
    var playAlertTone = sim.playAlertTone || function () {};

    // Reset fired-alerts when sim resets to T=0
    useEffect(function () {
      if (time === 0) {
        firedAlertsRef.current = new Set();
        setFiredAlerts(new Set());
      }
    }, [time === 0]);

    // Alarm thresholds are applied in the shared engine now (so students hear alarms too); kept
    // here only for on-screen reference by future panels.
    var thresholds = window.getAlarmThresholds && window.getAlarmThresholds((_scenario$patientAge = scenario === null || scenario === void 0 ? void 0 : scenario.patientAge) !== null && _scenario$patientAge !== void 0 ? _scenario$patientAge : 40) || {
      hr: {
        low: 40,
        high: 130
      },
      rr: {
        low: 8,
        high: 30
      },
      spO2: 90
    };

    // Seeded from the engine, so ticks made before Back (or a resume) are not wiped on return.
    var _useState83 = useState(function () {
        return _objectSpread({
          "Safe Approach": null,
          "Team Leadership": null,
          "Communication": null,
          "CPR Quality": null,
          "Defib Safety": null,
          "Re-evaluation": null
        }, state.assessments && _typeof(state.assessments) === 'object' ? state.assessments : {});
      }),
      _useState84 = _slicedToArray(_useState83, 2),
      assessments = _useState84[0],
      setAssessments = _useState84[1];

    // Every rhythm menu is now derived from the shared registry, so the arrest menu can
    // no longer offer a rhythm no scenario uses, and the ROSC menu can no longer omit Atrial
    // Flutter or Complete Heart Block.
    var RHYTHMS = RG.SELECTABLE;
    var ARREST_RHYTHMS = RG.ARREST;
    var ROSC_RHYTHMS = RG.ROSC;

    // The 28 new route-specific keys are grouped here so they are reachable in two taps
    // and sit beside their IV equivalents (the route is printed on every button).
    var DRUG_GROUPS = {
      "Resus / Cardiac": ["AdrenalineIV", "AdrenalinePush", "AdrenalineInfusion", "Amiodarone", "AmiodaroneInfusion", "Atropine", "Adenosine", "Digoxin", "MagSulph", "MagnesiumInfusion", "Calcium", "CalciumChloride", "SodiumBicarb", "AdrenalineIM"],
      // 'Morphine' was a dead slot here: the intervention key is 'Analgesia' (label "Morphine"),
      // so the group rendered one permanently missing button.
      "RSI / Induction": ["Propofol", "Ketamine", "KetamineIM", "Etomidate", "Thiopentone", "Midazolam", "Alfentanil", "Fentanyl", "Roc", "Sux", "Sugammadex"],
      "Sedation / Analgesia": ["Analgesia", "MorphineIM", "MorphineOral", "Paracetamol", "ParacetamolOral", "Metoclopramide", "Naloxone", "NaloxoneIM", "NaloxoneIN", "Flumazenil"],
      // NICE NG217 / APLS: buccal midazolam is step 1 when there is no IV/IO access, and PR
      // diazepam is the community alternative. Neither existed before Wave 4a.
      "Seizures (by route)": ["MidazolamBuccal", "MidazolamIN", "MidazolamIM", "Lorazepam", "LorazepamIM", "DiazepamIV", "DiazepamPR", "Levetiracetam", "Phenytoin"],
      "Vasoactive": ["Metaraminol", "Noradrenaline", "Labetalol", "LabetalolInfusion", "Phentolamine"],
      // Osmotherapy lowers the modelled ICP in a neuro scenario (so does a tube with normocapnia).
      "Raised ICP": ["HypertonicSaline", "Mannitol"],
      "Antibiotics": ["Antibiotics", "Ceftriaxone", "Tazocin", "Gentamicin", "Benzylpenicillin", "BenzylpenicillinIM"],
      "Glucose / Insulin": ["InsulinInfusion", "InsulinDextrose", "InsulinSubcut", "Dextrose", "GlucoseOral", "Glucagon", "GlucagonIV", "HIET"],
      // WAVE 5 (minor note): "Salbutamol IV infusion" is categorised under BREATHING, which is
      // correct — it is a respiratory escalation — but a facilitator looking for a drug looks in
      // DRUGS and concluded it was missing. Cross-listing it (and the other respiratory agents
      // that live under Breathing) makes it discoverable from BOTH tabs; the buttons are rendered
      // from the intervention key, so this is a second route to the same action, not a duplicate
      // definition.
      "Respiratory (also under Breathing)": ["Nebs", "NebsContinuous", "SalbutamolIV"].filter(function (k) {
        return INTERVENTIONS[k];
      }),
      "Other": []
    };
    var KNOWN_DRUGS = new Set(Object.values(DRUG_GROUPS).flat());
    useEffect(function () {
      if (!searchTerm) {
        setSearchResults([]);
        return;
      }
      var term = searchTerm.toLowerCase();
      var matches = Object.keys(INTERVENTIONS).filter(function (key) {
        var item = INTERVENTIONS[key];
        // Route is searchable too, so "IM", "buccal", "PR" or "intranasal" finds the
        // right key without knowing the label.
        return item.label.toLowerCase().includes(term) || key.toLowerCase().includes(term) || (item.route || '').toLowerCase().includes(term);
      });
      setSearchResults(matches);
    }, [searchTerm]);
    var getInterventionsByCat = function getInterventionsByCat(cat) {
      var keys = [];
      if (cat === 'Common') keys = ['Obs', 'Oxygen', 'IV Access', 'Fluids', 'Analgesia', 'Antiemetic', 'Antibiotics', 'Nebs', 'AdrenalineIM', 'Blood', 'TXA', 'ArtLine', 'ChestSeal'];else keys = Object.keys(INTERVENTIONS).filter(function (key) {
        return INTERVENTIONS[key].category === cat;
      });
      return keys.sort(function (a, b) {
        return INTERVENTIONS[a].label.localeCompare(INTERVENTIONS[b].label);
      });
    };
    var _useState85 = useState(false),
      _useState86 = _slicedToArray(_useState85, 2),
      showToast = _useState86[0],
      setShowToast = _useState86[1];
    useEffect(function () {
      if (notification && notification.id) {
        setShowToast(true);
        var timer = setTimeout(function () {
          return setShowToast(false);
        }, 3000);
        return function () {
          return clearTimeout(timer);
        };
      }
    }, [notification]);
    useEffect(function () {
      sim.dispatch({
        type: 'UPDATE_ASSESSMENT',
        payload: assessments
      });
    }, [assessments]);
    useEffect(function () {
      if (!isRunning) return;
      timerAlerts.forEach(function (alert) {
        var alertTimeS = alert.mins * 60;
        if (time >= alertTimeS && !firedAlertsRef.current.has(alert.id)) {
          firedAlertsRef.current.add(alert.id);
          setFiredAlerts(new Set(firedAlertsRef.current));
          addLogEntry("Timer Alert: ".concat(alert.msg), 'danger');
          playAlertTone('critical');
        }
      });
    }, [time, isRunning, timerAlerts]);
    useEffect(function () {
      var handler = function handler(e) {
        var _active$matches;
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        var active = document.activeElement;
        // Typing never triggers a shortcut. A focused button only blocks Space (which presses
        // it); previously any focused button blocked every shortcut, so after one click on
        // START none of them worked.
        if (active !== null && active !== void 0 && (_active$matches = active.matches) !== null && _active$matches !== void 0 && _active$matches.call(active, 'input, select, textarea, [contenteditable="true"]')) return;
        // D, T and ? close their own window again, as the shortcut help says ("Toggle").
        if ((e.key === 'd' || e.key === 'D') && showDrugCalc) {
          setShowDrugCalc(false);
          return;
        }
        if ((e.key === 't' || e.key === 'T') && showTimerModal) {
          setShowTimerModal(false);
          return;
        }
        if (e.key === '?' && showKeyHelp) {
          setShowKeyHelp(false);
          return;
        }
        // Arrest View is a layout on the team's monitor, not a window here, so it does not block.
        var modalOpen = showJoin || modalVital || showDrugCalc || showTimerModal || invModal || showNIBPModal || showLogModal || showRhythmModal || showKeyHelp || showFlagsModal || showArrestMenu || showROSCMenu || showSetup || showMarkSheet || showVolume;
        if (modalOpen) return;
        if (e.key === ' ') {
          var _active$matches2;
          if (active !== null && active !== void 0 && (_active$matches2 = active.matches) !== null && _active$matches2 !== void 0 && _active$matches2.call(active, 'button, a, [role="button"]')) return;
          e.preventDefault();
          isRunning ? pause() : start();
        }
        if (e.key === 'f' || e.key === 'F') confirmFinish();
        if (e.key === 'd' || e.key === 'D') setShowDrugCalc(function (v) {
          return !v;
        });
        if (e.key === 't' || e.key === 'T') setShowTimerModal(function (v) {
          return !v;
        });
        if (e.key === '?') setShowKeyHelp(function (v) {
          return !v;
        });
      };
      window.addEventListener('keydown', handler);
      return function () {
        return window.removeEventListener('keydown', handler);
      };
    }, [isRunning, showJoin, modalVital, showDrugCalc, showTimerModal, invModal, showNIBPModal, showLogModal, showRhythmModal, showKeyHelp, showFlagsModal, showArrestMenu, showROSCMenu, showSetup, showMarkSheet, showVolume]);

    // A blank entry is never logged (Enter or a stray click on an empty box used to add empty
    // lines to the log and the debrief timeline).
    var submitCustomLog = function submitCustomLog(flagged) {
      var msg = customLog.trim();
      if (!msg) return;
      addLogEntry(msg, 'manual', !!flagged);
      setCustomLog('');
    };
    // Finish is irreversible (it ends the session and opens the debrief), and it sits next to
    // Back and START, so the button confirms exactly as the F shortcut always has.
    // A cuff that is not on cannot measure; say so rather than silently changing the team's
    // retained last reading.
    var cycleNibp = function cycleNibp() {
      if (!sensors.nibp) {
        sim.dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: 'No NIBP cuff attached — attach it first.',
            type: 'warning',
            id: Date.now()
          }
        });
        return;
      }
      triggerNIBP();
    };
    var confirmFinish = function confirmFinish() {
      if (window.confirm('End the simulation and go to debrief?')) onFinish();
    };
    var formatTime = function formatTime(s) {
      return "".concat(Math.floor(s / 60).toString().padStart(2, '0'), ":").concat((s % 60).toString().padStart(2, '0'));
    };
    // Individual sensors, derived from the shared engine helper so the
    // controller and the student monitor can never disagree about what is attached.
    // Quick Sim is NOT special-cased here any more: it starts with nothing attached, and the
    // strip below shows exactly what the team sees — a removed sensor's trace goes blank.
    var isMonitoringApplied = activeInterventions.has('Obs');
    var sensors = window.getSensors ? window.getSensors(state) : {
      ecg: isMonitoringApplied,
      spo2: isMonitoringApplied,
      nibp: isMonitoringApplied,
      temp: isMonitoringApplied,
      etco2: etco2Enabled,
      art: false,
      iv: false,
      any: isMonitoringApplied
    };
    var sEcg = sensors.ecg;
    var sSpo2 = sensors.spo2;
    var sResp = sensors.ecg; // impedance respiration comes off the ECG electrodes
    // Every continuous sensor except IV access (which is a route, not a monitor).
    var MONITOR_SENSOR_KEYS = ['MonECG', 'MonSpO2', 'MonNIBP', 'MonTemp', 'ToggleETCO2', 'ArtLine'];
    var anyMonitorOn = sensors.ecg || sensors.spo2 || sensors.nibp || sensors.temp || sensors.etco2 || sensors.art;
    var removeAllMonitoring = function removeAllMonitoring() {
      if (sim.detachSensors) sim.detachSensors(MONITOR_SENSOR_KEYS);else (window.SENSOR_DEFS || []).filter(function (d) {
        return d.kind === 'continuous' && sensors[d.id];
      }).forEach(function (d) {
        return toggleSensor(d.id);
      });
    };
    var pocReadings = state.pocReadings || {};
    // Capnography: no ventilation means NO capnogram (the absence is the teaching point).
    var capnoVentilating = window.isCapnoVentilating ? window.isCapnoVentilating(state, vitals) : true;
    // Bronchospasm drives the shark-fin capnogram through the EXISTING etco2Pathology state.
    var capnoPattern = etco2Pathology || 'normal';
    // HOW obstructed, not just whether: one severity number from the engine's
    // existing bronchospasm model (scenario diagnosis + how hard the patient is working −
    // bronchodilator pk relief), which scales the capnogram from a normal trapezoid through a
    // slant to an unmistakable shark fin, and falls again as treatment takes effect. The
    // facilitator's explicit Normal/Obstructive choice still overrides it (Wave 5 supremacy).
    var obstruction = window.getObstruction ? window.getObstruction(state, vitals, scenario) : {
      severity: capnoPattern === 'bronchospastic' ? 0.9 : 0,
      band: 'none',
      base: 0,
      relief: 0,
      tiring: 0,
      source: ''
    };
    var capnoSeverity = Number.isFinite(obstruction.severity) ? obstruction.severity : 0;
    // The facilitator's own panel size (drag handles + localStorage).
    var panel = useResizablePanel();

    // ======================= QUICK SIM PRESETS (scripted sequences) =======================
    // A preset steps through rhythm/obs changes on a timer, or waits for Next. Elapsed time only
    // accrues while the clock runs, so a preset waits for START and PAUSE freezes it too.
    // Rhythms go through the same entry points as the menus: a pulseless target is an ARREST,
    // leaving a pulseless rhythm is a ROSC, anything else is an ordinary rhythm change.
    var QSP = window.QuickSimPresets;
    var _useState87 = useState(function () {
        return QSP ? QSP.all() : [];
      }),
      _useState88 = _slicedToArray(_useState87, 2),
      presetList = _useState88[0],
      setPresetList = _useState88[1];
    var _useState89 = useState(null),
      _useState90 = _slicedToArray(_useState89, 2),
      presetView = _useState90[0],
      setPresetView = _useState90[1]; // { name, idx, total, note, nextIn, waiting }
    var presetRunRef = useRef(kept && kept.presetRun ? _objectSpread(_objectSpread({}, kept.presetRun), {}, {
      lastTs: Date.now()
    }) : null); // { preset, idx, accMs, lastTs, lastNote }
    var liveStateRef = useRef(state);
    liveStateRef.current = state;
    var presetActionsRef = useRef(null);
    presetActionsRef.current = {
      changeRhythm: changeRhythm,
      triggerArrest: triggerArrest,
      triggerROSC: triggerROSC,
      startTrend: startTrend,
      manualUpdateVital: manualUpdateVital,
      addLogEntry: addLogEntry
    };
    var applyPresetStep = function applyPresetStep(preset, step, i) {
      var a = presetActionsRef.current;
      var cause = "preset: ".concat(preset.name);
      if (step.rhythm && RG.isKnown(step.rhythm)) {
        var cur = liveStateRef.current.rhythm;
        if (RG.isPulseless(step.rhythm)) {
          if (RG.canonical(cur) !== RG.canonical(step.rhythm)) a.triggerArrest(step.rhythm, cause);
        } else if (RG.isPulseless(cur)) a.triggerROSC(step.rhythm, cause);else if (RG.canonical(cur) !== RG.canonical(step.rhythm)) a.changeRhythm(step.rhythm, cause);
      }
      var targets = {};
      Object.keys(step.vitals || {}).forEach(function (k) {
        var v = Number(step.vitals[k]);
        if (Number.isFinite(v)) targets[k] = v;
      });
      if (Object.keys(targets).length) {
        if (Number(step.over) > 0) a.startTrend(targets, Number(step.over));else Object.keys(targets).forEach(function (k) {
          return a.manualUpdateVital(k, targets[k]);
        });
      }
      a.addLogEntry("Preset \"".concat(preset.name, "\" \u2014 step ").concat(i + 1, "/").concat(preset.steps.length, ": ").concat(step.note || 'applied'), 'system');
    };
    var refreshPresetView = function refreshPresetView() {
      var run = presetRunRef.current;
      if (!run) {
        setPresetView(null);
        return;
      }
      var next = run.preset.steps[run.idx];
      setPresetView({
        name: run.preset.name,
        idx: run.idx,
        total: run.preset.steps.length,
        note: run.lastNote,
        waiting: !!(next && next.wait),
        nextNote: next ? next.note : null,
        nextIn: next && !next.wait ? Math.max(0, Math.ceil((Number(next.after) || 0) - run.accMs / 1000)) : null
      });
    };
    var firePresetStep = function firePresetStep() {
      var run = presetRunRef.current;
      if (!run) return;
      var step = run.preset.steps[run.idx];
      if (!step) return;
      applyPresetStep(run.preset, step, run.idx);
      run.lastNote = step.note || null;
      run.idx += 1;
      run.accMs = 0;
      if (run.idx >= run.preset.steps.length) {
        presetActionsRef.current.addLogEntry("Preset \"".concat(run.preset.name, "\" complete."), 'system');
        presetRunRef.current = null;
      }
      refreshPresetView();
    };
    var startPreset = function startPreset(preset) {
      if (presetRunRef.current && !window.confirm("Stop \"".concat(presetRunRef.current.preset.name, "\" and start \"").concat(preset.name, "\"?"))) return;
      presetRunRef.current = {
        preset: preset,
        idx: 0,
        accMs: 0,
        lastTs: Date.now(),
        lastNote: null
      };
      addLogEntry("Preset started: \"".concat(preset.name, "\""), 'system');
      // A first step with no delay fires at once, so pressing the preset changes something now.
      if (!preset.steps[0].wait && !(Number(preset.steps[0].after) > 0)) firePresetStep();else refreshPresetView();
    };
    var stopPreset = function stopPreset() {
      if (!presetRunRef.current) return;
      addLogEntry("Preset stopped: \"".concat(presetRunRef.current.preset.name, "\""), 'system');
      presetRunRef.current = null;
      refreshPresetView();
    };
    var presetActive = !!presetView;
    // A preset kept from before Back shows (and carries on) straight away.
    useEffect(function () {
      if (presetRunRef.current) refreshPresetView();
    }, []);
    // Keep this run's alerts and preset for when the screen comes back (only the latest run).
    var runIdNow = state.runId;
    useEffect(function () {
      return function () {
        if (!runIdNow) return;
        var store = window.__liveSimKeep || (window.__liveSimKeep = {});
        Object.keys(store).forEach(function (k) {
          if (k !== runIdNow) delete store[k];
        });
        store[runIdNow] = {
          timerAlerts: timerAlertsRef.current,
          fired: Array.from(firedAlertsRef.current),
          presetRun: presetRunRef.current,
          rightFolded: rightFoldedRef.current
        };
      };
    }, [runIdNow]);
    useEffect(function () {
      if (!presetActive) return;
      var id = setInterval(function () {
        var run = presetRunRef.current;
        if (!run) return;
        var now = Date.now();
        var st = liveStateRef.current;
        if (st.isRunning && !st.isFinished) run.accMs += now - run.lastTs;
        run.lastTs = now;
        var next = run.preset.steps[run.idx];
        if (next && !next.wait && run.accMs >= (Number(next.after) || 0) * 1000) firePresetStep();else refreshPresetView();
      }, 250);
      return function () {
        return clearInterval(id);
      };
    }, [presetActive]);
    var savePresetSnapshot = function savePresetSnapshot() {
      if (!QSP) return;
      var name = window.prompt('Name for this preset (saves the current rhythm and obs on this device):', RG.labelFor(state.rhythm));
      if (!name || !name.trim()) return;
      var ok = QSP.save(QSP.snapshotPreset(name.trim(), state.rhythm, vitals));
      if (!ok) {
        window.alert('This browser is not allowing storage, so the preset could not be saved.');
        return;
      }
      setPresetList(QSP.all());
    };
    var deletePreset = function deletePreset(p) {
      if (!QSP || !window.confirm("Delete the saved preset \"".concat(p.name, "\"?"))) return;
      QSP.remove(p.id);
      setPresetList(QSP.all());
    };
    // WAVE 6 / QUICK SIM WAVEFORMS. The strip used to be frozen whenever the session clock was
    // not running (isPaused={!isRunning}), which meant the rAF loop sized the canvas, painted it
    // black and returned WITHOUT DRAWING. Quick Sim reaches this controller without ever passing
    // through the briefing screen's START, so the facilitator saw an entirely black trace panel
    // for the whole session while the student monitor (which never gates its strips on the clock)
    // drew normally. A facilitator must be able to see the rhythm they have selected before the
    // clock starts, so the trace now freezes ONLY on a deliberate pause of a session that has
    // actually run — i.e. never at 00:00, in any launch mode.
    //
    // `!isRunning && time > 0` also matched a RESUMED session: "Resume
    // Previous" restores a non-zero clock and does not start the sim, so the strip was read as
    // deliberately paused and stayed BLANK until START was pressed (a fresh Quick Sim drew
    // correctly, which is what made it look inconsistent). The two cases are now distinguished by
    // the only thing that actually differs — whether the FACILITATOR paused this session: the
    // reducer sets `pausedAt` on PAUSE_SIM and clears it on START_SIM and on RESTORE_SESSION,
    // and it is deliberately not persisted, so a reload can only ever produce "restored, not yet
    // started". A deliberate pause of a running session still genuinely freezes the strip.
    var pausedByFacilitator = state.pausedAt !== null && state.pausedAt !== undefined;
    var traceFrozen = !isRunning && (pausedByFacilitator || state.isFinished);
    var showEtco2 = etco2Enabled;
    var showArt = activeInterventions.has('ArtLine');
    // A weight entered for an adult Quick Sim patient is not a child (it made a 40-year-old "paeds").
    var isPaeds = scenario.ageRange === 'Paediatric' || !!scenario.wetflag && !(Number(scenario.patientAge) >= 18);
    var cycleAudioOutput = function cycleAudioOutput() {
      var next = audioOutput === 'controller' ? 'monitor' : audioOutput === 'monitor' ? 'both' : 'controller';
      sim.dispatch({
        type: 'SET_AUDIO_OUTPUT',
        payload: next
      });
    };

    // The small x / - on a card goes through the engine's own toggle-off path (log line, toast,
    // CPR flag cleared, queued pre-START effects dropped) rather than a bare reducer dispatch,
    // which used to leave CPR "in progress" on the monitor after the x on the CPR card.
    var handleRemove = function handleRemove(e, key, type) {
      e.stopPropagation();
      if (type === 'continuous') {
        sim.applyIntervention(key);
        return;
      }
      sim.dispatch({
        type: 'DECREMENT_INTERVENTION',
        payload: key
      });
      var label = INTERVENTIONS[key] && INTERVENTIONS[key].label || key;
      addLogEntry("".concat(label, ": one dose removed from the count (facilitator correction)."), 'system');
    };

    // Nothing is ever disabled. An amber corner marker simply SHOWS what is not in place yet, so
    // the facilitator can see a sequence deviation before clicking without being prevented.
    var unmetFor = function unmetFor(action) {
      return window.getUnmetExpectations ? window.getUnmetExpectations(action, state) : [];
    };
    var renderActionBtn = function renderActionBtn(key) {
      var action = INTERVENTIONS[key];
      if (!action) return null;
      var count = interventionCounts[key] || 0;
      var isActive = activeInterventions.has(key);
      var variant = count > 0 || isActive ? "success" : "outline";
      var missing = unmetFor(action);
      var isContinuous = action.type === 'continuous';
      var btnTitle = missing.length ? "Not in place yet: ".concat(missing.join(', '), " \u2014 you can still do this, it will be flagged for the debrief.") : isActive && isContinuous ? "".concat(action.label, " is ACTIVE \u2014 pressing again STOPS it.") : action.label;
      // The remove control is a sibling of the main button, not a child: a button inside a
      // button is invalid and a "nested-interactive" accessibility failure.
      // A corner control (stop / remove one) sits over the top right of the tile: keep the
      // label clear of it, and never let a long label spill out of the tile.
      var hasCorner = isActive && isContinuous || !isActive && count > 0 && !isContinuous;
      return /*#__PURE__*/React.createElement("div", {
        key: key,
        className: "relative"
      }, /*#__PURE__*/React.createElement("button", {
        title: btnTitle,
        onClick: function onClick() {
          return applyIntervention(key);
        },
        className: "relative w-full h-14 p-2 rounded text-left bg-slate-700 hover:bg-slate-600 border flex flex-col justify-between overflow-hidden group/btn ".concat(isActive && isContinuous ? 'border-emerald-500 ring-1 ring-emerald-500/40' : missing.length ? 'border-amber-500/60' : 'border-slate-600')
      }, /*#__PURE__*/React.createElement("span", {
        "data-testid": "action-label",
        className: "text-xs font-bold leading-tight line-clamp-2 shrink-0 ".concat(missing.length ? 'pl-2.5' : '', " ").concat(hasCorner ? 'pr-6' : '', " ").concat(variant === 'success' ? 'text-emerald-400' : 'text-slate-200')
      }, action.label), /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between items-end w-full"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-[10px] truncate ".concat(isActive && isContinuous ? 'text-emerald-400 font-bold uppercase not-italic' : 'opacity-70 italic')
      }, isActive && isContinuous ? "Active \xB7 tap to stop" : action.route && action.route !== 'n/a' ? action.route : action.category), count > 0 && action.type !== 'continuous' && /*#__PURE__*/React.createElement("span", {
        className: "bg-emerald-700 text-white text-[9px] font-bold px-1.5 rounded-full shadow-md"
      }, "x", count)), missing.length > 0 && /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true",
        className: "absolute top-0 left-0 w-0 h-0 border-t-[14px] border-l-[14px] border-t-amber-500 border-l-transparent"
      }), activeDurations[key] && /*#__PURE__*/React.createElement("div", {
        className: "absolute bottom-0 left-0 h-1 bg-emerald-400 transition-all duration-1000",
        style: {
          width: "".concat(Math.max(0, 100 - (time - activeDurations[key].startTime) / activeDurations[key].duration * 100), "%")
        }
      })), isActive && action.type === 'continuous' && /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-label": "Stop ".concat(action.label),
        className: "absolute top-1 right-1 text-red-400 bg-slate-900/80 hover:bg-red-600 hover:text-white rounded-full p-1 cursor-pointer transition-colors z-10",
        onClick: function onClick(e) {
          return handleRemove(e, key, 'continuous');
        }
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-3 h-3"
      })), !isActive && count > 0 && action.type !== 'continuous' && /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-label": "Remove one ".concat(action.label, " from the count"),
        className: "absolute top-1 right-1 text-red-400 bg-slate-900/80 hover:bg-red-600 hover:text-white rounded-full p-1 cursor-pointer transition-colors z-10",
        onClick: function onClick(e) {
          return handleRemove(e, key, 'bolus');
        }
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "minus",
        className: "w-3 h-3"
      })));
    };
    var renderDrugsTab = function renderDrugsTab() {
      var allDrugs = Object.keys(INTERVENTIONS).filter(function (k) {
        return INTERVENTIONS[k].category === 'Drugs';
      }).sort();
      var groups = _objectSpread(_objectSpread({}, DRUG_GROUPS), {}, {
        "Other": allDrugs.filter(function (d) {
          return !KNOWN_DRUGS.has(d);
        })
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "space-y-4"
      }, Object.keys(groups).map(function (group) {
        if (groups[group].length === 0) return null;
        return /*#__PURE__*/React.createElement("div", {
          key: group
        }, /*#__PURE__*/React.createElement("h4", {
          className: "text-xs font-bold text-slate-400 uppercase mb-1 border-b border-slate-700 pb-1"
        }, group), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2"
        }, groups[group].map(function (key) {
          return renderActionBtn(key);
        })));
      }));
    };

    // A plausible starting split for a GCS total (or the last breakdown set, if it still adds up).
    var GCS_SPLIT = {
      15: [4, 5, 6],
      14: [3, 5, 6],
      13: [3, 4, 6],
      12: [3, 4, 5],
      11: [3, 3, 5],
      10: [2, 3, 5],
      9: [2, 2, 5],
      8: [2, 2, 4],
      7: [1, 2, 4],
      6: [1, 1, 4],
      5: [1, 1, 3],
      4: [1, 1, 2],
      3: [1, 1, 1]
    };
    var gcsSplit = function gcsSplit(total, last) {
      var t = Math.max(3, Math.min(15, Math.round(Number(total)) || 15));
      if (last && last.e + last.v + last.m === t) return _objectSpread({}, last);
      var _GCS_SPLIT$t = _slicedToArray(GCS_SPLIT[t], 3),
        e = _GCS_SPLIT$t[0],
        v = _GCS_SPLIT$t[1],
        m = _GCS_SPLIT$t[2];
      return {
        e: e,
        v: v,
        m: m
      };
    };
    var GCS_SCALE = {
      e: {
        label: 'Eyes (E)',
        options: [[4, 'Spontaneous'], [3, 'To voice'], [2, 'To pain'], [1, 'None']]
      },
      v: {
        label: 'Verbal (V)',
        options: [[5, 'Orientated'], [4, 'Confused'], [3, 'Words'], [2, 'Sounds'], [1, 'None']]
      },
      m: {
        label: 'Motor (M)',
        options: [[6, 'Obeys'], [5, 'Localises'], [4, 'Withdraws'], [3, 'Abnormal flexion'], [2, 'Extends'], [1, 'None']]
      }
    };
    var pickGcsPart = function pickGcsPart(k, n) {
      var next = _objectSpread(_objectSpread({}, gcsParts || gcsSplit(modalTarget)), {}, _defineProperty({}, k, n));
      setGcsParts(next);
      setModalTarget(next.e + next.v + next.m);
    };
    var gcsPartsLabel = function gcsPartsLabel(p) {
      return p ? "E".concat(p.e, " V").concat(p.v, " M").concat(p.m) : '';
    };

    // Every obs change defaults to NOW (Jake's request): it goes to the patient straight away.
    // 30 s, 2 min and 5 min are still there for a gradual change.
    var openVitalControl = function openVitalControl(key) {
      if (key === 'gcs') setGcsParts(gcsSplit(vitals.gcs, lastGcsParts));
      setModalVital(key);
      setModalTarget(vitals[key === 'bp' ? 'bpSys' : key]);
      if (key === 'bp') setModalTarget2(vitals.bpDia);
      setTrendDuration(0);
    };
    // A blank or non-numeric field used to reach the reducer as NaN, which then poisoned the Firebase
    // diff (RTDB rejects NaN) and froze the student monitor for the rest of the session.
    var validateVitalModal = function validateVitalModal() {
      if (modalVital === 'pupils') return modalTarget === '' || modalTarget === null ? 'Pupils is required.' : null;
      var field = modalVital === 'bp' ? 'bpSys' : modalVital;
      var err = window.validateBuilderField ? window.validateBuilderField(field, modalTarget) : null;
      if (err) return err;
      if (!Number.isFinite(parseFloat(modalTarget))) return 'Target must be a number.';
      if (modalVital === 'bp') {
        var err2 = window.validateBuilderField ? window.validateBuilderField('bpDia', modalTarget2) : null;
        if (err2) return err2;
        if (!Number.isFinite(parseFloat(modalTarget2))) return 'Diastolic must be a number.';
        if (parseFloat(modalTarget) <= parseFloat(modalTarget2)) return 'Systolic must be greater than diastolic.';
      }
      return null;
    };
    var vitalModalError = modalVital ? validateVitalModal() : null;

    // Same NaN-into-Firebase hazard as the vitals modal — the NIBP reading is synced too.
    var nibpError = function () {
      if (!showNIBPModal) return null;
      var e1 = window.validateBuilderField ? window.validateBuilderField('bpSys', nibpSys) : null;
      if (e1) return e1;
      var e2 = window.validateBuilderField ? window.validateBuilderField('bpDia', nibpDia) : null;
      if (e2) return e2;
      if (parseFloat(nibpSys) <= parseFloat(nibpDia)) return 'Systolic must be greater than diastolic.';
      return null;
    }();

    // `cycleCuff` (BP only): also measure now, so the team's NIBP shows the new value once the
    // cuff has inflated (~5 s). Without it the patient's BP changes but the monitor keeps its
    // last reading until the cuff next cycles — the team's press, yours, or the auto timer.
    var confirmVitalUpdate = function confirmVitalUpdate() {
      var cycleCuff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (vitalModalError) return;
      var targets = {};
      if (modalVital === 'bp') {
        targets.bpSys = parseFloat(modalTarget);
        targets.bpDia = parseFloat(modalTarget2);
      } else if (modalVital === 'pupils') {
        targets.pupils = modalTarget;
      } else {
        targets[modalVital] = parseFloat(modalTarget);
      }
      if (modalVital === 'gcs') {
        var parts = gcsParts && gcsParts.e + gcsParts.v + gcsParts.m === targets.gcs ? gcsParts : null;
        setLastGcsParts(parts);
        if (parts) addLogEntry("GCS set to ".concat(targets.gcs, " (").concat(gcsPartsLabel(parts), ")"), 'manual');
      }
      if (trendDuration === 0) sim.manualUpdateVitals(targets);else startTrend(targets, trendDuration);
      // The cuff reads the patient when it finishes inflating (~5 s), by which time an
      // immediate change has landed.
      if (modalVital === 'bp' && trendDuration === 0 && cycleCuff && sensors.nibp) {
        triggerNIBP();
        addLogEntry('NIBP cycled by facilitator to show the new BP', 'manual');
      }
      setModalVital(null);
    };
    var VITAL_NAMES = {
      hr: 'Heart rate',
      bp: 'Blood pressure',
      spO2: 'SpO2',
      rr: 'Respiratory rate',
      temp: 'Temperature',
      bm: 'Glucose',
      etco2: 'ETCO2',
      gcs: 'GCS',
      ph: 'pH',
      k: 'Potassium (K+)',
      pupils: 'Pupils'
    };

    // Paediatric arrests are weight-based (4 J/kg). The energy ladder and the recommended
    // dose both come from the registry, so the controller, the monitor-hosted defib and the
    // standalone defib page cannot disagree about what 3.5 kg or 10 kg needs.
    var energySteps = sim.defibEnergySteps ? sim.defibEnergySteps() : RG.ADULT_ENERGY_STEPS;
    var recommendedEnergy = sim.recommendedShockEnergy ? sim.recommendedShockEnergy() : RG.ADULT_DEFAULT_ENERGY;
    var shockEnergy = Number.isFinite(Number(defib.energy)) && Number(defib.energy) > 0 ? Math.round(Number(defib.energy)) : recommendedEnergy;
    var getTrend = function getTrend(key) {
      if (!trends.active || !trends.targets || trends.targets[key] === undefined) return null;
      var d = trends.durations ? Number(trends.durations[key]) : Number(trends.duration);
      var e = trends.durations ? Number((trends.elapsedBy || {})[key]) || 0 : Number(trends.elapsed) || 0;
      return {
        active: true,
        progress: d > 0 ? Math.min(1, e / d) : 1,
        target: trends.targets[key]
      };
    };
    var addTimerAlert = function addTimerAlert() {
      var mins = Number(newAlertMins);
      if (!newAlertMsg.trim()) {
        setTimerAlertError('Enter an alert message.');
        return;
      }
      if (!Number.isFinite(mins) || mins < 0.5 || mins > 180) {
        setTimerAlertError('Alert time must be between 0.5 and 180 minutes.');
        return;
      }
      setTimerAlerts(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: Date.now(),
          mins: mins,
          msg: newAlertMsg.trim()
        }]);
      });
      setNewAlertMsg('');
      setNewAlertMins('5');
      setTimerAlertError('');
    };

    // Flagged entries are the debrief's teaching artefacts: sequence deviations recorded by the
    // permissive gating, plus shocks and anything the facilitator flagged by hand.
    var flaggedEntries = state.log.filter(function (l) {
      return l.flagged;
    });
    // ---- WAVE 5 / ITEM 3: THE COUNTER MUST MATCH THE LIST --------------------------------
    // `flagged: true` is used for TWO different things: a genuine prerequisite deviation (which
    // always also carries a structured `deviation` record) and mere SIGNIFICANCE, so that arrests,
    // shocks and hand-flagged moments stand out in the debrief timeline. The toolbar chip counted
    // every flagged entry, so a run with two real deviations plus an arrest and four shocks read
    // "Safety flags (7)" while the Sequence Deviations list below it correctly showed 2 — the
    // facilitator could not tell which number to believe.
    // The chip now counts ONLY deviations, and the significance flag keeps its debrief-timeline
    // behaviour untouched (it is still what highlights those rows, here and in debrief.js).
    var deviationEntries = flaggedEntries.filter(function (l) {
      return l.deviation && Array.isArray(l.deviation.missing);
    });
    var significanceEntries = flaggedEntries.filter(function (l) {
      return !(l.deviation && Array.isArray(l.deviation.missing));
    });

    // The flow is now CHOOSE / CUSTOMISE, then SEND. Opening the chooser sends nothing, and
    // dismissing it sends nothing and does not wipe a result already on the student monitor.
    // "Clear result on monitor" is a separate, explicitly-labelled destructive action.
    var handleInvClick = function handleInvClick(type) {
      setInvModal(type);
      setInvCustomText("");
    };
    var sendInv = function sendInv(type, text, image) {
      revealInvestigation(type, text, {
        image: image || null,
        hideReport: !!image && !invWithReport
      });
      setInvModal(null);
    };
    // Passing null makes the engine/monitor resolve the scenario's OWN authored finding.
    // The previous "Scenario Default" button sent the literal placeholder string
    // "Abnormal (See scenario)" to the students' screen.
    // A course scenario (e.g. ETC) with a course image of this type sends that image, the course's
    // own picture, unless the facilitator has changed the result; when it cannot be loaded, the
    // scenario's written result goes instead. courseMedia and showCourseImage are defined below.
    var sendScenarioDefault = function sendScenarioDefault(type) {
      setInvModal(null);
      var changed = !!(scenario && scenario.invChanged && scenario.invChanged[type]);
      var item = !changed && courseMediaRef.current.find(function (m) {
        return m.type === type;
      });
      if (item) {
        showCourseImage(item, invWithReport).then(function (ok) {
          if (!ok) revealInvestigation(type, null, {
            hideReport: !invWithReport
          });
        });
        return;
      }
      revealInvestigation(type, null, {
        hideReport: !invWithReport
      });
    };
    // What "Scenario finding" will show, so the facilitator can see it before sending.
    var INV = window.INVESTIGATIONS;
    var scenarioResultPreview = function scenarioResultPreview(type) {
      var KEYS = {
        'X-ray': 'chestXray',
        CT: 'ct',
        POCUS: 'pocus',
        ECG: 'ecg',
        Urine: 'urine',
        VBG: 'vbg'
      };
      var k = KEYS[type];
      if (!k || !scenario) return null;
      // Everything but the gas: exactly what the monitor will show (data/investigations.js resolveResult).
      if (type !== 'VBG' && INV && INV.resolveResult) {
        var r = INV.resolveResult(scenario, type, {
          rhythm: state.rhythm,
          age: scenario.patientAge
        });
        var top0 = scenario[k],
          gen0 = (scenario.investigations || {})[k];
        var authoredEcg = type === 'ECG' && (gen0 && gen0.image || top0 && top0.image);
        var _image = r.image || r.images[0] && r.images[0].key || null;
        return {
          text: r.text || (r.live12 ? '12-lead drawn from the current rhythm.' : null),
          image: _image,
          ecgImageNotFitting: !!authoredEcg && !r.image
        };
      }
      var top = scenario[k],
        gen = (scenario.investigations || {})[k];
      var src = type === 'ECG' ? gen : top && (top.findings || top.image) ? top : gen;
      if (!src) return null;
      var text = typeof src === 'string' ? src : src.findings || null;
      if (type === 'ECG' && gen && gen.imageReport) text = gen.imageReport;
      if (!text && type === 'Urine') text = Object.keys(src).map(function (x) {
        return "".concat(x, ": ").concat(src[x]);
      }).join(', ');
      if (!text && type === 'POCUS') text = ['heart', 'lungs', 'abdo', 'aorta', 'ivc'].filter(function (x) {
        return src[x];
      }).map(function (x) {
        return src[x];
      }).join(' ');
      if (!text && type === 'VBG') text = "pH ".concat(src.pH, ", pCO2 ").concat(src.pCO2, ", lactate ").concat(src.Lac, ", K ").concat(src.K, ", glucose ").concat(src.Glu);
      var image = src && src.image || null;
      var imgFits = image && (type !== 'ECG' || INV && INV.ecgImageFits(image, state.rhythm));
      return {
        text: text,
        image: imgFits ? image : null,
        ecgImageNotFitting: !!image && !imgFits
      };
    };
    var dismissInv = function dismissInv() {
      return setInvModal(null);
    };
    // The closed "Investigation results" section says which results the facilitator has changed.
    var invChangedSummary = function invChangedSummary(sc) {
      var ch = Object.keys(sc && sc.invChanged || {});
      return ch.length ? "Changed: ".concat(ch.join(', ')) : "Scenario's own results";
    };
    // Course images (restricted course scenarios, e.g. ETC): sent from the mark sheet or from the
    // result chooser. The copy on the session is removed when this screen closes.
    var MSX = window.MarkScheme;
    var courseMedia = MSX && MSX.media && scenario ? MSX.media(scenario) : [];
    var courseMediaRef = useRef(courseMedia);
    courseMediaRef.current = courseMedia;
    var showCourseImage = function showCourseImage(item, withReport) {
      return MSX.showOnMonitor({
        sim: sim,
        sessionID: sessionID,
        scenario: scenario,
        item: item,
        withReport: withReport
      });
    };
    useEffect(function () {
      return function () {
        if (courseMedia.length && MSX && MSX.clearMonitorImage) MSX.clearMonitorImage(sessionID);
      };
    }, [sessionID, courseMedia.length]);
    var clearInvOnMonitor = function clearInvOnMonitor() {
      clearInvestigation();
      setInvModal(null);
      addLogEntry('Results and images cleared from the patient screens', 'system');
    };

    // A narrow monitor panel (small laptop, or dragged narrow) gets the compact tiles too: the
    // large tiles size their numbers by SCREEN width, so in a narrow panel "120/75" was clipped.
    var panelPx = panel.prefs.width !== null ? panel.prefs.width : (window.innerWidth || 1280) * 0.34;
    var narrowPanel = panelPx < 420;
    // A short screen (a 1366x768 or 1024x768 laptop) gets the compact tiles as well, and "More
    // obs" starts closed (its summary still shows GCS and glucose), so the obs tiles and the
    // Rhythm & resus controls are all on screen without scrolling.
    var shortScreen = (window.innerHeight || 1000) < 900;
    var compactTiles = narrowPanel || shortScreen;
    // The vital tiles. The core six (HR, BP, SpO2, RR, Temp, ETCO2) are the big tiles in the
    // desktop panel; GCS and glucose sit in a smaller "More obs" row beneath them. The phone view
    // shows all eight, compact, core first. pH and K+ are not obs: they are what the VBG reports,
    // so they are set and shown with the VBG result (Investigation results, data/screens/invresults.js).
    // The tiles always show the patient's TRUE value (the facilitator must be able to steer a
    // vital before its sensor goes on); the amber note says when the team cannot currently see it.
    var tileProps = function tileProps(compact) {
      return {
        compact: compact,
        medium: !compact,
        visible: true
      };
    };
    var coreTiles = function coreTiles(compact) {
      return [/*#__PURE__*/React.createElement(VitalDisplay, _extends({
        key: "hr"
      }, tileProps(compact), {
        label: "HR",
        value: vitals.hr,
        onClick: function onClick() {
          return openVitalControl('hr');
        },
        trend: getTrend('hr'),
        note: sEcg ? null : 'not on monitor'
      })),
      /*#__PURE__*/
      // BP opens the same control as every other vital, so it sets the patient's actual BP
      // (with a ramp if wanted), not just the displayed cuff reading.
      React.createElement(VitalDisplay, _extends({
        key: "bp"
      }, tileProps(compact), {
        label: "BP",
        value: vitals.bpSys,
        value2: vitals.bpDia,
        onClick: function onClick() {
          return openVitalControl('bp');
        },
        trend: getTrend('bpSys'),
        note: sensors.art ? null : state.nibp && state.nibp.sys ? "".concat(sensors.nibp ? 'cuff' : 'cuff off · last', " ").concat(state.nibp.sys, "/").concat(state.nibp.dia) : sensors.nibp ? 'cuff not cycled' : 'not on monitor'
      })), /*#__PURE__*/React.createElement(VitalDisplay, _extends({
        key: "spo2"
      }, tileProps(compact), {
        label: "SpO2",
        value: vitals.spO2,
        onClick: function onClick() {
          return openVitalControl('spO2');
        },
        trend: getTrend('spO2'),
        note: sSpo2 ? null : 'not on monitor'
      })), /*#__PURE__*/React.createElement(VitalDisplay, _extends({
        key: "rr"
      }, tileProps(compact), {
        label: "RR",
        value: vitals.rr,
        onClick: function onClick() {
          return openVitalControl('rr');
        },
        trend: getTrend('rr'),
        note: sResp ? null : 'not on monitor'
      })), /*#__PURE__*/React.createElement(VitalDisplay, _extends({
        key: "temp"
      }, tileProps(compact), {
        label: "Temp",
        value: vitals.temp,
        unit: "\xB0C",
        onClick: function onClick() {
          return openVitalControl('temp');
        },
        trend: getTrend('temp'),
        note: sensors.temp ? null : 'not on monitor'
      })), /*#__PURE__*/React.createElement(VitalDisplay, _extends({
        key: "etco2"
      }, tileProps(compact), {
        label: "ETCO2",
        value: vitals.etco2,
        unit: "kPa",
        onClick: function onClick() {
          return openVitalControl('etco2');
        },
        trend: getTrend('etco2'),
        note: sensors.etco2 ? null : 'not on monitor'
      }))];
    };
    var moreTiles = function moreTiles() {
      return [/*#__PURE__*/React.createElement(VitalDisplay, {
        key: "gcs",
        compact: true,
        visible: true,
        label: "GCS",
        value: vitals.gcs,
        onClick: function onClick() {
          return openVitalControl('gcs');
        },
        trend: getTrend('gcs'),
        note: lastGcsParts && lastGcsParts.e + lastGcsParts.v + lastGcsParts.m === Math.round(vitals.gcs) ? gcsPartsLabel(lastGcsParts) : null
      }), /*#__PURE__*/React.createElement(VitalDisplay, {
        key: "bm",
        compact: true,
        visible: true,
        label: "Glucose",
        value: vitals.bm,
        unit: "mmol",
        onClick: function onClick() {
          return openVitalControl('bm');
        },
        trend: getTrend('bm'),
        note: pocReadings.bm ? "POC ".concat(pocReadings.bm.clock) : 'POC not checked'
      })];
    };
    var renderVitalTiles = function renderVitalTiles() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, coreTiles(true), moreTiles());
    };

    // One-line summaries shown on a closed section.
    var yesNo = function yesNo(b) {
      return b ? "\u2713" : "\u2717";
    };
    var monitoringSummary = "".concat(sensors.all ? 'All on' : sensors.standard ? 'Standard on' : anyMonitorOn ? 'Partly on' : 'Nothing attached', " \xB7 IV ").concat(yesNo(sensors.iv), " \xB7 Art line ").concat(yesNo(sensors.art), " \xB7 CO2 ").concat(yesNo(sensors.etco2));
    var drugSummary = activeDrugRows.length ? "".concat(activeDrugRows[0].label, ": ").concat((PHASE_STYLE[activeDrugRows[0].phase] || {
      label: String(activeDrugRows[0].phase)
    }).label.toLowerCase()).concat(activeDrugRows[0].sustained && !activeDrugRows[0].stopped ? ', running' : Number.isFinite(activeDrugRows[0].remaining) ? ", ".concat(fmtRemaining(activeDrugRows[0].remaining), " left") : '').concat(activeDrugRows.length > 1 ? " (+".concat(activeDrugRows.length - 1, " more)") : '') : '';
    var conditionSummary = deteriorationMode === 'auto' ? "AUTO \u2014 deteriorating on its own" : "MANUAL \u2014 obs change only when you change them";
    // The ventilator (transport ventilator, the ICU ventilator or the anaesthetic machine): on the room monitor or its own tablet, the lungs it ventilates, and what
    // each linked ventilator is showing right now (sessions/<CODE>/ventState).
    var VP = window.VENT_PROFILES;
    var ventPanelOpen = !!state.ventPanelOpen;
    var ventCfg = state.vent || {
      profile: VP ? VP.profileForScenario(rawScenario) : 'normal',
      breathing: null
    };
    var VE = window.VENT_ENGINE;
    var ventLinkOn = state.ventLink !== false;
    var ventDriver = VE ? VE.driverFor(state) : null;
    var VENT_KEY_NAMES = {
      spO2: 'SpO2',
      rr: 'RR',
      etco2: 'ETCO2',
      hr: 'HR',
      bpSys: 'BP',
      bpDia: 'BP'
    };
    var ventHeld = VE ? VE.DRIVEN.concat(VE.NUDGED).filter(function (k) {
      return state.manualHold && state.manualHold[k];
    }) : [];
    var ventLung = VP ? VP.lungFor(ventCfg) : null;
    var ventMirrors = Object.keys(state.ventMirror || {}).map(function (k) {
      return _objectSpread({
        id: k
      }, state.ventMirror[k]);
    });
    var VENT_STATE_LABEL = {
      off: 'Off',
      selftest: 'Self-test',
      ambient: 'Ambient (not ventilating)',
      standby: 'Standby',
      ventilating: 'Ventilating'
    };
    var ventSummary = ventMirrors.length ? ventMirrors.map(function (m) {
      return "".concat(VENT_STATE_LABEL[m.state] || m.state).concat(m.state === 'ventilating' ? " ".concat(m.label) : '').concat(m.alarms ? " \xB7 ALARM" : '');
    }).join(' | ') : "".concat(ventPanelOpen ? 'On the room monitor' : 'Not connected', " \xB7 ").concat(ventLung ? ventLung.name : '');
    var resusSummary = "".concat(RG.labelFor(state.rhythm), " \xB7 ").concat(defib.shockCount || 0, " shock").concat((defib.shockCount || 0) === 1 ? '' : 's').concat(cprInProgress ? " \xB7 CPR on" : '');
    var trendBetter = function trendBetter() {
      sim.dispatch({
        type: 'TRIGGER_IMPROVE'
      });
      addLogEntry("Patient Improving (Trend)", "success");
    };
    var trendWorse = function trendWorse() {
      sim.dispatch({
        type: 'TRIGGER_DETERIORATE'
      });
      addLogEntry("Patient Deteriorating (Trend)", "danger");
    };
    // Auto/Manual and Trend Better/Worse: ONE set of controls, shown in one place only (see below).
    var conditionButtons = /*#__PURE__*/React.createElement("span", {
      className: "flex gap-1 flex-none",
      "data-testid": "condition-quick"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return sim.toggleDeteriorationMode && sim.toggleDeteriorationMode();
      },
      "aria-pressed": deteriorationMode === 'auto',
      title: "".concat(deteriorationMode === 'auto' ? 'Deterioration is AUTO: click to go MANUAL' : 'Deterioration is MANUAL: click to go AUTO', ". ").concat(detInfo.declared ? "Scenario: ".concat(detInfo.type, " at rate ").concat(detInfo.rate, ". Treating the cause slows, then reverses it.") : 'This scenario declares no deterioration rate, so AUTO would change nothing.'),
      className: "h-6 px-2 rounded text-[10px] font-bold uppercase border ".concat(deteriorationMode === 'auto' ? 'bg-amber-700 border-amber-400 text-white' : 'bg-slate-800 border-slate-500 text-slate-200')
    }, deteriorationMode === 'auto' ? 'Auto' : 'Manual'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: trendBetter,
      title: "Trend the patient BETTER (logged)",
      className: "h-6 px-2 rounded text-[10px] font-bold uppercase bg-emerald-900 border border-emerald-500 text-emerald-100 hover:bg-emerald-800"
    }, "Better"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: trendWorse,
      title: "Trend the patient WORSE (logged)",
      className: "h-6 px-2 rounded text-[10px] font-bold uppercase bg-red-900 border border-red-500 text-red-100 hover:bg-red-800"
    }, "Worse"));
    // Quick Sim has no Auto deterioration, only Trend Better / Worse. With its rhythm column folded away
    // they sit on the More obs row instead (one set on screen at a time).
    var trendOnlyButtons = /*#__PURE__*/React.createElement("span", {
      className: "flex gap-1 flex-none",
      "data-testid": "trend-quick"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: trendBetter,
      title: "Trend the patient BETTER (logged)",
      className: "h-6 px-2 rounded text-[10px] font-bold uppercase bg-emerald-900 border border-emerald-500 text-emerald-100 hover:bg-emerald-800"
    }, "Better"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: trendWorse,
      title: "Trend the patient WORSE (logged)",
      className: "h-6 px-2 rounded text-[10px] font-bold uppercase bg-red-900 border border-red-500 text-red-100 hover:bg-red-800"
    }, "Worse"));
    // Patient condition: AUTO/MANUAL deterioration and the Trend buttons (placed under the obs, see below).
    var conditionSection = function conditionSection() {
      var extraClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return /*#__PURE__*/React.createElement(Section, {
        id: "condition",
        className: extraClass,
        tone: deteriorationMode === 'auto' ? 'amber' : 'default',
        title: "Patient condition",
        summary: conditionSummary,
        defaultOpen: false,
        right: conditionButtons
      }, /*#__PURE__*/React.createElement("div", {
        title: "Switching either way leaves the obs exactly where they are; there is no jump in either direction.",
        className: "flex items-center justify-between gap-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "min-w-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-sm font-bold ".concat(deteriorationMode === 'auto' ? 'text-amber-300' : 'text-slate-200')
      }, deteriorationMode === 'auto' ? "AUTO \u2014 deteriorating on its own" : "MANUAL \u2014 obs only change when you change them"), /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-slate-400 mt-0.5"
      }, detInfo.declared ? "Scenario: ".concat(detInfo.type, " at rate ").concat(detInfo.rate, ". Treating the cause slows, then reverses it.") : 'This scenario declares no deterioration rate, so AUTO would change nothing.')), /*#__PURE__*/React.createElement(Button, {
        ariaLabel: deteriorationMode === 'auto' ? 'Switch deterioration to MANUAL' : 'Switch deterioration to AUTO',
        variant: deteriorationMode === 'auto' ? 'warning' : 'secondary',
        onClick: function onClick() {
          return sim.toggleDeteriorationMode && sim.toggleDeteriorationMode();
        },
        className: "h-9 px-3 flex-none font-bold text-[11px] uppercase"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: deteriorationMode === 'auto' ? 'pause' : 'play',
        className: "w-4 h-4 mr-1"
      }), deteriorationMode === 'auto' ? 'Go MANUAL' : 'Go AUTO')));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full overflow-hidden max-md:h-auto max-md:overflow-visible flex flex-col p-2 bg-slate-900 relative ".concat(flash === 'red' ? 'flash-red' : flash === 'green' ? 'flash-green' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixed bottom-3 max-md:w-[92vw] md:max-w-2xl left-1/2 -translate-x-1/2 z-50 bg-slate-800 border-l-4 rounded shadow-2xl px-6 py-3 transition-all duration-300 ".concat(showToast ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none', " ").concat((notification === null || notification === void 0 ? void 0 : notification.type) === 'danger' ? 'border-red-500' : (notification === null || notification === void 0 ? void 0 : notification.type) === 'success' ? 'border-emerald-500' : (notification === null || notification === void 0 ? void 0 : notification.type) === 'warning' ? 'border-amber-500' : 'border-sky-500')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: (notification === null || notification === void 0 ? void 0 : notification.type) === 'danger' || (notification === null || notification === void 0 ? void 0 : notification.type) === 'warning' ? 'alert-triangle' : (notification === null || notification === void 0 ? void 0 : notification.type) === 'success' ? 'check-circle' : 'info',
      className: "w-5 h-5 ".concat((notification === null || notification === void 0 ? void 0 : notification.type) === 'danger' ? 'text-red-500' : (notification === null || notification === void 0 ? void 0 : notification.type) === 'warning' ? 'text-amber-500' : (notification === null || notification === void 0 ? void 0 : notification.type) === 'success' ? 'text-emerald-500' : 'text-sky-500')
    }), /*#__PURE__*/React.createElement("span", {
      className: "font-bold text-white"
    }, notification === null || notification === void 0 ? void 0 : notification.msg))), rhythmEvent && /*#__PURE__*/React.createElement("div", {
      role: "status",
      className: "fixed bottom-20 max-md:w-[92vw] md:max-w-2xl left-1/2 -translate-x-1/2 z-50 rounded shadow-2xl px-6 py-3 border-l-4 animate-fadeIn ".concat(rhythmEvent.converted ? 'bg-slate-800 border-amber-400' : 'bg-slate-800/90 border-slate-500')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "activity",
      className: "w-5 h-5 ".concat(rhythmEvent.converted ? 'text-amber-400' : 'text-slate-400')
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase tracking-widest text-slate-400 font-bold"
    }, rhythmEvent.converted ? 'Rhythm converted' : 'Rhythm unchanged'), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-white text-sm"
    }, RG.labelFor(rhythmEvent.from), " ", /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "\u2192"), " ", RG.labelFor(rhythmEvent.to)), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-amber-300/80"
    }, rhythmEvent.detail || rhythmEvent.cause)))), /*#__PURE__*/React.createElement("div", {
      className: "md:hidden mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 mb-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 flex-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase tracking-widest text-slate-400 font-bold leading-none whitespace-nowrap"
    }, "Obs \xB7 ", sensors.any ? 'tap to change' : /*#__PURE__*/React.createElement("span", {
      className: "text-amber-400",
      "data-testid": "phone-none-on-monitor"
    }, "none on monitor")), /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold truncate ".concat(RG.isPulseless(state.rhythm) ? 'text-red-300' : 'text-white')
    }, RG.labelFor(state.rhythm))), /*#__PURE__*/React.createElement("div", {
      className: "font-mono text-xl font-bold text-white"
    }, formatTime(clockSeconds)), !isRunning ? /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      onClick: start,
      className: "h-9 px-3 font-bold text-sm ".concat(notStarted ? 'ring-2 ring-amber-400' : '')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "play",
      className: "w-4 h-4"
    }), " START") : /*#__PURE__*/React.createElement(Button, {
      variant: "warning",
      onClick: pause,
      className: "h-9 px-3 font-bold text-sm"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "pause",
      className: "w-4 h-4"
    }), " PAUSE")), setUpButton('mb-1 w-full justify-center'), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 min-[400px]:grid-cols-4 gap-1 ".concat(sensors.any ? '' : '[&_[data-off-monitor]]:hidden')
    }, renderVitalTiles())), /*#__PURE__*/React.createElement("div", {
      "data-testid": "controller-toolbar",
      "data-setup": notStarted ? 'true' : undefined,
      className: "flex flex-wrap justify-between items-center gap-y-2 p-2 rounded mb-2 border ".concat(notStarted ? 'bg-amber-950/70 border-amber-500 ring-2 ring-amber-400/70' : 'bg-slate-800 border-slate-700')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2 items-center relative z-20"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      ariaLabel: "Back",
      onClick: onBack,
      className: "h-8 px-2 whitespace-nowrap"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "arrow-left"
    }), /*#__PURE__*/React.createElement("span", {
      className: "max-md:hidden ml-1"
    }, "Back")), /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      onClick: confirmFinish,
      className: "h-8 px-2 font-bold whitespace-nowrap"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "square"
    }), " Finish"), hasMarkSheet && /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return setShowMarkSheet(true);
      },
      className: "h-8 px-2 whitespace-nowrap text-fuchsia-300 border-fuchsia-600/60"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "clipboard-check"
    }), " Mark sheet"), !isRunning ? /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      onClick: start,
      className: "h-8 px-4 font-bold max-md:hidden ".concat(notStarted ? 'ring-2 ring-amber-400' : '')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "play"
    }), " START") : /*#__PURE__*/React.createElement(Button, {
      variant: "warning",
      onClick: pause,
      className: "h-8 px-4 max-md:hidden"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "pause"
    }), " PAUSE"), notStarted && /*#__PURE__*/React.createElement(NotStartedBadge, {
      className: "max-md:hidden"
    }), setUpButton('max-md:hidden'), showSetup && PS && PS.PatientSetup && /*#__PURE__*/React.createElement(PS.PatientSetup, {
      sim: sim,
      addLogEntry: addLogEntry,
      onClose: function onClose() {
        return setShowSetup(false);
      }
    }), !isRunning && !notStarted && !state.isFinished && /*#__PURE__*/React.createElement("span", {
      "data-testid": "paused-badge",
      role: "status",
      className: "max-md:hidden h-8 px-2 flex items-center rounded border border-slate-500 bg-slate-900 text-slate-200 text-[11px] font-bold uppercase tracking-wider"
    }, "Paused")), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-2"
    }, function () {
      // A defib or ventilator loaded inside a patient screen reports itself as well
      // (role monitor-defib / monitor-vent); count the screens, not the pages.
      var screens = remoteClients.filter(function (c) {
        return !/^monitor-/.test(String(c.role || ''));
      });
      var n = screens.length;
      var shows = Array.from(new Set(screens.map(function (c) {
        return c.display || 'patient monitor';
      })));
      var linked = n === 0 ? 'no screens linked' : n === 1 ? shows[0] : "".concat(n, " screens linked");
      var label = syncProblem ? 'Sync error' : syncStatus.state === 'connected' ? "Live \xB7 ".concat(linked) : 'Syncing';
      // A phone gets the short form ("No screens", "2 screens") so the toolbar is two rows, not three.
      var shortLabel = syncProblem || syncStatus.state !== 'connected' ? label : n === 0 ? 'No screens' : n === 1 ? shows[0] : "".concat(n, " screens");
      var tip = [syncStatus.message || (syncStatus.state === 'connected' ? 'Live session sync is active.' : 'Connecting to the live session.'), n === 0 ? 'No patient screen is linked. Use Screens to open one, or Join by QR code.' : screens.map(function (c) {
        return "".concat(c.display || 'patient monitor', " (last seen ").concat(Math.max(0, Math.round((Date.now() - Number(c.ts)) / 1000)), "s ago)");
      }).join('\n')].join('\n');
      var tone = syncProblem ? 'border-red-500 bg-red-950/60 text-red-300' : syncStatus.state !== 'connected' ? 'border-amber-600 bg-amber-950/40 text-amber-300' : n === 0 ? 'border-emerald-800 bg-emerald-950/30 text-emerald-300' : 'border-sky-700 bg-sky-950/40 text-sky-300';
      return /*#__PURE__*/React.createElement("div", {
        role: syncProblem ? 'alert' : 'status',
        title: tip,
        "data-testid": "connection-badge",
        className: "h-8 px-2 flex items-center gap-1 rounded border text-[10px] uppercase font-bold whitespace-nowrap ".concat(tone)
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: syncProblem ? 'wifi-off' : n === 0 ? 'wifi' : shows.includes('defib') ? 'zap' : 'monitor',
        className: "w-3 h-3"
      }), /*#__PURE__*/React.createElement("span", {
        className: "max-md:hidden"
      }, label), /*#__PURE__*/React.createElement("span", {
        className: "md:hidden"
      }, shortLabel));
    }(), !quickSim && deviationEntries.length > 0 && /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Review ".concat(deviationEntries.length, " sequence deviations"),
      variant: "outline",
      onClick: function onClick() {
        return setShowFlagsModal(true);
      },
      className: "h-8 px-2 text-amber-400 border-amber-500/60 bg-amber-950/30 text-[10px] uppercase font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "flag",
      className: "w-3 h-3 mr-1"
    }), " Safety flags (", deviationEntries.length, ")"), isMuted && /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Unmute alarms",
      variant: "danger",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_MUTED',
          payload: false
        });
      },
      className: "h-8 px-2 text-[10px] uppercase font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "volume-x",
      className: "w-4 h-4 mr-1"
    }), " Muted"), /*#__PURE__*/React.createElement("div", {
      className: "max-xl:hidden"
    }, /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Patient screen volume ".concat(Math.round(volumePct), "%"),
      variant: "outline",
      onClick: function onClick() {
        return setShowVolume(function (o) {
          return !o;
        });
      },
      className: "h-8 px-2 text-xs font-bold ".concat(volumePct === 0 ? 'text-red-400 border-red-500/60' : 'text-slate-200 border-slate-500/60')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: volumePct === 0 ? 'volume-x' : 'volume-2',
      className: "w-4 h-4 md:mr-1"
    }), /*#__PURE__*/React.createElement("span", {
      className: "max-md:hidden"
    }, Math.round(volumePct), "%"))), showVolume && /*#__PURE__*/React.createElement("div", {
      "data-testid": "volume-panel",
      className: "fixed right-4 top-16 z-50 w-72 max-w-[calc(100vw-2rem)] bg-slate-900 border border-slate-600 rounded shadow-2xl p-3 space-y-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "volumeSlider",
      className: "text-xs font-bold text-slate-300 uppercase"
    }, "Patient screen volume"), /*#__PURE__*/React.createElement("span", {
      className: "font-mono text-sm text-white"
    }, Math.round(volumePct), "%")), /*#__PURE__*/React.createElement("input", {
      id: "volumeSlider",
      type: "range",
      min: "0",
      max: "150",
      step: "10",
      value: Math.round(volumePct),
      onChange: function onChange(e) {
        return setVolume(Number(e.target.value) / 100);
      },
      className: "w-full accent-sky-500"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between text-[10px] text-slate-400"
    }, /*#__PURE__*/React.createElement("span", null, "Off"), /*#__PURE__*/React.createElement("span", null, "Normal (100%)"), /*#__PURE__*/React.createElement("span", null, "Max")), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setVolume(volumePct === 0 ? lastVolumeRef.current || 1 : 0);
      },
      variant: volumePct === 0 ? 'danger' : 'secondary',
      className: "h-9 flex-1 text-xs"
    }, volumePct === 0 ? 'Unmute' : 'Mute all'), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return sim.dispatch({
          type: 'TRIGGER_SOUND',
          payload: 'VolumeTest'
        });
      },
      variant: "secondary",
      className: "h-9 flex-1 text-xs"
    }, "Test sound")), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400"
    }, "Sets the monitor, defib, ventilator and patient voice on every patient screen. Above 100% the quieter sounds (pulse beep, voice) get louder; the alarms are already near the most a device can play."), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowVolume(false);
      },
      variant: "outline",
      className: "h-8 w-full text-xs"
    }, "Done")), /*#__PURE__*/React.createElement(ViewModeToggle, null), window.ScreenDeviceWarning && /*#__PURE__*/React.createElement(window.ScreenDeviceWarning, {
      state: state,
      onOpen: function onOpen() {
        return setShowJoin(true);
      }
    }), /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Screens: add patient screens and choose what each one shows",
      variant: "outline",
      onClick: function onClick() {
        return setShowJoin(true);
      },
      className: "h-8 px-2 text-sky-300 border-sky-500/50 text-xs font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-4 h-4 md:mr-1"
    }), /*#__PURE__*/React.createElement("span", {
      className: "max-md:hidden"
    }, "Screens")), /*#__PURE__*/React.createElement(MenuButton, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "max-md:hidden"
      }, "Tools"),
      icon: "settings",
      ariaLabel: "Tools: drug calculator, timer alerts, log, sound and shortcuts",
      items: [{
        label: 'Drug calculator',
        icon: 'pill',
        hint: 'D',
        onClick: function onClick() {
          return setShowDrugCalc(true);
        }
      }, {
        label: 'Timer alerts',
        icon: 'bell',
        hint: 'T',
        onClick: function onClick() {
          return setShowTimerModal(true);
        }
      }, {
        label: 'Full simulation log',
        icon: 'list',
        onClick: function onClick() {
          return setShowLogModal(true);
        }
      }, {
        label: "Sound plays on: ".concat(audioOutput === 'both' ? 'both' : audioOutput === 'controller' ? 'this controller' : 'room monitor'),
        icon: 'volume-2',
        hint: 'change',
        onClick: cycleAudioOutput
      }, {
        label: "Patient screen volume: ".concat(Math.round(volumePct), "%"),
        icon: 'volume-2',
        onClick: function onClick() {
          return setShowVolume(true);
        }
      }, {
        label: isMuted ? 'Unmute alarms' : 'Mute alarms',
        icon: isMuted ? 'volume-2' : 'volume-x',
        onClick: function onClick() {
          return sim.dispatch({
            type: 'SET_MUTED',
            payload: !isMuted
          });
        }
      }, {
        label: 'Keyboard shortcuts',
        icon: 'info',
        hint: '?',
        onClick: function onClick() {
          return setShowKeyHelp(true);
        }
      }]
    }), /*#__PURE__*/React.createElement("div", {
      className: "font-mono text-2xl font-bold text-white ml-2 max-md:hidden ".concat(notStarted ? 'max-xl:hidden' : '')
    }, formatTime(clockSeconds)))), window.PatientStatus && /*#__PURE__*/React.createElement(window.PatientStatus.PatientStatusPanel, {
      sim: sim,
      addLogEntry: addLogEntry,
      showScenario: !quickSim,
      extra: window.PatientScreenSwitch ? /*#__PURE__*/React.createElement(window.PatientScreenSwitch, {
        sim: sim,
        addLogEntry: addLogEntry,
        onOpenScreens: function onOpenScreens() {
          return setShowJoin(true);
        }
      }) : null
    }), /*#__PURE__*/React.createElement("div", {
      ref: panel.rowRef,
      className: "flex-1 flex flex-col md:flex-row gap-2 overflow-hidden min-h-0 max-md:flex-none max-md:overflow-visible"
    }, /*#__PURE__*/React.createElement("div", {
      style: rightFolded ? undefined : panel.panelStyle,
      className: "w-full ".concat(rightFolded ? 'md:flex-1 md:min-w-0' : 'md:w-[34%] md:max-w-[72%]', " flex flex-col ").concat(shortScreen ? 'gap-1' : 'gap-2', " md:overflow-y-auto md:h-full md:pr-1")
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block flex-none bg-black border border-slate-800 rounded overflow-hidden",
      "data-testid": "obs-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden md:grid ".concat(compactTiles ? 'grid-cols-3' : 'grid-cols-2', " gap-1 p-1 bg-black")
    }, coreTiles(compactTiles)), /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block bg-black px-1 pb-1"
    }, /*#__PURE__*/React.createElement(Section, {
      id: "moreObs",
      title: "More obs",
      summary: "GCS ".concat(vitals.gcs, " \xB7 Glucose ").concat(Number.isFinite(vitals.bm) ? vitals.bm.toFixed(1) : '--'),
      defaultOpen: !shortScreen,
      className: "border-slate-800 bg-black",
      right: quickSim ? rightFolded ? trendOnlyButtons : null : shortScreen ? conditionButtons : null
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-1"
    }, moreTiles())))), !quickSim && conditionSection(shortScreen ? 'md:hidden' : ''), quickSim ? /*#__PURE__*/React.createElement("div", {
      className: "flex-none bg-slate-800 rounded border-l-4 border-sky-500 shadow-md",
      "data-testid": "quicksim-patient"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setQuickInfoOpen(function (v) {
          return !v;
        });
      },
      "aria-expanded": quickInfoOpen,
      "data-testid": "quicksim-toggle",
      title: quickInfoOpen ? 'Hide the patient details' : 'Show the full patient details',
      className: "w-full text-left flex items-center justify-between gap-2 rounded hover:bg-slate-700/40 ".concat(shortScreen ? 'px-2 py-1' : 'p-2')
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 ".concat(shortScreen && !quickInfoOpen ? 'flex items-baseline gap-2' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] font-bold text-sky-400 uppercase tracking-widest flex items-center gap-1 flex-none"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "sliders",
      className: "w-3 h-3"
    }), " ", rawScenario && rawScenario.ventSim ? "Ventilator Sim \u2014 ".concat(rawScenario.ventSim.name) : 'Quick Sim — no scenario'), /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-white font-bold ".concat(quickInfoOpen ? 'break-words' : 'truncate')
    }, scenario.patientName, " (", window.shortAge(scenario.patientAge), " ", scenario.sex, (_scenario$wetflag2 = scenario.wetflag) !== null && _scenario$wetflag2 !== void 0 && _scenario$wetflag2.weight ? ", ".concat(scenario.wetflag.weight, " kg") : '', ")")), /*#__PURE__*/React.createElement("span", {
      className: "flex-none flex items-center gap-1"
    }, isPaeds && /*#__PURE__*/React.createElement("span", {
      className: "text-[9px] px-1.5 py-0.5 rounded bg-purple-950/60 border border-purple-600 text-purple-300 uppercase font-bold tracking-wider"
    }, "paeds \xB7 wetflag"), /*#__PURE__*/React.createElement(Lucide, {
      icon: quickInfoOpen ? 'chevron-up' : 'chevron-down',
      className: "w-4 h-4 text-slate-400"
    }))), quickInfoOpen && /*#__PURE__*/React.createElement("div", {
      className: "px-2 pb-2 text-xs text-slate-300 space-y-2",
      "data-testid": "quicksim-details"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Name"), /*#__PURE__*/React.createElement("span", {
      className: "text-white break-words"
    }, scenario.patientName), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Age"), /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, window.formatAge ? window.formatAge(scenario.patientAge) : window.shortAge(scenario.patientAge)), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Sex"), /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, scenario.sex), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Weight"), /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, (_scenario$wetflag3 = scenario.wetflag) !== null && _scenario$wetflag3 !== void 0 && _scenario$wetflag3.weight || scenario.weight ? "".concat(((_scenario$wetflag4 = scenario.wetflag) === null || _scenario$wetflag4 === void 0 ? void 0 : _scenario$wetflag4.weight) || scenario.weight, " kg") : 'Not set (adult)')), rawScenario && rawScenario.ventSim && rawScenario.ventSim.description && /*#__PURE__*/React.createElement("p", null, rawScenario.ventSim.description), scenario.profile && /*#__PURE__*/React.createElement("p", null, scenario.profile), isPaeds && scenario.wetflag && /*#__PURE__*/React.createElement("div", {
      className: "rounded border border-purple-700/60 bg-purple-950/30 p-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] font-bold text-purple-300 uppercase tracking-wider mb-1"
    }, "WETFLAG (", scenario.wetflag.weight, " kg)"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-x-3 gap-y-0.5"
    }, /*#__PURE__*/React.createElement("span", null, "Energy ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, scenario.wetflag.energy, " J")), /*#__PURE__*/React.createElement("span", null, "Tube ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, scenario.wetflag.tube || '--')), /*#__PURE__*/React.createElement("span", null, "Fluids ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, scenario.wetflag.fluids, " ml")), /*#__PURE__*/React.createElement("span", null, "Lorazepam ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, scenario.wetflag.lorazepam, " mg")), /*#__PURE__*/React.createElement("span", null, "Adrenaline ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, scenario.wetflag.adrenaline, " mcg")), /*#__PURE__*/React.createElement("span", null, "Glucose ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, scenario.wetflag.glucose, " ml"))), /*#__PURE__*/React.createElement("div", {
      className: "mt-1 flex items-center justify-between gap-2 text-[10px] text-slate-400"
    }, /*#__PURE__*/React.createElement("span", null, showWetflag ? 'Shown on the patient monitor.' : 'Not shown on the patient monitor.'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_WETFLAG_VISIBILITY',
          payload: !showWetflag
        });
      },
      "data-testid": "quicksim-wetflag-toggle",
      className: "px-2 py-0.5 rounded border border-purple-600 text-purple-300 uppercase font-bold"
    }, showWetflag ? 'Hide' : 'Show'))))) : null, /*#__PURE__*/React.createElement(Section, {
      id: "monitoring",
      title: "Monitoring & access",
      summary: monitoringSummary,
      defaultOpen: false,
      remember: !quickSim,
      right: !sensors.standard && /*#__PURE__*/React.createElement(Button, {
        onClick: attachStandard,
        variant: "primary",
        className: "h-6 px-2 text-[10px] uppercase font-bold flex-none",
        ariaLabel: "Attach standard monitoring",
        title: "Attach the standard four: ECG electrodes, SpO2 probe, NIBP cuff and temperature probe."
      }, "Attach")
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between mb-1 gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] text-slate-400 cursor-help",
      title: "\u25CF attached: click to remove (its trace and number go blank on the team's monitor). \u25CB not attached: click to attach. POC checks show the value at the moment taken; click again to resample."
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "info",
      className: "w-3 h-3 inline mr-1"
    }), "How the chips work"), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap justify-end gap-1"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: attachStandard,
      variant: sensors.all ? 'secondary' : sensors.standard ? 'secondary' : 'primary',
      title: sensors.standard ? 'ECG, SpO2, NIBP and temperature are all attached. Capnography, the arterial line and IV access are separate deliberate acts.' : 'Attach the standard four: ECG electrodes, SpO2 probe, NIBP cuff and temperature probe. Capnography, art line and IV access are NOT included.',
      className: "h-6 px-2 text-[10px] uppercase font-bold"
    }, sensors.all ? 'All on' : sensors.standard ? 'Standard on' : 'Attach standard'), !simple && /*#__PURE__*/React.createElement(Button, {
      onClick: attachInvasive,
      variant: sensors.etco2 && sensors.art && sensors.iv ? 'secondary' : 'outline',
      title: "Deliberate, invasive additions: IV/IO access, an arterial line and capnography. Kept OUT of the standard fast path on purpose.",
      className: "h-6 px-2 text-[10px] uppercase font-bold"
    }, sensors.etco2 && sensors.art && sensors.iv ? 'Invasive on' : '+ Invasive'), anyMonitorOn && /*#__PURE__*/React.createElement(Button, {
      onClick: removeAllMonitoring,
      variant: "outline",
      title: "Detach every monitor (ECG, SpO2, NIBP, temperature, capnography, arterial line). IV access is left in place. Each removal is logged.",
      className: "h-6 px-2 text-[10px] uppercase font-bold text-rose-300 border-rose-700/70 hover:border-rose-400 hover:text-rose-200"
    }, "Remove all"))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1"
    }, (window.SENSOR_DEFS || []).map(function (def) {
      var on = def.kind === 'poc' ? !!pocReadings[def.poc] : !!sensors[def.id];
      var reading = def.kind === 'poc' ? pocReadings[def.poc] : null;
      var label = def.kind === 'poc' && reading ? "".concat(def.label, ": ").concat(def.poc === 'vbg' ? "pH ".concat(Number.isFinite(reading.value) ? reading.value.toFixed(2) : '--', " / K ").concat(Number.isFinite(reading.value2) ? reading.value2.toFixed(1) : '--') : Number.isFinite(reading.value) ? reading.value.toFixed(1) : '--', " @ ").concat(reading.clock) : def.label;
      // What a click will DO, spelled out, because a one-way chip is what
      // confused the live tester.
      var doesWhat = def.kind === 'poc' ? reading ? 'click to REPEAT the check (fresh, newly timestamped sample)' : 'click to CHECK now (one-off, timestamped)' : on ? "ATTACHED \u2014 click to DETACH" : "not attached \u2014 click to ATTACH";
      return /*#__PURE__*/React.createElement("button", {
        key: def.id,
        onClick: function onClick() {
          return toggleSensor(def.id);
        },
        "aria-pressed": def.kind === 'poc' ? undefined : on,
        title: "".concat(def.label, " \u2014 reveals ").concat(def.reveals, ". ").concat(doesWhat, "."),
        className: "px-2 py-1 rounded border text-[10px] font-bold uppercase tracking-wide ".concat(on ? def.kind === 'poc' ? 'bg-purple-950/50 border-purple-500 text-purple-200' : 'bg-emerald-950/50 border-emerald-500 text-emerald-200 hover:bg-rose-950/60 hover:border-rose-500 hover:text-rose-200' : 'bg-slate-800 border-slate-600 text-slate-300 hover:bg-slate-700')
      }, on && def.kind !== 'poc' ? "\u25CF " : def.kind === 'poc' ? '' : "\u25CB ", label);
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex-none bg-black border border-slate-800 rounded relative overflow-hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-1 bg-slate-900/90 border-b border-slate-800 px-1 py-0.5"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return sim.dispatch({
          type: 'TOGGLE_MONITOR_TIMER'
        });
      },
      className: "bg-slate-800 hover:bg-slate-700 border ".concat((_state$monitorTimer = state.monitorTimer) !== null && _state$monitorTimer !== void 0 && _state$monitorTimer.visible ? 'border-sky-500 text-sky-400' : 'border-slate-600 text-white', " px-2 py-0.5 text-[10px] rounded font-bold uppercase tracking-wider")
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "clock",
      className: "w-3 h-3 inline mr-1"
    }), (_state$monitorTimer2 = state.monitorTimer) !== null && _state$monitorTimer2 !== void 0 && _state$monitorTimer2.visible ? 'Hide Timer' : 'Show Timer'), ((_state$monitorTimer3 = state.monitorTimer) === null || _state$monitorTimer3 === void 0 ? void 0 : _state$monitorTimer3.visible) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        var _state$monitorTimer4;
        return sim.dispatch({
          type: (_state$monitorTimer4 = state.monitorTimer) !== null && _state$monitorTimer4 !== void 0 && _state$monitorTimer4.active ? 'PAUSE_MONITOR_TIMER' : 'START_MONITOR_TIMER'
        });
      },
      className: "bg-slate-800 border border-slate-600 px-2 py-0.5 text-[10px] rounded text-white font-bold uppercase hover:bg-slate-700"
    }, (_state$monitorTimer5 = state.monitorTimer) !== null && _state$monitorTimer5 !== void 0 && _state$monitorTimer5.active ? 'Pause' : 'Start'), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return sim.dispatch({
          type: 'RESET_MONITOR_TIMER'
        });
      },
      className: "bg-slate-800 border border-slate-600 px-2 py-0.5 text-[10px] rounded text-white font-bold uppercase hover:bg-slate-700"
    }, "Reset")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setPhoneTrace(function (v) {
          return !v;
        });
      },
      "aria-expanded": phoneTrace,
      "data-testid": "phone-trace-toggle",
      className: "md:hidden bg-slate-800 border border-slate-600 px-2 py-0.5 text-[10px] text-white rounded font-bold uppercase tracking-wider"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "activity",
      className: "w-3 h-3 inline mr-1"
    }), phoneTrace ? 'Hide trace' : 'Trace'), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setShowRhythmModal(true);
      },
      className: "ml-auto bg-slate-800 hover:bg-slate-700 border border-slate-600 px-2 py-0.5 text-[10px] text-white rounded font-bold uppercase tracking-wider"
    }, "Change Rhythm")), /*#__PURE__*/React.createElement("div", {
      className: "relative ".concat(phoneTrace ? '' : 'max-md:hidden'),
      style: {
        height: panel.prefs.stripHeight + 'px'
      }
    }, /*#__PURE__*/React.createElement(ECGMonitor, {
      noise: state.noise,
      rhythmType: state.rhythm,
      hr: vitals.hr,
      rr: vitals.rr,
      spO2: vitals.spO2,
      etco2: vitals.etco2,
      isPaused: traceFrozen,
      showTraces: sensors.any,
      showEcg: sEcg,
      showPleth: sSpo2,
      showResp: sResp,
      reserveLanes: sensors.any ? ['ecg', 'pleth', 'resp'] : [],
      showEtco2: showEtco2,
      showArt: showArt,
      isCPR: cprInProgress,
      co2Pathology: capnoPattern,
      co2Severity: capnoSeverity,
      ventilating: capnoVentilating,
      className: "h-full"
    }), !sensors.any && /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 flex flex-col items-center justify-center gap-2 bg-black z-10 p-2 text-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-xs font-mono uppercase tracking-widest"
    }, "No monitoring attached"), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400"
    }, "The team's monitor reads \"No sensor detected\"."), /*#__PURE__*/React.createElement(Button, {
      onClick: attachStandard,
      variant: "primary",
      className: "min-h-8 h-auto py-1 px-3 max-w-full text-[11px] uppercase font-bold leading-tight text-center",
      title: "Attach the standard four: ECG electrodes, SpO2 probe, NIBP cuff and temperature probe."
    }, "Attach standard monitoring")))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 px-1 bg-black ".concat(phoneTrace ? '' : 'max-md:hidden')
    }, /*#__PURE__*/React.createElement(ResizeGrip, {
      axis: "y",
      onPointerDown: panel.beginDrag('y'),
      onNudge: function onNudge(d) {
        return panel.nudge('y', d);
      },
      onReset: panel.reset,
      value: panel.prefs.stripHeight,
      min: PANEL_BOUNDS.minStrip,
      max: PANEL_BOUNDS.maxStrip
    }), panel.isCustom && /*#__PURE__*/React.createElement("button", {
      onClick: panel.reset,
      title: "Reset the monitor panel to its default size",
      className: "flex-none text-[9px] uppercase tracking-widest font-bold text-slate-400 hover:text-white border border-slate-700 rounded px-1.5 py-0.5"
    }, "reset size"))), quickSim && window.InvResults && /*#__PURE__*/React.createElement(Section, {
      id: "quickInvResults",
      tone: "card",
      title: "Investigations: send or change",
      defaultOpen: false,
      summary: invChangedSummary(scenario)
    }, /*#__PURE__*/React.createElement(window.InvResults.LiveResults, {
      sim: sim,
      addLogEntry: addLogEntry
    })), /*#__PURE__*/React.createElement(Section, {
      id: "resus",
      title: "Rhythm & resus",
      summary: resusSummary,
      defaultOpen: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-none grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative",
      ref: arrestMenuRef
    }, /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Choose an arrest rhythm (".concat(showArrestMenu ? 'menu open' : 'menu closed', ")"),
      variant: "danger",
      onClick: function onClick() {
        setShowArrestMenu(!showArrestMenu);
        setShowROSCMenu(false);
      },
      className: "w-full font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "activity",
      className: "w-4 h-4"
    }), " ARREST \u25BE"), showArrestMenu && /*#__PURE__*/React.createElement("div", {
      className: "absolute top-full mt-1 left-0 bg-slate-800 border border-slate-600 rounded shadow-xl w-full flex flex-col p-1 z-50"
    }, ARREST_RHYTHMS.map(function (r) {
      return /*#__PURE__*/React.createElement("button", {
        key: r,
        onClick: function onClick() {
          triggerArrest(r);
          setShowArrestMenu(false);
        },
        className: "text-left px-3 py-2 text-sm text-red-300 hover:bg-slate-700 hover:text-white rounded"
      }, RG.labelFor(r));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "relative",
      ref: roscMenuRef
    }, /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Choose a ROSC rhythm (".concat(showROSCMenu ? 'menu open' : 'menu closed', ")"),
      variant: "success",
      onClick: function onClick() {
        setShowROSCMenu(!showROSCMenu);
        setShowArrestMenu(false);
      },
      className: "w-full font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "heart",
      className: "w-4 h-4"
    }), " ROSC \u25BE"), showROSCMenu && /*#__PURE__*/React.createElement("div", {
      className: "absolute top-full mt-1 right-0 bg-slate-800 border border-slate-600 rounded shadow-xl w-full flex flex-col p-1 z-50"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 px-2 py-1 border-b border-slate-700 uppercase tracking-wider font-bold"
    }, "Pick the post-ROSC rhythm"), ROSC_RHYTHMS.map(function (r) {
      return /*#__PURE__*/React.createElement("button", {
        key: r,
        onClick: function onClick() {
          triggerROSC(r);
          setShowROSCMenu(false);
        },
        className: "text-left px-3 py-2 text-sm text-emerald-300 hover:bg-slate-700 hover:text-white rounded"
      }, RG.labelFor(r));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "flex-none grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_ARREST_PANEL',
          payload: !arrestPanelOpen
        });
      },
      className: "w-full ".concat(arrestPanelOpen ? 'bg-red-900/30 border-red-500 text-red-400' : ''),
      title: "Dual-trace LEAD II / PADS arrest layout on the student monitor. Does not open the defibrillator."
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "activity",
      className: "w-4 h-4"
    }), " ", arrestPanelOpen ? "Close Arrest View" : "Arrest View"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_DEFIB_PANEL',
          payload: !defibPanelOpen
        });
      },
      className: "w-full ".concat(defibPanelOpen ? 'bg-amber-900/30 border-amber-500 text-amber-300' : 'text-amber-400 border-amber-500/50'),
      title: "Opens a working defibrillator ON the student monitor, with the obs still visible alongside it."
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-4 h-4"
    }), " ", defibPanelOpen ? "Close Defib" : "Defib")), /*#__PURE__*/React.createElement("div", {
      className: "flex-none flex flex-wrap gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: cycleNibp,
      className: "flex-1 min-w-[9rem] max-md:min-w-0 max-md:px-2 max-md:text-xs ".concat(sensors.nibp ? 'text-sky-400 border-sky-500/50 hover:bg-sky-900/30' : 'text-slate-400 border-slate-600'),
      title: sensors.nibp ? 'Take an NIBP reading now (about 5 s).' : 'No NIBP cuff is attached — attach it first (Monitoring & access).'
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "activity",
      className: "w-4 h-4 flex-none"
    }), " ", /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap"
    }, sensors.nibp ? 'Cycle NIBP Now' : 'Cycle NIBP'), !sensors.nibp && /*#__PURE__*/React.createElement("span", {
      className: "ml-1 text-[10px] whitespace-nowrap max-md:hidden"
    }, "(no cuff)")), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return toggleNIBPMode && toggleNIBPMode();
      },
      title: "Auto NIBP: the cuff measures every 3 minutes (the same switch as AUTO on the room monitor).",
      className: "flex-none px-3 max-md:px-2 text-[10px] uppercase font-bold whitespace-nowrap ".concat(state.nibp && state.nibp.mode === 'auto' ? 'text-emerald-300 border-emerald-500/60 bg-emerald-900/20' : 'text-slate-400 border-slate-600')
    }, /*#__PURE__*/React.createElement("span", null, "Auto", /*#__PURE__*/React.createElement("span", {
      className: "max-md:hidden"
    }, " NIBP"), ": ", state.nibp && state.nibp.mode === 'auto' ? 'on' : 'off')), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        setNibpSys(vitals.bpSys);
        setNibpDia(vitals.bpDia);
        setShowNIBPModal(true);
      },
      title: "Show a one-off NIBP reading without changing the patient's BP (e.g. a spurious reading). To change the patient's BP, tap the BP tile.",
      className: "flex-1 min-w-[8rem] max-md:min-w-0 max-md:px-2 px-3 text-[10px] uppercase font-bold text-slate-400 whitespace-nowrap"
    }, /*#__PURE__*/React.createElement("span", {
      className: "max-md:hidden"
    }, "Manual reading"), /*#__PURE__*/React.createElement("span", {
      className: "md:hidden"
    }, "Manual BP"))), isPaeds && /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_WETFLAG_VISIBILITY',
          payload: !showWetflag
        });
      },
      className: "w-full flex-none mt-1 ".concat(!showWetflag ? 'text-slate-400 border-slate-600' : 'text-purple-400 border-purple-500/50 bg-purple-900/20')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "baby",
      className: "w-4 h-4 mr-1"
    }), " ", showWetflag ? 'Hide WETFLAG on Monitor' : 'Show WETFLAG on Monitor'), /*#__PURE__*/React.createElement("div", {
      className: "flex-none rounded border-l-4 border-amber-500 bg-slate-800 p-2 ".concat(defib.shockCount || lastConversion || cprInProgress ? '' : 'max-md:hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center justify-between gap-x-3 gap-y-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase tracking-widest text-slate-400 font-bold"
    }, "Current rhythm"), /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-sm ".concat(RG.isPulseless(state.rhythm) ? 'text-red-300' : 'text-white')
    }, RG.labelFor(state.rhythm), RG.isShockable(state.rhythm) && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 px-1.5 py-0.5 rounded bg-red-900/60 border border-red-500 text-red-200 text-[9px] uppercase font-bold tracking-wider"
    }, "shockable"), RG.isSyncCardiovertible(state.rhythm) && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 px-1.5 py-0.5 rounded bg-amber-900/50 border border-amber-500 text-amber-200 text-[9px] uppercase font-bold tracking-wider"
    }, "sync cardiovert"), RG.isPulseless(state.rhythm) && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 px-1.5 py-0.5 rounded bg-slate-900 border border-slate-500 text-slate-300 text-[9px] uppercase font-bold tracking-wider"
    }, "pulseless"))), /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 text-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase tracking-widest text-slate-400 font-bold"
    }, "Last conversion"), /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold text-amber-300 truncate"
    }, lastConversion ? "".concat(RG.labelFor(lastConversion.from), " \u2192 ").concat(RG.labelFor(lastConversion.to)) : /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "none yet")), lastConversion && /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 truncate"
    }, lastConversion.detail || lastConversion.cause))), /*#__PURE__*/React.createElement("div", {
      className: "mt-1 grid grid-cols-4 gap-1 text-center bg-black/40 rounded p-1"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase text-slate-400 font-bold"
    }, "Shocks"), /*#__PURE__*/React.createElement("div", {
      className: "font-mono font-bold text-white"
    }, defib.shockCount || 0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase text-slate-400 font-bold"
    }, "Total J"), /*#__PURE__*/React.createElement("div", {
      className: "font-mono font-bold text-white"
    }, defib.totalEnergy || 0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase text-slate-400 font-bold"
    }, "Last J"), /*#__PURE__*/React.createElement("div", {
      className: "font-mono font-bold text-white"
    }, (_defib$lastEnergy = defib.lastEnergy) !== null && _defib$lastEnergy !== void 0 ? _defib$lastEnergy : "\u2014")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase text-slate-400 font-bold"
    }, "CPR"), /*#__PURE__*/React.createElement("div", {
      className: "font-mono font-bold ".concat(cprInProgress ? 'text-red-400 animate-pulse' : 'text-slate-400')
    }, cprInProgress ? 'ON' : 'off')))), (arrestPanelOpen || defibPanelOpen) && /*#__PURE__*/React.createElement("div", {
      "data-testid": "defib-panel",
      className: "flex-none bg-red-900/20 border-2 border-red-500 p-2 rounded-lg animate-fadeIn shadow-2xl shadow-red-900/50"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-2"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-red-400 font-bold uppercase text-xs flex items-center gap-1"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-3 h-3"
    }), " Defibrillator ", defibPanelOpen ? '(on monitor)' : '(arrest view)'), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close defibrillator panel",
      onClick: function onClick() {
        if (defibPanelOpen) sim.dispatch({
          type: 'SET_DEFIB_PANEL',
          payload: false
        });else sim.dispatch({
          type: 'SET_ARREST_PANEL',
          payload: false
        });
      },
      className: "text-red-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-4 h-4"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between mb-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400 text-[10px] uppercase font-bold"
    }, "Energy"), /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] text-slate-400"
    }, "Recommended ", /*#__PURE__*/React.createElement("b", {
      className: "text-emerald-400"
    }, recommendedEnergy, "J"), isPaeds && (_scenario$wetflag5 = scenario.wetflag) !== null && _scenario$wetflag5 !== void 0 && _scenario$wetflag5.weight ? " (4 J/kg, ".concat(scenario.wetflag.weight, "kg)") : '')), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1"
    }, energySteps.map(function (j) {
      return /*#__PURE__*/React.createElement("button", {
        key: j,
        onClick: function onClick() {
          return sim.setDefibEnergy(j);
        },
        className: "px-2 py-1 rounded border text-[11px] font-mono font-bold ".concat(shockEnergy === j ? 'bg-amber-600 border-amber-400 text-white' : j === recommendedEnergy ? 'bg-emerald-950/50 border-emerald-600 text-emerald-300' : 'bg-slate-800 border-slate-600 text-slate-300 hover:bg-slate-700')
      }, j, "J");
    }))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        initCharge(shockEnergy);
        sim.playSound('charge');
      },
      variant: "warning",
      className: "h-10 text-xs"
    }, defib.charged ? "CHARGED ".concat(defib.chargeEnergy, "J") : "Charge ".concat(shockEnergy, "J")), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        deliverShock(shockEnergy, 'facilitator');
        sim.playSound('shock');
      },
      variant: "danger",
      className: "h-10 text-xs font-bold"
    }, defib.syncMode ? 'SYNC SHOCK' : 'SHOCK', " ", shockEnergy, "J")), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 gap-2 mt-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return sim.toggleDefibSync();
      },
      variant: "outline",
      className: "h-9 text-[10px] uppercase font-bold ".concat(defib.syncMode ? 'bg-amber-900/40 border-amber-500 text-amber-300' : '')
    }, "SYNC ", defib.syncMode ? 'ON' : 'OFF'), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return sim.toggleCPR();
      },
      variant: "outline",
      className: "h-9 text-[10px] uppercase font-bold ".concat(cprInProgress ? 'bg-red-900/40 border-red-500 text-red-300' : '')
    }, "CPR ", cprInProgress ? 'stop' : 'start'), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return nextCycle && nextCycle();
      },
      variant: "outline",
      className: "min-h-9 h-auto py-1 leading-tight text-[10px] uppercase font-bold"
    }, "Rhythm check +2m")), simple && /*#__PURE__*/React.createElement("button", {
      type: "button",
      "data-testid": "shock-settings-simple",
      onClick: function onClick() {
        return setViewMode('full');
      },
      className: "mt-2 w-full text-left bg-black/50 p-2 rounded text-[10px] text-slate-300 hover:text-white"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400 uppercase font-bold"
    }, "Shock response"), ' ', function () {
      var ds = state.defibSettings || {};
      var r = ds.shockResponse || 'model';
      var conv = r === 'model' ? 'realistic model' : r === 'auto' ? 'auto' : r === 'never' ? 'never converts' : "converts on shock ".concat(r);
      return "".concat(conv).concat(ds.cvEnergy && ds.cvEnergy !== 'default' ? " \xB7 cardioversion at ".concat(ds.cvEnergy, " J") : '').concat(state.queuedRhythm ? " \xB7 next shock \u2192 ".concat(RG.shortFor(state.queuedRhythm)) : '');
    }(), /*#__PURE__*/React.createElement("span", {
      className: "text-sky-400 underline ml-1"
    }, "change (Full view)")), !simple && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "mt-2 bg-black/50 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between mb-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400 text-[10px] uppercase font-bold"
    }, "Next shock converts to"), state.queuedRhythm && /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return sim.setQueuedRhythm(null);
      },
      className: "text-[10px] text-sky-400 hover:text-sky-200 underline"
    }, "clear")), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1"
    }, RG.SELECTABLE.filter(function (r) {
      return RG.isRoscEligible(r) || RG.inArrest(r);
    }).map(function (r) {
      return /*#__PURE__*/React.createElement("button", {
        key: r,
        onClick: function onClick() {
          return sim.setQueuedRhythm(r);
        },
        className: "px-2 py-1 rounded border text-[10px] font-bold ".concat(state.queuedRhythm === r ? 'bg-sky-700 border-sky-400 text-white' : 'bg-slate-800 border-slate-600 text-slate-300 hover:bg-slate-700')
      }, RG.shortFor(r));
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 mt-1"
    }, "Leave unset to let the outcome model decide (energy, rhythm, CPR and drugs all count).")), /*#__PURE__*/React.createElement("div", {
      className: "mt-2 bg-black/50 p-2 rounded space-y-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-[10px] uppercase font-bold"
    }, "Shock response"), [['shockResponse', 'Converts', [['model', 'Realistic model (energy, CPR, drugs)'], ['auto', 'Auto (arrest: 3rd adequate shock, cardioversion: 1st)'], ['1', '1st adequate shock'], ['2', '2nd adequate shock'], ['3', '3rd adequate shock'], ['4', '4th adequate shock'], ['5', '5th adequate shock'], ['never', 'Never (refractory)']]], ['rOnT', 'Unsync shock with a pulse', [['never', 'No effect (flagged)'], ['sometimes', 'Sometimes causes VF (1 in 3)'], ['always', 'Always causes VF']]], ['refib', 'After ROSC', [['model', 'Realistic model'], ['once', 'VF recurs once (30-90 s)'], ['off', 'Stays in ROSC']]], ['cvEnergy', 'Cardioversion succeeds at', [['default', 'Default (75 J adult, 1 J/kg child)']].concat(RG.ADULT_ENERGY_STEPS.map(function (j) {
      return [String(j), "".concat(j, " J or more")];
    }))]].map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 3),
        k = _ref5[0],
        label = _ref5[1],
        opts = _ref5[2];
      return /*#__PURE__*/React.createElement("label", {
        key: k,
        className: "flex items-center justify-between gap-2 text-[10px] text-slate-300"
      }, /*#__PURE__*/React.createElement("span", {
        className: "whitespace-nowrap"
      }, label), /*#__PURE__*/React.createElement("select", {
        value: (state.defibSettings || {})[k] || (k === 'cvEnergy' ? 'default' : ''),
        onChange: function onChange(e) {
          return sim.setDefibSettings(_defineProperty({}, k, e.target.value));
        },
        className: "min-w-0 max-w-[14rem] bg-slate-900 border border-slate-600 rounded px-1 py-0.5 text-[10px] text-white"
      }, opts.map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
          v = _ref7[0],
          t = _ref7[1];
        return /*#__PURE__*/React.createElement("option", {
          key: v,
          value: v
        }, t);
      })));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "mt-2 flex items-center justify-between bg-black/50 p-2 rounded"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400 text-[10px] uppercase"
    }, "CPR / cycle timer"), /*#__PURE__*/React.createElement("span", {
      className: "font-mono text-xl font-bold ".concat(cprInProgress ? 'text-red-300' : 'text-white')
    }, formatTime(state.cycleTimer)))))), !quickSim && activeDrugRows.length > 0 && /*#__PURE__*/React.createElement(Section, {
      id: "drugs",
      tone: "violet",
      title: "Drugs on board (".concat(activeDrugRows.length, ")"),
      summary: drugSummary,
      defaultOpen: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1",
      title: "Effects are added on top of the underlying physiology and wear off on their own. A drug in ONSET has not started acting yet; the countdown says when it will."
    }, activeDrugRows.map(function (d) {
      var style = PHASE_STYLE[d.phase] || {
        cls: 'text-slate-300 border-slate-600 bg-slate-900',
        label: String(d.phase).toUpperCase()
      };
      var route = INTERVENTIONS[d.key] && INTERVENTIONS[d.key].route;
      // TITRATION: a running infusion can be turned up or down while it runs.
      var infusion = (state.activeDrugs || []).filter(function (x) {
        return x.key === d.key && x.sustained && x.stopTime < 0;
      }).pop();
      return /*#__PURE__*/React.createElement("div", {
        key: d.key,
        className: "border-b border-slate-700/40 last:border-0 pb-1 last:pb-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2 text-[11px]"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-white font-bold truncate flex-1 min-w-0"
      }, d.label, d.doses > 1 ? " x".concat(d.doses) : '', route && route !== 'n/a' ? /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 font-normal"
      }, " \xB7 ", route) : null), /*#__PURE__*/React.createElement("span", {
        className: "px-1.5 py-0.5 rounded border text-[9px] font-bold uppercase tracking-wider flex-none ".concat(style.cls)
      }, style.label), /*#__PURE__*/React.createElement("span", {
        className: "font-mono text-slate-400 w-10 text-right flex-none"
      }, d.intensity, "%"), /*#__PURE__*/React.createElement("span", {
        className: "font-mono text-slate-400 w-16 text-right flex-none",
        title: d.sustained && !d.stopped ? 'Runs until you stop it' : 'Time until the effect is gone'
      }, d.sustained && !d.stopped ? 'running' : fmtRemaining(d.remaining))), infusion && /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-1 mt-0.5 text-[10px] text-slate-400"
      }, "Rate", /*#__PURE__*/React.createElement("button", {
        title: "Turn the infusion DOWN",
        "aria-label": "Turn ".concat(d.label, " down"),
        onClick: function onClick() {
          return sim.dispatch({
            type: 'SET_DRUG_DOSE',
            payload: {
              key: d.key,
              dose: (Number(infusion.dose) || 1) - 0.25
            }
          });
        },
        className: "w-5 h-5 rounded bg-slate-700 hover:bg-slate-600 border border-slate-600 text-slate-200 leading-none font-bold"
      }, "-"), /*#__PURE__*/React.createElement("span", {
        className: "font-mono text-sky-300 w-10 text-center"
      }, "x", (Number(infusion.dose) || 1).toFixed(2)), /*#__PURE__*/React.createElement("button", {
        title: "Turn the infusion UP",
        "aria-label": "Turn ".concat(d.label, " up"),
        onClick: function onClick() {
          return sim.dispatch({
            type: 'SET_DRUG_DOSE',
            payload: {
              key: d.key,
              dose: (Number(infusion.dose) || 1) + 0.25
            }
          });
        },
        className: "w-5 h-5 rounded bg-slate-700 hover:bg-slate-600 border border-slate-600 text-slate-200 leading-none font-bold"
      }, "+")), !simple && (d.expected || d.onsetIn > 0) && /*#__PURE__*/React.createElement("div", {
        className: "text-[9px] text-slate-400 flex flex-wrap gap-x-2 gap-y-0.5 mt-0.5"
      }, d.expected && /*#__PURE__*/React.createElement("span", {
        className: "text-slate-300"
      }, d.expected), d.onsetIn > 0 ? /*#__PURE__*/React.createElement("span", {
        className: "text-sky-300 font-bold"
      }, "starts in ", fmtRemaining(d.onsetIn), " (onset ~", Math.round(d.onsetSeconds / 60) >= 1 ? Math.round(d.onsetSeconds / 60) + ' min' : d.onsetSeconds + 's', ")") : d.peakIn > 0 && /*#__PURE__*/React.createElement("span", {
        className: "text-amber-300"
      }, "peaks in ", fmtRemaining(d.peakIn))), !simple && (d.drives || []).map(function (dr) {
        return /*#__PURE__*/React.createElement("div", {
          key: dr.vital,
          className: "text-[9px] text-cyan-300 mt-0.5 font-mono"
        }, dr.vital === 'temp' ? 'temp' : dr.vital, " ", dr.current !== null ? dr.current.toFixed(2) : '--', " \u2192 ", dr.target, ' at ', dr.ratePerHour > 0 ? '+' : "\u2212", Math.abs(dr.ratePerHour), dr.vital === 'temp' ? " \xB0C/h" : '/h', dr.active ? dr.etaSeconds !== null ? " \xB7 ETA ".concat(fmtRemaining(dr.etaSeconds)) : '' : " \xB7 not started yet");
      }));
    }))), VP && /*#__PURE__*/React.createElement(Section, {
      id: "vent",
      title: "Ventilator",
      summary: ventSummary,
      defaultOpen: !!(rawScenario && rawScenario.ventSim),
      remember: !quickSim
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2 text-[11px] text-slate-300"
    }, rawScenario && rawScenario.ventSim && /*#__PURE__*/React.createElement("div", {
      className: "bg-cyan-950/40 border border-cyan-700/60 rounded p-2",
      "data-testid": "vent-brief"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-cyan-300"
    }, "Ventilator Sim: ", rawScenario.ventSim.name, " (", rawScenario.ventSim.mode === 'assessment' ? 'Assessment' : 'Education', ")"), /*#__PURE__*/React.createElement("div", {
      className: "text-slate-300"
    }, rawScenario.ventSim.description), VP && rawScenario.ventSim.problems.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mt-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Problems to inject, one at a time: "), rawScenario.ventSim.problems.map(function (id) {
      var p = VP.PROBLEMS.find(function (x) {
        return x.id === id;
      });
      return p ? p.label : id;
    }).join(', '), ".")), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_VENT_PANEL',
          payload: !ventPanelOpen
        });
      },
      className: "w-full ".concat(ventPanelOpen ? 'bg-cyan-900/30 border-cyan-500 text-cyan-300' : 'text-cyan-400 border-cyan-500/50'),
      title: "Shows the ventilator on the room monitor (it replaces the defib there). A ventilator tablet joined by QR code works whether this is on or off."
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "wind",
      className: "w-4 h-4"
    }), " ", ventPanelOpen ? 'Take the ventilator off the patient screens' : 'Show the ventilator on the patient screens'), /*#__PURE__*/React.createElement("label", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap text-slate-400 uppercase font-bold text-[10px]"
    }, "Ventilator"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Ventilator model",
      value: VP.modelOf(ventCfg.model),
      title: "The device the candidate sees. Changing it swaps the ventilator on every screen; it starts switched off.",
      onChange: function onChange(e) {
        sim.dispatch({
          type: 'SET_VENT_CONFIG',
          payload: {
            model: e.target.value
          }
        });
        addLogEntry("Ventilator changed to the ".concat(VP.MODEL_SHORT[e.target.value], " (facilitator)"), 'system');
      },
      className: "min-w-0 max-w-[16rem] bg-slate-900 border border-slate-600 rounded px-1 py-0.5 text-[11px] text-white"
    }, Object.keys(VP.MODELS).map(function (k) {
      return /*#__PURE__*/React.createElement("option", {
        key: k,
        value: k
      }, VP.MODELS[k]);
    }))), window.VentControls && /*#__PURE__*/React.createElement(window.VentControls.VentPatientPanel, {
      sim: sim,
      cfg: ventCfg,
      addLogEntry: addLogEntry
    }), /*#__PURE__*/React.createElement("label", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap text-slate-400 uppercase font-bold text-[10px]"
    }, "Lungs"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Ventilator lungs",
      value: ventCfg.profile,
      onChange: function onChange(e) {
        sim.dispatch({
          type: 'SET_VENT_CONFIG',
          payload: {
            profile: e.target.value
          }
        });
        addLogEntry("Ventilator lungs set to ".concat(VP.profiles[e.target.value].name, " (facilitator)"), 'system');
      },
      className: "min-w-0 max-w-[16rem] bg-slate-900 border border-slate-600 rounded px-1 py-0.5 text-[11px] text-white"
    }, VP.order.map(function (k) {
      return /*#__PURE__*/React.createElement("option", {
        key: k,
        value: k
      }, VP.profiles[k].name);
    }))), /*#__PURE__*/React.createElement("label", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap text-slate-400 uppercase font-bold text-[10px]"
    }, "Own breathing"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Patient's own breathing",
      value: ventCfg.breathing === true ? 'yes' : ventCfg.breathing === false ? 'no' : 'auto',
      onChange: function onChange(e) {
        var v = e.target.value;
        sim.dispatch({
          type: 'SET_VENT_CONFIG',
          payload: {
            breathing: v === 'yes' ? true : v === 'no' ? false : null
          }
        });
        addLogEntry("Ventilator patient: ".concat(v === 'yes' ? 'breathing for themselves' : v === 'no' ? 'not breathing (sedated and paralysed)' : 'breathing as the lungs say', " (facilitator)"), 'system');
      },
      className: "min-w-0 max-w-[16rem] bg-slate-900 border border-slate-600 rounded px-1 py-0.5 text-[11px] text-white"
    }, /*#__PURE__*/React.createElement("option", {
      value: "auto"
    }, "From the patient (", VE && VE.configFor(_objectSpread(_objectSpread({}, state), {}, {
      vent: _objectSpread(_objectSpread({}, ventCfg), {}, {
        breathing: null
      })
    })).breathing === false ? 'not breathing' : VE && VE.awakeFor(_objectSpread(_objectSpread({}, state), {}, {
      vent: _objectSpread(_objectSpread({}, ventCfg), {}, {
        breathing: null
      })
    })) ? 'awake, breathing' : VP.profiles[ventCfg.profile] && VP.profiles[ventCfg.profile].sedated ? 'not breathing' : 'breathing', ")"), /*#__PURE__*/React.createElement("option", {
      value: "yes"
    }, "Breathing for themselves"), /*#__PURE__*/React.createElement("option", {
      value: "no"
    }, "Not breathing (sedated, paralysed)"))), VE && function () {
      // What the circuit connects to: worked out from the patient unless the facilitator says.
      var auto = VE.interfaceFor(_objectSpread(_objectSpread({}, state), {}, {
        vent: _objectSpread(_objectSpread({}, ventCfg), {}, {
          airway: null
        })
      }));
      var NAME = {
        mask: 'Face mask',
        sga: 'SGA',
        tube: 'Tube'
      };
      var why = auto.source === 'recorded' ? 'recorded' : auto.source === 'awake' ? 'awake, no airway' : 'unconscious, assumed';
      return /*#__PURE__*/React.createElement("label", {
        className: "flex items-center justify-between gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "whitespace-nowrap text-slate-400 uppercase font-bold text-[10px]"
      }, "Airway"), /*#__PURE__*/React.createElement("select", {
        "aria-label": "Ventilator airway",
        value: ventCfg.airway || 'auto',
        title: "What the ventilator's circuit connects to. An awake patient with no airway has a face mask: only noninvasive modes suit it, and in other modes they fight the ventilator and the mask leaks. An unconscious patient with no airway recorded is assumed to have a tube.",
        onChange: function onChange(e) {
          var v = e.target.value;
          sim.dispatch({
            type: 'SET_VENT_CONFIG',
            payload: {
              airway: v === 'auto' ? null : v
            }
          });
          addLogEntry("Ventilator airway: ".concat(v === 'auto' ? 'worked out from the patient' : NAME[v], " (facilitator)"), 'system');
        },
        className: "min-w-0 max-w-[16rem] bg-slate-900 border border-slate-600 rounded px-1 py-0.5 text-[11px] text-white"
      }, /*#__PURE__*/React.createElement("option", {
        value: "auto"
      }, "From the patient (", NAME[auto.airway], ": ", why, ")"), /*#__PURE__*/React.createElement("option", {
        value: "mask"
      }, "Face mask"), /*#__PURE__*/React.createElement("option", {
        value: "sga"
      }, "SGA"), /*#__PURE__*/React.createElement("option", {
        value: "tube"
      }, "Tube")));
    }(), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap text-slate-400 uppercase font-bold text-[10px]"
    }, "Obs"), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1",
      role: "group",
      "aria-label": "Who sets the obs"
    }, [[true, 'Ventilator drives them'], [false, 'I set them']].map(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
        on = _ref9[0],
        label = _ref9[1];
      return /*#__PURE__*/React.createElement("button", {
        key: label,
        type: "button",
        "aria-pressed": ventLinkOn === on,
        onClick: function onClick() {
          if (ventLinkOn === on) return;
          sim.dispatch({
            type: 'SET_VENT_LINK',
            payload: on
          });
          addLogEntry(on ? 'Ventilator link on: the ventilator, while it ventilates, drives SpO2, RR and ETCO2 (facilitator).' : 'Ventilator link off: the facilitator sets the obs (facilitator).', 'system');
        },
        className: "px-2 py-0.5 rounded border text-[10px] font-bold ".concat(ventLinkOn === on ? 'bg-cyan-700 border-cyan-400 text-white' : 'bg-slate-900 border-slate-600 text-slate-300')
      }, label);
    }))), ventDriver && /*#__PURE__*/React.createElement("div", {
      "data-testid": "vent-driving",
      className: "text-emerald-300"
    }, "Breathing for the patient: SpO2, RR and ETCO2 follow the ventilator; low SpO2, high CO2 and air trapping move HR and BP."), ventLinkOn && ventHeld.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2 bg-amber-950/40 border border-amber-700/60 rounded p-1.5"
    }, /*#__PURE__*/React.createElement("span", null, "You typed ", Array.from(new Set(ventHeld.map(function (k) {
      return VENT_KEY_NAMES[k];
    }))).join(', '), ", so ", ventHeld.length === 1 ? 'it stays' : 'they stay', " as you set ", ventHeld.length === 1 ? 'it' : 'them', "."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        sim.dispatch({
          type: 'RELEASE_MANUAL_HOLD',
          payload: ventHeld
        });
        addLogEntry("Released ".concat(Array.from(new Set(ventHeld.map(function (k) {
          return VENT_KEY_NAMES[k];
        }))).join(', '), " to the ventilator (facilitator)."), 'system');
      },
      className: "flex-none px-2 py-0.5 rounded bg-amber-600 text-black font-bold text-[10px]"
    }, "Release to ventilator")), ventMirrors.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-500"
    }, "No ventilator is connected. Show it on the room monitor, or join a tablet with the Ventilator QR code (Screens > Join by QR code)."), ventMirrors.map(function (m) {
      var mon = m.mon || {};
      var ibw = Number(m.ibw) || 0;
      var alarms = String(m.alarms || '').split('|').filter(Boolean).map(function (a) {
        var i = a.indexOf(':');
        return {
          p: a.slice(0, i),
          t: a.slice(i + 1)
        };
      });
      var cell = function cell(label, v, unit) {
        return /*#__PURE__*/React.createElement("div", {
          key: label
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-[9px] uppercase text-slate-400 font-bold"
        }, label), /*#__PURE__*/React.createElement("div", {
          className: "font-mono font-bold text-white"
        }, Number.isFinite(v) ? v : "\u2014", /*#__PURE__*/React.createElement("span", {
          className: "text-[9px] text-slate-400 font-normal ml-0.5"
        }, unit)));
      };
      return /*#__PURE__*/React.createElement("div", {
        key: m.id,
        "data-testid": "vent-mirror",
        className: "bg-black/50 rounded p-2 flex flex-col gap-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-between gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-cyan-300"
      }, VP.MODELS[VP.modelOf(m.model)], " \xB7 ", m.embedded ? 'On the room monitor' : 'Ventilator tablet', Date.now() - Number(m.ts) > 15000 ? /*#__PURE__*/React.createElement("span", {
        className: "ml-1 text-amber-300"
      }, "(no update for ", Math.round((Date.now() - Number(m.ts)) / 1000), " s: link lost?)") : null), /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-white"
      }, VENT_STATE_LABEL[m.state] || m.state, m.state === 'ventilating' || m.state === 'standby' ? " \xB7 ".concat(m.label) : '', m.locked ? " \xB7 locked" : '')), m.ctl && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400"
      }, "Settings: "), m.ctl), m.state === 'ventilating' && /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-4 gap-1"
      }, cell('Ppeak', mon.ppeak, 'cmH2O'), cell('PEEP', mon.peep, 'cmH2O'), cell('Pplat', mon.pplat, 'cmH2O'), cell('AutoPEEP', mon.autopeep, 'cmH2O'), cell('VTE', mon.vte, 'ml'), cell('VTE/IBW', Number.isFinite(mon.vte) && ibw ? Math.round(mon.vte / ibw * 10) / 10 : null, 'ml/kg'), cell('MinVol', mon.mv, 'l/min'), cell('fTotal', mon.ftot, '/min'), cell('Oxygen', m.o2, '%'), cell('Leak', mon.vleak, '%')), alarms.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "flex flex-wrap gap-1"
      }, alarms.map(function (a, i) {
        return /*#__PURE__*/React.createElement("span", {
          key: i,
          className: "px-1.5 py-0.5 rounded font-bold ".concat(a.p === 'hi' ? 'bg-red-700 text-white' : a.p === 'med' ? 'bg-amber-500 text-black' : 'bg-sky-700 text-white')
        }, a.t);
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-slate-400"
      }, m.sex, ", ", m.height, " cm, IBW ", ibw, " kg", " \xB7 ", "Tests: ", m.tests, m.win && m.win !== 'standby' ? " \xB7 Window open: ".concat(m.win) : ''), m.lim && !m.lv && /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement("summary", {
        className: "cursor-pointer text-slate-400"
      }, "Alarm limits"), /*#__PURE__*/React.createElement("div", null, m.lim)), window.VentControls && /*#__PURE__*/React.createElement(window.VentControls.VentRemotePanel, {
        sim: sim,
        m: m
      }));
    })))), !rightFolded && /*#__PURE__*/React.createElement(ResizeGrip, {
      axis: "x",
      onPointerDown: panel.beginDrag('x'),
      onNudge: function onNudge(d) {
        return panel.nudge('x', d);
      },
      onReset: panel.reset,
      value: panel.prefs.width || 0,
      min: PANEL_BOUNDS.minWidth,
      max: 2000
    }), /*#__PURE__*/React.createElement("div", {
      className: "hidden md:flex flex-none flex-col items-center",
      "data-testid": "right-fold-bar"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: toggleRightFolded,
      "aria-expanded": !rightFolded,
      "aria-controls": "right-column",
      "aria-label": rightFolded ? "Open the ".concat(quickSim ? 'rhythms and log' : 'interventions and log', " column") : "Fold away the ".concat(quickSim ? 'rhythms and log' : 'interventions and log', " column"),
      className: "rounded border border-slate-600 bg-slate-800 hover:bg-slate-700 text-slate-200 font-bold uppercase tracking-widest text-[10px] flex items-center justify-center gap-1 ".concat(rightFolded ? 'h-full w-8 flex-col py-3' : 'h-8 w-8')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: rightFolded ? 'chevrons-left' : 'chevrons-right',
      className: "w-4 h-4"
    }), rightFolded && /*#__PURE__*/React.createElement("span", {
      style: {
        writingMode: 'vertical-rl'
      }
    }, quickSim ? 'Rhythms & log' : 'Interventions & log'))), /*#__PURE__*/React.createElement("div", {
      id: "right-column",
      className: "contents ".concat(rightFolded ? 'md:[&>*]:hidden' : '')
    }, quickSim ? /*#__PURE__*/React.createElement("div", {
      className: "flex-1 min-w-0 flex flex-col bg-slate-800 rounded border border-slate-700 md:overflow-hidden relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-3 max-md:p-2 border-b border-slate-700 flex flex-wrap gap-2 items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-1 min-w-[12rem] max-md:hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] uppercase tracking-widest text-slate-400 font-bold"
    }, "Rhythm"), /*#__PURE__*/React.createElement("div", {
      className: "text-sm font-bold text-white"
    }, RG.labelFor(state.rhythm))), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        sim.dispatch({
          type: 'TRIGGER_IMPROVE'
        });
        addLogEntry("Patient Improving (Trend)", "success");
      },
      variant: "success",
      className: "h-11 w-24 max-md:w-auto max-md:flex-1 shrink-0 text-xs px-2 flex-col gap-0 leading-tight"
    }, /*#__PURE__*/React.createElement("span", null, "Trend"), /*#__PURE__*/React.createElement("span", {
      className: "font-bold"
    }, "Better")), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        sim.dispatch({
          type: 'TRIGGER_DETERIORATE'
        });
        addLogEntry("Patient Deteriorating (Trend)", "danger");
      },
      variant: "danger",
      className: "h-11 w-24 max-md:w-auto max-md:flex-1 shrink-0 text-xs px-2 flex-col gap-0 leading-tight"
    }, /*#__PURE__*/React.createElement("span", null, "Trend"), /*#__PURE__*/React.createElement("span", {
      className: "font-bold"
    }, "Worse"))), /*#__PURE__*/React.createElement("div", {
      className: "md:flex-1 md:overflow-y-auto p-3 space-y-3"
    }, /*#__PURE__*/React.createElement(Section, {
      id: "qsVoice",
      title: "Patient voice",
      summary: "Make the patient speak on the monitor",
      defaultOpen: false
    }, renderVoicePanel()), /*#__PURE__*/React.createElement("div", {
      "data-testid": "presets"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between mb-1 gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-widest text-slate-400 font-bold"
    }, "Presets"), simple ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setViewMode('full');
      },
      className: "text-[10px] text-sky-400 hover:text-sky-200 underline"
    }, presetList.length, " presets in Full view") : /*#__PURE__*/React.createElement("button", {
      onClick: savePresetSnapshot,
      className: "text-[10px] uppercase font-bold text-sky-400 hover:text-sky-200 border border-sky-800 rounded px-1.5 py-0.5",
      title: "Save the current rhythm and obs as a one-press preset on this device"
    }, "+ Save current")), presetView && /*#__PURE__*/React.createElement("div", {
      className: "mb-2 rounded border border-sky-600 bg-sky-950/40 p-2",
      role: "status"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold text-sky-200 truncate"
    }, presetView.name), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-300"
    }, presetView.note ? "Now: ".concat(presetView.note) : "Starting\u2026"), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400"
    }, presetView.waiting ? /*#__PURE__*/React.createElement("span", {
      className: "text-amber-300 font-bold"
    }, "Next: ", presetView.nextNote, " \u2014 waiting for you") : presetView.nextNote ? /*#__PURE__*/React.createElement(React.Fragment, null, "Next in ", /*#__PURE__*/React.createElement("b", {
      className: "font-mono text-white"
    }, presetView.nextIn, "s"), ": ", presetView.nextNote) : null, (pausedByFacilitator || state.isFinished) && /*#__PURE__*/React.createElement("span", {
      className: "ml-1 text-amber-300"
    }, "(paused)"))), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1 flex-none"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: firePresetStep,
      variant: presetView.waiting ? 'primary' : 'secondary',
      className: "h-8 px-2 text-[10px] uppercase font-bold",
      title: "Apply the next step now"
    }, "Next \u203A"), /*#__PURE__*/React.createElement(Button, {
      onClick: stopPreset,
      variant: "outline",
      className: "h-8 px-2 text-[10px] uppercase font-bold",
      title: "Stop the preset (the patient stays as they are now)"
    }, "Stop"))), /*#__PURE__*/React.createElement("div", {
      className: "mt-1 h-1 bg-slate-800 rounded overflow-hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-full bg-sky-500",
      style: {
        width: "".concat(Math.round(presetView.idx / presetView.total * 100), "%")
      }
    }))), !simple && /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2"
    }, presetList.map(function (p) {
      return /*#__PURE__*/React.createElement("div", {
        key: p.id,
        className: "relative"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return startPreset(p);
        },
        title: p.description,
        className: "w-full p-2 pr-6 rounded border text-left text-[11px] font-bold leading-tight min-h-[2.75rem] ".concat(presetView && presetView.name === p.name ? 'bg-sky-700 border-sky-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-200 hover:bg-slate-600')
      }, p.name, /*#__PURE__*/React.createElement("div", {
        className: "text-[9px] font-normal text-slate-300"
      }, p.steps.length, " step", p.steps.length === 1 ? '' : 's', p.user ? " \xB7 saved" : '', p.steps.some(function (x) {
        return x.wait;
      }) ? " \xB7 waits for you" : '')), p.user && /*#__PURE__*/React.createElement("button", {
        "aria-label": "Delete preset ".concat(p.name),
        onClick: function onClick() {
          return deletePreset(p);
        },
        className: "absolute top-1 right-1 text-slate-400 hover:text-red-400"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-3 h-3"
      })));
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2 mb-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-widest text-slate-400 font-bold"
    }, "Select rhythm (", RG.SELECTABLE.length, ")"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setPhoneRhythms(function (v) {
          return !v;
        });
      },
      "aria-expanded": phoneRhythms,
      "data-testid": "phone-rhythms-toggle",
      className: "md:hidden text-[10px] uppercase font-bold px-2 py-1 rounded border border-slate-600 text-slate-200 hover:bg-slate-700"
    }, phoneRhythms ? 'Hide list' : 'Show all')), /*#__PURE__*/React.createElement("div", {
      className: "text-[9px] text-slate-400 mb-2 leading-relaxed ".concat(phoneRhythms ? '' : 'max-md:hidden')
    }, "Each rhythm has a typical rate, applied only when you have not set HR yourself. An HR you typed is kept across a rhythm change (the log says so); ARREST and ROSC reset it."), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 ".concat(phoneRhythms ? '' : 'max-md:hidden')
    }, RG.SELECTABLE.map(function (r) {
      var isCur = state.rhythm === r;
      var arrest = RG.inArrest(r);
      return /*#__PURE__*/React.createElement("button", {
        key: r,
        onClick: function onClick() {
          return changeRhythm(r, 'manual selection');
        },
        title: "".concat(RG.labelFor(r)).concat(RG.isShockable(r) ? ' — shockable' : '').concat(RG.isPulseless(r) ? ' — pulseless' : ''),
        className: "p-2 rounded border text-left text-[11px] font-bold leading-tight min-h-[3rem] ".concat(isCur ? 'bg-sky-700 border-sky-400 text-white' : arrest ? 'bg-red-950/40 border-red-800/70 text-red-200 hover:bg-red-900/40' : 'bg-slate-700 border-slate-600 text-slate-200 hover:bg-slate-600')
      }, RG.labelFor(r), /*#__PURE__*/React.createElement("div", {
        className: "mt-0.5 flex gap-1 flex-wrap"
      }, RG.isShockable(r) && /*#__PURE__*/React.createElement("span", {
        className: "text-[8px] uppercase tracking-wider px-1 rounded bg-red-900/70 border border-red-600 text-red-200"
      }, "shock"), RG.isSyncCardiovertible(r) && /*#__PURE__*/React.createElement("span", {
        className: "text-[8px] uppercase tracking-wider px-1 rounded bg-amber-900/60 border border-amber-600 text-amber-200"
      }, "sync"), RG.isPulseless(r) && /*#__PURE__*/React.createElement("span", {
        className: "text-[8px] uppercase tracking-wider px-1 rounded bg-slate-900 border border-slate-500 text-slate-300"
      }, "pulseless")));
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-2"
    }, "Event log (", state.log.length, ")"), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border border-slate-700 rounded p-2 font-mono text-[11px] space-y-1 max-h-72 max-md:max-h-48 overflow-y-auto"
    }, state.log.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-center py-4"
    }, "Nothing logged yet. Attach monitoring, press START, then change the obs or the rhythm."), state.log.slice().reverse().map(function (entry, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "flex gap-3 border-b border-slate-800 last:border-0 pb-0.5 ".concat(entry.flagged ? 'bg-amber-900/20 -mx-1 px-1 rounded' : '')
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 w-12 flex-shrink-0"
      }, entry.simTime), /*#__PURE__*/React.createElement("span", {
        className: "flex-grow ".concat(entry.type === 'danger' ? 'text-red-400 font-bold' : entry.type === 'warning' ? 'text-amber-300 font-bold' : entry.type === 'success' ? 'text-emerald-400 font-bold' : 'text-slate-300')
      }, entry.msg));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-3 border-t border-slate-700 flex flex-wrap gap-2"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "bg-slate-800 border border-slate-600 rounded px-4 h-10 text-sm flex-1 min-w-[10rem] text-white focus:border-amber-500 outline-none",
      placeholder: "Add a note to the log",
      value: customLog,
      onChange: function onChange(e) {
        return setCustomLog(e.target.value);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') submitCustomLog(false);
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return submitCustomLog(true);
      },
      disabled: !customLog.trim(),
      variant: "secondary",
      className: "h-10 w-24 max-md:w-auto max-md:px-2 shrink-0 text-amber-500 border-amber-500/30"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "flag",
      className: "w-4 h-4 mr-1"
    }), " Flag"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return submitCustomLog(false);
      },
      disabled: !customLog.trim(),
      variant: "secondary",
      className: "h-10 w-24 max-md:w-auto max-md:px-2 shrink-0"
    }, "Add Log"))) : /*#__PURE__*/React.createElement("div", {
      className: "flex-1 min-w-0 flex flex-col bg-slate-800 rounded border border-slate-700 md:overflow-hidden relative"
    }, searchTerm.length > 0 && searchResults.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "absolute top-[64px] left-2 right-2 bg-slate-800 border border-slate-600 rounded shadow-2xl z-40 max-h-64 overflow-y-auto"
    }, searchResults.map(function (key) {
      return /*#__PURE__*/React.createElement("button", {
        key: key,
        onClick: function onClick() {
          applyIntervention(key);
          setSearchTerm("");
          setSearchResults([]);
        },
        className: "w-full text-left p-3 hover:bg-slate-700 border-b border-slate-700 last:border-0 flex justify-between items-center group"
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-sky-400"
      }, INTERVENTIONS[key].label, INTERVENTIONS[key].route && INTERVENTIONS[key].route !== 'n/a' ? /*#__PURE__*/React.createElement("span", {
        className: "ml-2 text-[10px] font-normal text-slate-400 uppercase tracking-wide"
      }, INTERVENTIONS[key].route) : null), /*#__PURE__*/React.createElement("span", {
        className: "text-xs text-slate-400 uppercase"
      }, INTERVENTIONS[key].category));
    })), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-2 border-b border-slate-700"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      "aria-label": "Search interventions",
      className: "w-full bg-slate-800 border border-slate-600 rounded px-4 h-11 text-base text-white focus:border-sky-500 outline-none",
      placeholder: "Search (name or route, e.g. IM)",
      value: searchTerm,
      onChange: function onChange(e) {
        return setSearchTerm(e.target.value);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap bg-slate-900 border-b border-slate-700"
    }, ['Common', 'Drugs', 'Airway', 'Breathing', 'Circulation', 'Procedures', 'Investigations', 'Voice', 'Assessment'].map(function (cat) {
      return /*#__PURE__*/React.createElement("button", {
        key: cat,
        onClick: function onClick() {
          return setActiveTab(cat);
        },
        className: "px-2 md:px-4 py-2 md:py-3 text-[10px] md:text-xs font-bold uppercase tracking-wider transition-colors whitespace-nowrap ".concat(activeTab === cat ? 'bg-slate-800 text-sky-400 border-t-2 border-sky-400' : 'text-slate-400 hover:text-slate-300', " ").concat(cat === 'Assessment' ? 'md:ml-auto border-l border-slate-700 text-amber-400' : '')
      }, cat);
    })), /*#__PURE__*/React.createElement("div", {
      className: "md:flex-1 p-3 md:overflow-y-auto bg-slate-800 relative"
    }, activeTab === 'Assessment' ? /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 p-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-sky-900/20 border border-sky-500/30 p-4 rounded-lg"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-sm font-bold text-sky-400 uppercase mb-2 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "clipboard-check",
      className: "w-4 h-4"
    }), " Live Skills Checklist"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-4"
    }, "Mark skills as observed (Green) or needs improvement (Red). This data will appear in the debrief."), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-2 gap-3"
    }, Object.keys(assessments).map(function (skill) {
      return /*#__PURE__*/React.createElement("div", {
        key: skill,
        className: "flex items-center justify-between bg-slate-900 p-3 rounded border border-slate-700"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-sm font-bold text-slate-200"
      }, skill), /*#__PURE__*/React.createElement("div", {
        className: "flex gap-2"
      }, /*#__PURE__*/React.createElement("button", {
        "aria-label": "Mark ".concat(skill, " as needing improvement"),
        onClick: function onClick() {
          return setAssessments(_objectSpread(_objectSpread({}, assessments), {}, _defineProperty({}, skill, false)));
        },
        className: "p-2 rounded border ".concat(assessments[skill] === false ? 'bg-red-600 border-red-500 text-white' : 'bg-slate-800 border-slate-600 text-slate-400')
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-4 h-4"
      })), /*#__PURE__*/React.createElement("button", {
        "aria-label": "Mark ".concat(skill, " as achieved"),
        onClick: function onClick() {
          return setAssessments(_objectSpread(_objectSpread({}, assessments), {}, _defineProperty({}, skill, true)));
        },
        className: "p-2 rounded border ".concat(assessments[skill] === true ? 'bg-emerald-600 border-emerald-500 text-white' : 'bg-slate-800 border-slate-600 text-slate-400')
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "check",
        className: "w-4 h-4"
      }))));
    })))) : activeTab === 'Voice' ? renderVoicePanel() : activeTab === 'Investigations' ? /*#__PURE__*/React.createElement(React.Fragment, null, window.InvResults && /*#__PURE__*/React.createElement(Section, {
      id: "invResults",
      tone: "card",
      title: "What the monitor buttons give",
      defaultOpen: true,
      summary: invChangedSummary(scenario),
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(window.InvResults.LiveResults, {
      sim: sim,
      addLogEntry: addLogEntry
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1"
    }, "Send a result to the monitor now"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2"
    }, ['ECG', 'VBG', 'ABG', 'X-ray', 'Urine', 'POCUS', 'CT'].map(function (type) {
      return /*#__PURE__*/React.createElement(Button, {
        key: type,
        onClick: function onClick() {
          return type === 'ABG' ? revealInvestigation('ABG') : handleInvClick(type);
        },
        title: type === 'ABG' ? 'Sends the arterial gas now. It follows the VBG result above.' : undefined,
        variant: "outline",
        className: "h-14 flex flex-col items-center justify-center gap-1"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "activity",
        className: "w-4 h-4 text-sky-400"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-xs font-bold"
      }, "Send ", type));
    }))) : activeTab === 'Drugs' ? renderDrugsTab() : /*#__PURE__*/React.createElement(React.Fragment, null, scenario.recommendedActions && scenario.recommendedActions.length > 0 && activeTab === 'Common' && /*#__PURE__*/React.createElement("div", {
      className: "mb-4 p-4 bg-amber-900/20 border-2 border-amber-500 rounded-lg shadow-lg"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-amber-400 uppercase mb-3 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "check-circle",
      className: "w-4 h-4"
    }), " Recommended Actions"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3"
    }, scenario.recommendedActions.map(function (key) {
      if (!INTERVENTIONS[key]) return null;
      return renderActionBtn(key);
    }))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2"
    }, getInterventionsByCat(activeTab).filter(function (key) {
      return !(activeTab === 'Common' && (scenario.recommendedActions || []).indexOf(key) !== -1);
    }).map(function (key) {
      return renderActionBtn(key);
    })), scenario.customActions && scenario.customActions.length > 0 && activeTab === 'Common' && /*#__PURE__*/React.createElement("div", {
      className: "mt-4 p-4 bg-sky-900/20 border-2 border-sky-500 rounded-lg shadow-lg"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-sky-400 uppercase mb-3 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "settings",
      className: "w-4 h-4"
    }), " Scenario Actions"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3"
    }, scenario.customActions.map(function (action, idx) {
      return /*#__PURE__*/React.createElement("button", {
        key: idx,
        onClick: function onClick() {
          return addLogEntry(action, 'action');
        },
        className: "h-14 p-2 rounded text-left bg-sky-900/30 hover:bg-sky-800/50 border border-sky-600 flex items-center text-xs font-bold text-sky-300"
      }, action);
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "flex-none border-t border-slate-700 bg-slate-900",
      "data-testid": "event-log"
    }, /*#__PURE__*/React.createElement(Section, {
      id: "eventLog",
      title: "Event log (".concat(state.log.length, ")"),
      summary: state.log.length ? state.log[state.log.length - 1].msg : 'Nothing logged yet',
      defaultOpen: true,
      className: "border-0 rounded-none bg-slate-900",
      right: /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setShowLogModal(true);
        },
        className: "text-[10px] uppercase font-bold text-sky-400 hover:text-sky-200 flex-none"
      }, "Full log")
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-mono text-[11px] space-y-0.5 max-h-[18vh] min-h-[3rem] overflow-y-auto mb-2 pr-1"
    }, state.log.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 py-2"
    }, "Nothing logged yet."), state.log.map(function (entry, i) {
      return {
        entry: entry,
        i: i
      };
    }).reverse().slice(0, 60).map(function (_ref0) {
      var entry = _ref0.entry,
        i = _ref0.i;
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "flex gap-2 items-start ".concat(entry.flagged ? 'bg-amber-900/20 rounded' : '')
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-label": "".concat(entry.flagged ? 'Unflag' : 'Flag', " log entry at ").concat(entry.simTime),
        onClick: function onClick() {
          return sim.dispatch({
            type: 'TOGGLE_FLAG',
            payload: i
          });
        },
        className: "flex-none mt-0.5 ".concat(entry.flagged ? 'text-amber-500' : 'text-slate-500 hover:text-amber-500')
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "flag",
        className: "w-3 h-3"
      })), /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 w-11 flex-none",
        title: entry.time ? "Clock time ".concat(entry.time) : undefined
      }, entry.simTime), /*#__PURE__*/React.createElement("span", {
        title: entry.msg,
        className: "flex-1 min-w-0 line-clamp-2 ".concat(entry.type === 'danger' ? 'text-red-400 font-bold' : entry.type === 'warning' ? 'text-amber-300' : entry.type === 'success' ? 'text-emerald-400' : 'text-slate-300')
      }, entry.msg));
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      "aria-label": "Note for the log",
      className: "bg-slate-800 border border-slate-600 rounded px-3 h-9 text-sm flex-1 min-w-[8rem] text-white focus:border-amber-500 outline-none",
      placeholder: "Add a note",
      value: customLog,
      onChange: function onChange(e) {
        return setCustomLog(e.target.value);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') submitCustomLog(false);
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return submitCustomLog(true);
      },
      disabled: !customLog.trim(),
      variant: "secondary",
      className: "h-9 px-3 shrink-0 text-amber-500 border-amber-500/30"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "flag",
      className: "w-4 h-4 mr-1"
    }), " Flag"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return submitCustomLog(false);
      },
      disabled: !customLog.trim(),
      variant: "secondary",
      className: "h-9 px-3 shrink-0"
    }, "Add note"))))))), showLogModal && /*#__PURE__*/React.createElement(Modal, {
      label: "Simulation log",
      onClose: function onClose() {
        return setShowLogModal(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-2xl shadow-2xl h-[80vh] flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-4"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Simulation Log"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowLogModal(false);
      },
      size: "sm",
      variant: "outline"
    }, "Close")), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 overflow-y-auto bg-slate-900 p-4 rounded border border-slate-700 font-mono text-sm space-y-2"
    }, state.log.map(function (entry, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "flex gap-4 border-b border-slate-800 pb-1 items-center ".concat(entry.flagged ? 'bg-amber-900/20 -mx-2 px-2' : '')
      }, /*#__PURE__*/React.createElement("button", {
        "aria-label": "".concat(entry.flagged ? 'Unflag' : 'Flag', " log entry at ").concat(entry.simTime),
        onClick: function onClick() {
          return sim.dispatch({
            type: 'TOGGLE_FLAG',
            payload: i
          });
        },
        className: "text-slate-400 hover:text-amber-500 transition-colors ".concat(entry.flagged ? 'text-amber-500' : '')
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "flag",
        className: "w-4 h-4"
      })), /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 w-20 flex-shrink-0"
      }, entry.simTime), /*#__PURE__*/React.createElement("span", {
        className: "flex-grow ".concat(entry.type === 'danger' ? 'text-red-400 font-bold' : entry.type === 'warning' ? 'text-amber-300 font-bold' : entry.type === 'success' ? 'text-emerald-400 font-bold' : 'text-slate-300')
      }, entry.msg));
    })))), showNIBPModal && /*#__PURE__*/React.createElement(Modal, {
      label: "NIBP control",
      onClose: function onClose() {
        return setShowNIBPModal(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-sm shadow-2xl"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-1 uppercase tracking-wider"
    }, "Manual NIBP reading"), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400 mb-4"
    }, "Shows this one reading on the team's NIBP without changing the patient's BP \u2014 the next cuff cycle measures the real value again. To change the patient's BP, use the BP tile."), /*#__PURE__*/React.createElement("div", {
      className: "space-y-4"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase"
    }, "Systolic"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Systolic",
      type: "number",
      value: nibpSys,
      onChange: function onChange(e) {
        return setNibpSys(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-500 rounded p-3 text-xl font-mono text-white text-center font-bold"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase"
    }, "Diastolic"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Diastolic",
      type: "number",
      value: nibpDia,
      onChange: function onChange(e) {
        return setNibpDia(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-500 rounded p-3 text-xl font-mono text-white text-center font-bold"
    })), nibpError && /*#__PURE__*/React.createElement("div", {
      className: "bg-red-900/30 border border-red-600 rounded p-2 text-red-200 text-xs font-bold text-center"
    }, nibpError), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        if (nibpError) return;
        sim.dispatch({
          type: 'SET_NIBP',
          payload: {
            sys: parseFloat(nibpSys),
            dia: parseFloat(nibpDia)
          }
        });
        setShowNIBPModal(false);
        addLogEntry("NIBP Manual: ".concat(nibpSys, "/").concat(nibpDia), 'manual');
      },
      variant: "primary",
      disabled: !!nibpError,
      className: "h-12 text-sm ".concat(nibpError ? 'opacity-40 cursor-not-allowed' : '')
    }, "Send Value"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        triggerNIBP();
        setShowNIBPModal(false);
      },
      variant: "warning",
      className: "h-12 text-sm"
    }, "Cycle Cuff")), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowNIBPModal(false);
      },
      variant: "outline",
      className: "w-full"
    }, "Cancel")))), invModal && /*#__PURE__*/React.createElement(Modal, {
      label: "Investigation result",
      onClose: dismissInv
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-lg shadow-2xl h-[90vh] flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Choose ", invModal, " result"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400"
    }, "Nothing has been sent yet. Pick a finding (or type one) and it goes to the student monitor.")), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Dismiss without sending",
      onClick: dismissInv,
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 overflow-y-auto flex-grow pr-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        revealInvestigation(invModal, null, {
          normal: true,
          hideReport: !invWithReport
        });
        setInvModal(null);
      },
      variant: "secondary",
      title: "A normal result for this patient, with its picture (the 12-lead is drawn from the current rhythm)."
    }, "Normal"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return sendScenarioDefault(invModal);
      },
      variant: "secondary",
      title: "Sends this scenario's own result (shown below)."
    }, "Scenario Finding")), function () {
      var pv = scenarioResultPreview(invModal);
      if (!pv || !pv.text && !pv.image) return null;
      var img = pv.image && INV ? INV.imageFor(pv.image) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 border border-slate-700 rounded p-2 flex gap-2 items-start",
        "data-testid": "inv-scenario-preview"
      }, img && /*#__PURE__*/React.createElement("img", {
        src: img.src,
        alt: "",
        className: "w-20 h-16 object-cover rounded flex-none bg-white"
      }), /*#__PURE__*/React.createElement("div", {
        className: "text-[11px] text-slate-300 leading-snug"
      }, /*#__PURE__*/React.createElement("b", {
        className: "text-slate-100"
      }, "Scenario finding:"), " ", pv.text || 'Image only.', pv.ecgImageNotFitting && /*#__PURE__*/React.createElement("span", {
        className: "block text-amber-300 mt-0.5"
      }, "The real ECG for this scenario no longer matches the current rhythm, so the monitor will draw the 12-lead from the live rhythm instead.")));
    }(), courseMedia.some(function (m) {
      return m.type === invModal;
    }) && /*#__PURE__*/React.createElement("div", {
      "data-testid": "inv-course-media"
    }, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-purple-300 font-bold uppercase mb-2 block"
    }, "Course images (", MSX.courseOf(scenario), ")"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 gap-1.5"
    }, courseMedia.filter(function (m) {
      return m.type === invModal;
    }).map(function (m, i) {
      return /*#__PURE__*/React.createElement("button", {
        key: "".concat(m.image, "-").concat(i),
        type: "button",
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _context.n = 1;
                return showCourseImage(m, invWithReport);
              case 1:
                setInvModal(null);
              case 2:
                return _context.a(2);
            }
          }, _callee);
        })),
        className: "text-left px-3 py-1.5 bg-slate-700 hover:bg-slate-600 text-xs text-slate-100 rounded border border-purple-500/50"
      }, /*#__PURE__*/React.createElement("b", null, m.label || m.type), m.caption ? ": ".concat(m.caption) : '');
    }))), INV && INV.FINDINGS[invModal] && /*#__PURE__*/React.createElement("label", {
      className: "flex items-center gap-2 text-xs text-slate-300 cursor-pointer"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: invWithReport,
      onChange: function onChange(e) {
        return setInvWithReport(e.target.checked);
      }
    }), "Show the written report with the image (untick to show the image alone, for the team to interpret)"), INV && INV.FINDINGS[invModal] && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase mb-2 block"
    }, "Results with a real image"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 gap-2",
      "data-testid": "inv-library"
    }, INV.FINDINGS[invModal].filter(function (f) {
      return f.image;
    }).map(function (f) {
      var img = INV.imageFor(f.image);
      return /*#__PURE__*/React.createElement("button", {
        key: f.id,
        type: "button",
        onClick: function onClick() {
          return sendInv(invModal, f.report, f.image);
        },
        title: f.report,
        className: "text-left flex gap-2 items-center p-1.5 bg-slate-700 hover:bg-slate-600 rounded border border-slate-600"
      }, /*#__PURE__*/React.createElement("img", {
        src: img.src,
        alt: "",
        className: "w-14 h-11 object-cover rounded flex-none bg-white",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-xs text-slate-100 leading-tight"
      }, f.label));
    })), INV.FINDINGS[invModal].some(function (f) {
      return !f.image;
    }) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase mt-3 mb-2 block"
    }, "More results (written report only)"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 gap-1.5"
    }, INV.FINDINGS[invModal].filter(function (f) {
      return !f.image;
    }).map(function (f) {
      return /*#__PURE__*/React.createElement("button", {
        key: f.id,
        type: "button",
        onClick: function onClick() {
          return sendInv(invModal, f.report);
        },
        title: f.report,
        className: "text-left px-3 py-1.5 bg-slate-700 hover:bg-slate-600 text-xs text-slate-200 rounded border border-slate-600"
      }, f.label);
    })))), PREDEFINED_FINDINGS[invModal] && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase mb-2 block"
    }, "Other quick results (text)"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 gap-2"
    }, PREDEFINED_FINDINGS[invModal].map(function (finding) {
      return /*#__PURE__*/React.createElement("button", {
        key: finding,
        onClick: function onClick() {
          return sendInv(invModal, finding);
        },
        className: "text-left px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm text-slate-200 rounded border border-slate-600 transition-colors"
      }, finding);
    }))), (invModal === 'X-ray' || invModal === 'CT') && scenario.customImages && scenario.customImages[invModal === 'X-ray' ? 'xray' : 'ct'] && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase mb-1 block"
    }, "Scenario Image"), /*#__PURE__*/React.createElement("a", {
      href: scenario.customImages[invModal === 'X-ray' ? 'xray' : 'ct'],
      target: "_blank",
      rel: "noopener noreferrer",
      className: "text-sky-400 hover:text-sky-300 underline text-sm break-all"
    }, scenario.customImages[invModal === 'X-ray' ? 'xray' : 'ct'])), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase mb-1 block"
    }, "Custom Finding"), /*#__PURE__*/React.createElement("textarea", {
      value: invCustomText,
      onChange: function onChange(e) {
        return setInvCustomText(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm h-20",
      placeholder: "Type custom finding here..."
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return sendInv(invModal, invCustomText);
      },
      variant: "primary",
      className: "w-full mt-2",
      disabled: !invCustomText.trim()
    }, "Send Custom"))), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 pt-4 mt-2 flex-shrink-0 grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: dismissInv,
      variant: "outline",
      className: "w-full"
    }, "Cancel (send nothing)"), /*#__PURE__*/React.createElement(Button, {
      onClick: clearInvOnMonitor,
      variant: "danger",
      className: "w-full"
    }, "Clear result on monitor")))), modalVital && /*#__PURE__*/React.createElement(Modal, {
      label: "Vital control",
      onClose: function onClose() {
        return setModalVital(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-sm shadow-2xl"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-4 uppercase tracking-wider"
    }, "Set ", VITAL_NAMES[modalVital] || modalVital), /*#__PURE__*/React.createElement("div", {
      className: "space-y-4",
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter' && e.target && e.target.type === 'number') {
          e.preventDefault();
          confirmVitalUpdate(false);
        }
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase"
    }, modalVital === 'bp' ? 'Systolic' : modalVital === 'gcs' ? 'Total (type it, or pick E, V and M below)' : 'Target'), /*#__PURE__*/React.createElement("input", {
      "aria-label": modalVital === 'bp' ? 'Systolic' : VITAL_NAMES[modalVital] || 'Target',
      type: "number",
      step: modalVital === 'ph' ? 0.01 : modalVital === 'temp' || modalVital === 'etco2' || modalVital === 'bm' || modalVital === 'k' ? 0.1 : 1,
      value: modalTarget,
      onChange: function onChange(e) {
        setModalTarget(e.target.value);
        if (modalVital === 'gcs') {
          var t = Math.round(parseFloat(e.target.value));
          setGcsParts(t >= 3 && t <= 15 ? gcsSplit(t) : null);
        }
      },
      onFocus: function onFocus(e) {
        return e.target.select();
      },
      className: "w-full bg-slate-900 border border-slate-500 rounded p-3 text-xl font-mono text-white text-center font-bold",
      autoFocus: true
    })), modalVital === 'gcs' && /*#__PURE__*/React.createElement("div", {
      "data-testid": "gcs-parts",
      className: "space-y-2"
    }, ['e', 'v', 'm'].map(function (k) {
      return /*#__PURE__*/React.createElement("div", {
        key: k,
        role: "group",
        "aria-label": GCS_SCALE[k].label
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-400 font-bold uppercase mb-1"
      }, GCS_SCALE[k].label, gcsParts ? /*#__PURE__*/React.createElement("span", {
        className: "text-white ml-1"
      }, gcsParts[k]) : null), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-3 gap-1"
      }, GCS_SCALE[k].options.map(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
          n = _ref11[0],
          txt = _ref11[1];
        return /*#__PURE__*/React.createElement("button", {
          key: n,
          type: "button",
          onClick: function onClick() {
            return pickGcsPart(k, n);
          },
          "aria-pressed": !!gcsParts && gcsParts[k] === n,
          "aria-label": "".concat(k.toUpperCase()).concat(n, " ").concat(txt),
          className: "p-1.5 rounded border text-[11px] font-bold leading-tight ".concat(gcsParts && gcsParts[k] === n ? 'bg-sky-700 border-sky-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-300')
        }, n, " ", /*#__PURE__*/React.createElement("span", {
          className: "font-normal"
        }, txt));
      })));
    }), gcsParts && /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-300 text-center font-mono",
      "data-testid": "gcs-parts-total"
    }, gcsPartsLabel(gcsParts), " = ", gcsParts.e + gcsParts.v + gcsParts.m)), modalVital === 'bp' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase"
    }, "Diastolic"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Diastolic",
      type: "number",
      value: modalTarget2,
      onChange: function onChange(e) {
        return setModalTarget2(e.target.value);
      },
      onFocus: function onFocus(e) {
        return e.target.select();
      },
      className: "w-full bg-slate-900 border border-slate-500 rounded p-3 text-xl font-mono text-white text-center font-bold"
    })), modalVital === 'etco2' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase mb-2 block"
    }, "Capnogram shape"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 gap-2"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setEtco2Shape('normal');
      },
      title: "Follow the patient: the scenario's bronchospasm severity shapes the trace and treatment normalises it.",
      className: "p-2 rounded border text-xs font-bold ".concat(etco2Shape === 'normal' ? 'bg-sky-600 border-sky-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300')
    }, "Auto"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setEtco2Shape('bronchospastic');
      },
      title: "Force a severe shark fin regardless of the model.",
      className: "p-2 rounded border text-xs font-bold ".concat(etco2Shape === 'bronchospastic' ? 'bg-sky-600 border-sky-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300')
    }, "Obstructive"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setEtco2Shape('nonobstructive');
      },
      title: "Force a normal square capnogram regardless of the model.",
      className: "p-2 rounded border text-xs font-bold ".concat(etco2Shape === 'nonobstructive' ? 'bg-sky-600 border-sky-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300')
    }, "Force normal"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setEtco2Shape('rebreathing');
      },
      title: "Rebreathing: the baseline does not return to zero on inspiration (exhausted soda lime, inadequate fresh gas flow, faulty valve).",
      className: "p-2 rounded border text-xs font-bold ".concat(etco2Shape === 'rebreathing' ? 'bg-sky-600 border-sky-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300')
    }, "Rebreathing"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setEtco2Shape('curare');
      },
      title: "Curare cleft: a notch in the plateau from a spontaneous breath against the ventilator (neuromuscular block wearing off).",
      className: "p-2 rounded border text-xs font-bold ".concat(etco2Shape === 'curare' ? 'bg-sky-600 border-sky-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300')
    }, "Curare cleft")), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 mt-2 leading-relaxed"
    }, "No waveform at all (apnoea, oesophageal tube, disconnection) shows by itself when nothing is ventilating the patient; during CPR the trace is low with compression ripples."), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 mt-2 font-mono"
    }, "obstruction ", Math.round(capnoSeverity * 100), "% \xB7 ", obstruction.band, obstruction.relief > 0 ? " \xB7 bronchodilator relief ".concat(Math.round(obstruction.relief * 100), "%") : '', obstruction.source ? " \xB7 ".concat(obstruction.source) : '')), window.TraceVariations && (modalVital === 'hr' || modalVital === 'spO2' || modalVital === 'bp') && /*#__PURE__*/React.createElement(window.TraceVariations, {
      kind: modalVital,
      sim: sim,
      noise: state.noise,
      hasArt: !!sensors.art,
      hasSpo2: !!sensors.spo2,
      hasEcg: !!sensors.ecg
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase mb-1 block"
    }, "Get there"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-4 gap-1"
    }, [[0, 'Now'], [30, '30 s'], [120, '2 min'], [300, '5 min']].map(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
        d = _ref13[0],
        lbl = _ref13[1];
      return /*#__PURE__*/React.createElement("button", {
        key: d,
        onClick: function onClick() {
          return setTrendDuration(d);
        },
        "aria-pressed": trendDuration === d,
        className: "p-2 rounded text-[11px] font-bold border ".concat(trendDuration === d ? 'bg-sky-700 border-sky-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-300')
      }, lbl);
    }))), modalVital === 'bp' && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border border-slate-700 rounded p-2 text-[10px] text-slate-400 leading-relaxed"
    }, !sensors.nibp && !sensors.art ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", {
      className: "text-amber-300"
    }, "No NIBP cuff or arterial line attached"), " \u2014 the team will not see this until one is attached and measures.") : /*#__PURE__*/React.createElement("span", null, sensors.art ? 'The arterial line follows this live. ' : '', sensors.nibp ? /*#__PURE__*/React.createElement(React.Fragment, null, "The room monitor keeps showing the last cuff reading", state.nibp && state.nibp.sys ? /*#__PURE__*/React.createElement(React.Fragment, null, " (", /*#__PURE__*/React.createElement("b", {
      className: "text-slate-200"
    }, Math.round(state.nibp.sys), "/", Math.round(state.nibp.dia)), ")") : null, " until the cuff next cycles: the team's press, yours, or the auto timer", state.nibp && state.nibp.mode === 'auto' ? /*#__PURE__*/React.createElement(React.Fragment, null, " (", /*#__PURE__*/React.createElement("b", {
      className: "text-emerald-300"
    }, "auto is on"), ")") : null, ".") : '')), modalVital === 'hr' && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border border-slate-700 rounded p-2 text-[10px] text-slate-400 leading-relaxed"
    }, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-200"
    }, "Your value wins."), " A later rhythm change will ", /*#__PURE__*/React.createElement("b", null, "not"), " overwrite an HR you set here \u2014 it keeps your number and says so in the log. Only ARREST and ROSC reset it, because those define a new baseline. Set HR here again at any time to change it."), vitalModalError && /*#__PURE__*/React.createElement("div", {
      className: "bg-red-900/30 border border-red-600 rounded p-2 text-red-200 text-xs font-bold text-center"
    }, vitalModalError), modalVital === 'bp' && trendDuration === 0 && sensors.nibp ? /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 gap-2 mt-4"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return confirmVitalUpdate(false);
      },
      variant: "success",
      disabled: !!vitalModalError,
      className: "h-14 text-sm font-bold leading-tight ".concat(vitalModalError ? 'opacity-40 cursor-not-allowed' : '')
    }, "Change, don't send"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return confirmVitalUpdate(true);
      },
      variant: "primary",
      disabled: !!vitalModalError,
      className: "h-14 text-sm font-bold leading-tight ".concat(vitalModalError ? 'opacity-40 cursor-not-allowed' : '')
    }, "Change and cycle cuff now"), /*#__PURE__*/React.createElement("p", {
      className: "sm:col-span-2 text-[10px] text-slate-400 leading-relaxed"
    }, "\u201CChange, don't send\u201D changes the patient now; the monitor shows it at the next cuff cycle. \u201CCycle cuff now\u201D changes it and starts a measurement: the cuff inflates for about 5 s, then the new reading appears.")) : /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return confirmVitalUpdate(false);
      },
      variant: "success",
      disabled: !!vitalModalError,
      className: "w-full mt-4 h-12 text-lg font-bold ".concat(vitalModalError ? 'opacity-40 cursor-not-allowed' : '')
    }, modalVital === 'bp' ? trendDuration === 0 ? 'Change BP' : 'Start the change' : 'CONFIRM'), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setModalVital(null);
      },
      variant: "outline",
      className: "w-full"
    }, "Cancel")))), showRhythmModal && /*#__PURE__*/React.createElement(Modal, {
      label: "Select rhythm",
      onClose: function onClose() {
        return setShowRhythmModal(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-2xl shadow-2xl"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-1 uppercase tracking-wider"
    }, "Select Rhythm"), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400 mb-3"
    }, "Each rhythm carries a typical rate, which is applied only if you have not set HR yourself. If you have, your HR stands and the log records why \u2014 facilitator values are never silently overwritten."), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 gap-2"
    }, RHYTHMS.map(function (r) {
      return /*#__PURE__*/React.createElement("button", {
        key: r,
        onClick: function onClick() {
          changeRhythm(r, 'manual selection');
          setShowRhythmModal(false);
        },
        className: "p-3 text-sm font-bold rounded border ".concat(state.rhythm === r ? 'bg-sky-700 border-sky-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-300 hover:bg-slate-600')
      }, RG.labelFor(r));
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowRhythmModal(false);
      },
      variant: "outline",
      className: "w-full mt-4"
    }, "Cancel"))), showDrugCalc && /*#__PURE__*/React.createElement(Modal, {
      label: "Drug dosing calculator",
      onClose: function onClose() {
        return setShowDrugCalc(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-lg shadow-2xl h-[90vh] flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-4"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Drug Dosing Calculator"), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close drug calculator",
      onClick: function onClick() {
        return setShowDrugCalc(false);
      },
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "mb-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "text-xs text-slate-400 font-bold uppercase"
    }, "Patient Weight (kg)"), /*#__PURE__*/React.createElement("input", {
      "aria-label": "Patient Weight (kg)",
      type: "number",
      min: "0.5",
      max: "300",
      step: "0.1",
      value: drugCalcWeightStr,
      onChange: function onChange(e) {
        return setDrugCalcWeightStr(e.target.value);
      },
      className: "w-full bg-slate-900 border rounded p-2 text-xl font-mono text-white text-center font-bold mt-1 ".concat(drugCalcWeightError ? 'border-red-500' : 'border-slate-500')
    }), drugCalcWeightError && /*#__PURE__*/React.createElement("div", {
      className: "text-red-400 text-xs font-bold mt-1"
    }, drugCalcWeightError)), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 overflow-y-auto space-y-2 pr-1"
    }, drugCalcWeightError && /*#__PURE__*/React.createElement("div", {
      className: "bg-red-900/30 border border-red-600 rounded p-4 text-center text-red-200 text-sm"
    }, "Doses hidden until a valid weight is entered."), !drugCalcWeightError && DRUG_CALC_LIST.map(function (drug, idx) {
      var calcAge = Number.isFinite(Number(scenario.patientAge)) ? Number(scenario.patientAge) : null;
      var maxDose = drug.maxByAge ? drug.maxByAge(calcAge) : drug.max;
      var rawDose = drug.byAge ? drug.byAge(calcAge) : drug.perKg * drugCalcWeight;
      var minDose = drug.min ? Math.max(rawDose, drug.min) : rawDose;
      var finalDose = Math.min(minDose, maxDose);
      var shown = drug.display && drug.display(calcAge) || (finalDose < 1 ? finalDose.toFixed(2).replace(/0$/, '') : finalDose.toFixed(1));
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "bg-slate-900 border border-slate-700 rounded p-3 flex justify-between items-center"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "text-sm font-bold text-white"
      }, drug.name), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-400"
      }, drug.info)), /*#__PURE__*/React.createElement("div", {
        className: "text-right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-lg font-bold text-sky-400 font-mono"
      }, shown, " ", drug.unit), /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-slate-400"
      }, drug.byAge ? "for age ".concat(calcAge === null ? 'adult' : calcAge) : "max ".concat(maxDose).concat(drug.unit))));
    })))), showTimerModal && /*#__PURE__*/React.createElement(Modal, {
      label: "Timer alerts",
      onClose: function onClose() {
        return setShowTimerModal(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-md shadow-2xl"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-4"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Timer Alerts"), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close timer alerts",
      onClick: function onClick() {
        return setShowTimerModal(false);
      },
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-3 mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0.5",
      max: "180",
      step: "0.5",
      value: newAlertMins,
      onChange: function onChange(e) {
        setNewAlertMins(e.target.value);
        setTimerAlertError('');
      },
      placeholder: "Mins",
      className: "w-20 bg-slate-900 border border-slate-600 rounded p-2 text-white text-center"
    }), /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: newAlertMsg,
      onChange: function onChange(e) {
        return setNewAlertMsg(e.target.value);
      },
      placeholder: "Alert message...",
      className: "flex-1 bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm"
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: addTimerAlert,
      variant: "primary",
      className: "h-10 px-3"
    }, "Add")), timerAlertError && /*#__PURE__*/React.createElement("div", {
      className: "text-red-400 text-xs font-bold"
    }, timerAlertError), /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400"
    }, "Alerts fire automatically at the set sim time and play a tone.")), /*#__PURE__*/React.createElement("div", {
      className: "space-y-2 max-h-64 overflow-y-auto"
    }, timerAlerts.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-sm text-center py-4"
    }, "No alerts set"), timerAlerts.map(function (alert) {
      return /*#__PURE__*/React.createElement("div", {
        key: alert.id,
        className: "flex items-center justify-between p-3 rounded border ".concat(firedAlerts.has(alert.id) ? 'bg-red-900/30 border-red-600' : 'bg-slate-900 border-slate-700')
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "text-white font-bold text-sm"
      }, alert.msg), /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 text-xs ml-2"
      }, "@ ", alert.mins, "min"), firedAlerts.has(alert.id) && /*#__PURE__*/React.createElement("span", {
        className: "text-red-400 text-xs ml-2 font-bold"
      }, "FIRED")), /*#__PURE__*/React.createElement("button", {
        "aria-label": "Remove alert: ".concat(alert.msg),
        onClick: function onClick() {
          return setTimerAlerts(function (prev) {
            return prev.filter(function (a) {
              return a.id !== alert.id;
            });
          });
        },
        className: "text-slate-400 hover:text-red-400"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-4 h-4"
      })));
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowTimerModal(false);
      },
      variant: "outline",
      className: "w-full mt-4"
    }, "Close"))), showFlagsModal && /*#__PURE__*/React.createElement(Modal, {
      label: "Safety flags",
      onClose: function onClose() {
        return setShowFlagsModal(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-amber-600/60 w-full max-w-2xl shadow-2xl max-h-[80vh] flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-3"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-amber-400 uppercase tracking-wider flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "flag",
      className: "w-4 h-4"
    }), " Safety flags (", deviationEntries.length, ")"), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close safety flags",
      onClick: function onClick() {
        return setShowFlagsModal(false);
      },
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-3"
    }, "Nothing was blocked. The count is the number of ", /*#__PURE__*/React.createElement("b", null, "sequence deviations"), " \u2014 actions performed before their usual prerequisites were in place. Arrests, shocks and hand-flagged moments are listed separately below as significant events; they are not deviations and are not counted."), deviationEntries.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mb-4"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold text-slate-400 uppercase mb-2"
    }, "Sequence deviations"), /*#__PURE__*/React.createElement("div", {
      className: "space-y-2"
    }, deviationEntries.map(function (entry, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "bg-amber-950/30 border border-amber-700/50 rounded p-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-sm font-bold text-amber-200"
      }, entry.deviation.label || entry.deviation.action), /*#__PURE__*/React.createElement("span", {
        className: "font-mono text-xs text-slate-400"
      }, entry.simTime)), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-300 mt-0.5"
      }, "Not in place: ", entry.deviation.missing.join(', ')));
    }))), /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold text-slate-400 uppercase mb-2"
    }, "Other significant events (", significanceEntries.length, ")"), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 overflow-y-auto bg-slate-900 p-3 rounded border border-slate-700 font-mono text-xs space-y-1"
    }, significanceEntries.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-center py-4"
    }, "No other flagged events."), significanceEntries.map(function (entry, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "flex gap-3"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 w-14 flex-shrink-0"
      }, entry.simTime), /*#__PURE__*/React.createElement("span", {
        className: "text-slate-200"
      }, entry.msg));
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowFlagsModal(false);
      },
      variant: "outline",
      className: "w-full mt-4"
    }, "Close"))), showJoin && window.ScreensPanel && /*#__PURE__*/React.createElement(Modal, {
      label: "Patient screens",
      onClose: function onClose() {
        return setShowJoin(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-5 rounded-lg border border-slate-600 w-full max-w-3xl shadow-2xl max-h-[90vh] overflow-y-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-3"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Patient screens"), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close screens",
      onClick: function onClick() {
        return setShowJoin(false);
      },
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement(window.ScreensPanel, {
      sessionID: sessionID
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowJoin(false);
      },
      variant: "outline",
      className: "w-full mt-4"
    }, "Done"))), showMarkSheet && hasMarkSheet && /*#__PURE__*/React.createElement(window.MarkScheme.MarkSheetModal, {
      scenario: scenario,
      onClose: function onClose() {
        return setShowMarkSheet(false);
      },
      onShowImage: showCourseImage,
      onClearImage: clearInvOnMonitor
    }), showKeyHelp && /*#__PURE__*/React.createElement(Modal, {
      label: "Keyboard shortcuts",
      onClose: function onClose() {
        return setShowKeyHelp(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-sm shadow-2xl"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-4"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Keyboard Shortcuts"), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close keyboard shortcuts",
      onClick: function onClick() {
        return setShowKeyHelp(false);
      },
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-2"
    }, [['Space', 'Play / Pause sim'], ['F', 'Finish sim'], ['D', 'Toggle Drug Calculator'], ['T', 'Toggle Timer Alerts'], ['?', 'Show this help']].map(function (_ref14) {
      var _ref15 = _slicedToArray(_ref14, 2),
        key = _ref15[0],
        desc = _ref15[1];
      return /*#__PURE__*/React.createElement("div", {
        key: key,
        className: "flex items-center justify-between p-2 bg-slate-900 rounded border border-slate-700"
      }, /*#__PURE__*/React.createElement("kbd", {
        className: "bg-slate-700 border border-slate-500 text-white text-xs font-mono px-3 py-1 rounded"
      }, key), /*#__PURE__*/React.createElement("span", {
        className: "text-slate-300 text-sm"
      }, desc));
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowKeyHelp(false);
      },
      variant: "outline",
      className: "w-full mt-4"
    }, "Close"))));
  };
  window.LiveSimScreen = LiveSimScreen;
})();